import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdirectiveInject, ɵɵdefineComponent, ɵɵelementStart, ɵɵlistener, ɵɵelementEnd, ɵɵproperty, ɵɵsanitizeHtml, Component, Inject, ɵɵinject, InjectionToken, ɵɵtext, ɵɵnextContext, ɵɵclassMapInterpolate2, ɵɵadvance, ɵɵtextInterpolate, ɵɵelement, ɵɵtemplate, ɵɵstyleMapInterpolate1, ɵɵclassMapInterpolate1, ɵɵtextInterpolate1, ɵɵpropertyInterpolate, ɵɵsanitizeUrl, Input, ɵɵgetCurrentView, ɵɵrestoreView, EventEmitter, ɵɵNgOnChangesFeature, ɵɵpipe, ɵɵreference, ɵɵpipeBind1, Output, ɵɵviewQuery, ViewContainerRef, ɵɵqueryRefresh, ɵɵloadQuery, ViewChild, ElementRef, ɵɵstyleMap, ɵɵelementContainerStart, ɵɵelementContainerEnd, ɵɵProvidersFeature, ɵɵdefinePipe, Pipe, ɵɵclassMap, ɵɵclassProp, ɵɵstyleProp, ComponentFactoryResolver, ɵɵdefineDirective, Directive, ɵɵpureFunction1, ɵɵtextInterpolate2, ɵɵInheritDefinitionFeature, HostListener, ɵɵstaticViewQuery, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, ɵɵpureFunction0, ɵɵpipeBind2, HostBinding, NgZone, ɵɵpureFunction5 } from '@angular/core';
import { ActivatedRoute, Router, RouterModule, RouterLinkWithHref, RouterOutlet, RouterLink, NavigationEnd, RouterLinkActive } from '@angular/router';
import { NgIf, NgForOf, AsyncPipe, NgClass, CommonModule, DatePipe, NgStyle } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBar, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { __awaiter } from 'tslib';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TranslateService, TranslatePipe, TranslateDirective, TranslateModule } from '@ngx-translate/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { tap, catchError, startWith, debounceTime, map, pairwise, filter } from 'rxjs/operators';
import { MatIcon, MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatCardModule, MatCard, MatCardContent } from '@angular/material/card';
import { MatListModule, MatNavList, MatListItem, MatListAvatarCssMatStyler, MatListSubheaderCssMatStyler } from '@angular/material/list';
import { MatProgressBarModule, MatProgressBar } from '@angular/material/progress-bar';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatMenuModule, MatMenuTrigger, _MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AgmCoreModule } from '@agm/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, RequiredValidator, FormGroup, FormControl, ɵangular_packages_forms_forms_y, NgForm, NgModel, MaxLengthValidator, Validators, FormBuilder, SelectControlValueAccessor, ReactiveFormsModule, FormsModule, FormControlDirective } from '@angular/forms';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { MatOption, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter, MatNativeDateModule, MatLine } from '@angular/material/core';
import { MatFormField, MatLabel, MatSuffix, MatHint, MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatTabGroup, MatTab, MatTabLabel, MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCheckbox, MatCheckboxRequiredValidator, MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioGroup, MatRadioButton, MatRadioModule } from '@angular/material/radio';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { MatAutocompleteTrigger, MatAutocomplete, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatGridListModule } from '@angular/material/grid-list';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressSpinner, MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DomSanitizer, Title } from '@angular/platform-browser';
import 'ag-grid-enterprise';
import { Events } from 'ag-grid-community';
import { ViasReturnActions as ViasReturnActions$1, AlertType as AlertType$1 } from 'projects/viasng-core/src/public-api';
import { DefaultLayoutDirective, DefaultFlexDirective, DefaultLayoutAlignDirective } from '@angular/flex-layout/flex';
import { MatSidenavContainer, MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbar, MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { PerfectScrollbarDirective, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { MatDivider } from '@angular/material/divider';
import { LoadingBarService, LoadingBarModule } from '@ngx-loading-bar/core';
import { Dir } from '@angular/cdk/bidi';
import { DefaultClassDirective, DefaultStyleDirective } from '@angular/flex-layout/extended';
import { MatExpansionModule } from '@angular/material/expansion';

var CardType;
(function (CardType) {
    CardType["Warning"] = "warning";
    CardType["Info"] = "info";
    CardType["Success"] = "success";
})(CardType || (CardType = {}));

class StorageService {
    constructor() { }
    getItem(key, isPermenant) {
        let value;
        if (isPermenant === undefined) {
            isPermenant = false;
        }
        if (isPermenant) {
            value = localStorage.getItem(key);
        }
        else {
            value = sessionStorage.getItem(key);
        }
        return value;
    }
    setItem(key, value, isPermenant) {
        if (isPermenant === undefined) {
            isPermenant = false;
        }
        if (isPermenant) {
            localStorage.setItem(key, value);
        }
        else {
            sessionStorage.setItem(key, value);
        }
    }
    deleteItem(key, isPermenant) {
        if (isPermenant === undefined) {
            isPermenant = false;
        }
        if (isPermenant) {
            localStorage.removeItem(key);
        }
        else {
            sessionStorage.removeItem(key);
        }
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
StorageService.ɵprov = ɵɵdefineInjectable({ token: StorageService, factory: StorageService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

var AlertType;
(function (AlertType) {
    AlertType[AlertType["Error"] = 0] = "Error";
    AlertType[AlertType["Success"] = 1] = "Success";
    AlertType[AlertType["Warning"] = 2] = "Warning";
})(AlertType || (AlertType = {}));
class ViasAlertComponent {
    constructor(data, snackBar) {
        this.data = data;
        this.snackBar = snackBar;
    }
}
ViasAlertComponent.ɵfac = function ViasAlertComponent_Factory(t) { return new (t || ViasAlertComponent)(ɵɵdirectiveInject(MAT_SNACK_BAR_DATA), ɵɵdirectiveInject(MatSnackBar)); };
ViasAlertComponent.ɵcmp = ɵɵdefineComponent({ type: ViasAlertComponent, selectors: [["ng-component"]], decls: 1, vars: 1, consts: [[1, "data.class", 3, "innerHTML", "click"]], template: function ViasAlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵlistener("click", function ViasAlertComponent_Template_div_click_0_listener() { return ctx.snackBar.dismiss(); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("innerHTML", ctx.data.html, ɵɵsanitizeHtml);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasAlertComponent, [{
        type: Component,
        args: [{
                template: `<div class="data.class" [innerHTML]="data.html" (click)="snackBar.dismiss()"></div>`
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }, { type: MatSnackBar }]; }, null); })();
class ViasAlertService {
    constructor(snackBar, translate) {
        this.snackBar = snackBar;
        this.translate = translate;
        this.horizontalPosition = 'center';
        this.verticalPosition = 'top';
        this.snackBarAutoHide = '6000';
    }
    /**
     * Kullanim
     *
     * this.globals.viasAlert.show(
     *    errorTxt,
     *    AlertType.Error,
     *    ()=>{
     *      alert("acildi");
     *    },
     *    ()=>{
     *      alert("kapandi");
     *    }
     * );
     *
     * @param msgTxt string
     * @param type AlertType
     * @param afterOpenedFunc function
     * @param afterDismissedFunc function
     */
    show(msgTxt, type = AlertType.Success, afterOpenedFunc = () => { }, afterDismissedFunc = () => { }) {
        let color = 'green-snackbar';
        switch (type) {
            case AlertType.Error:
                color = 'red-snackbar';
                break;
            case AlertType.Warning:
                color = 'yellow-snackbar';
                break;
            default:
            case AlertType.Success:
                color = 'green-snackbar';
                break;
        }
        this.snackBarConfig = new MatSnackBarConfig();
        this.snackBarConfig.horizontalPosition = this.horizontalPosition;
        this.snackBarConfig.verticalPosition = this.verticalPosition;
        this.snackBarConfig.duration = parseInt(this.snackBarAutoHide, 0);
        this.snackBarConfig.panelClass = color;
        // this.snackBarRef = this.snackBar.open(msgTxt, 'X', this.snackBarConfig);
        this.translate.get(msgTxt).subscribe((translated) => {
            msgTxt = translated;
        });
        this.snackBarConfig.data = { html: msgTxt, class: color };
        this.snackBarRef = this.snackBar.openFromComponent(ViasAlertComponent, this.snackBarConfig);
        this.snackBarRef.afterDismissed().subscribe(afterDismissedFunc);
        this.snackBarRef.afterOpened().subscribe(afterOpenedFunc);
    }
}
ViasAlertService.ɵfac = function ViasAlertService_Factory(t) { return new (t || ViasAlertService)(ɵɵinject(MatSnackBar), ɵɵinject(TranslateService)); };
ViasAlertService.ɵprov = ɵɵdefineInjectable({ token: ViasAlertService, factory: ViasAlertService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasAlertService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MatSnackBar }, { type: TranslateService }]; }, null); })();

class ViasDialogService {
    constructor(dialog) {
        this.dialog = dialog;
        this.config = {
            disableClose: false,
            hasBackdrop: true,
        };
    }
    setConfig(conf = {}) {
        for (const x in conf) {
            this.config[x] = conf[x];
        }
    }
    setComponent(openedPage) {
        this.openedPage = openedPage;
    }
    open() {
        return this.dialog.open(this.openedPage, this.config);
    }
}
ViasDialogService.ɵfac = function ViasDialogService_Factory(t) { return new (t || ViasDialogService)(ɵɵinject(MatDialog)); };
ViasDialogService.ɵprov = ɵɵdefineInjectable({ token: ViasDialogService, factory: ViasDialogService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: MatDialog }]; }, null); })();

class ViasUserPrefService {
    constructor(viasService) {
        this.viasService = viasService;
    }
    getPref(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.viasService.send(10, 0, {
                user_id: userId
            }).then(response => {
                let userPrefs = { userId };
                if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                    console.log('error user pref');
                }
                else if (response.data) {
                    if (response.data['prefs'] !== undefined) {
                        const r = response.data['prefs'];
                        userPrefs = JSON.parse(r.prefs);
                    }
                }
                return userPrefs;
            });
        });
    }
    setPref(userPrefs) {
        this.viasService.send(10, 2, {
            user_id: userPrefs.userId,
            prefs: JSON.stringify(userPrefs)
        });
    }
    resetPref(userId) {
        this.viasService.send(10, 4, {
            user_id: userId
        });
    }
}
ViasUserPrefService.ɵfac = function ViasUserPrefService_Factory(t) { return new (t || ViasUserPrefService)(ɵɵinject(ViasConnectionService)); };
ViasUserPrefService.ɵprov = ɵɵdefineInjectable({ token: ViasUserPrefService, factory: ViasUserPrefService.ɵfac, providedIn: 'any' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasUserPrefService, [{
        type: Injectable,
        args: [{
                providedIn: 'any'
            }]
    }], function () { return [{ type: ViasConnectionService }]; }, null); })();

const MAIN_SERVER_URL = new InjectionToken('MainServerURL', {
    providedIn: 'root',
    factory: () => ''
});
const PRINT_URL = new InjectionToken('PrintURL', {
    providedIn: 'root',
    factory: () => ''
});
const SERVER_URL = new InjectionToken('ServerURL', {
    providedIn: 'root',
    factory: () => ''
});
const CONTRACTOR_SERVER_URL = new InjectionToken('ContractorServerURL', {
    providedIn: 'root',
    factory: () => ''
});
class GlobalsService {
    constructor(mainServerURL, serverURL, contractorServerURL, printURL, storage, viasAlert, viasDialog, userPrefService, translate) {
        this.mainServerURL = mainServerURL;
        this.serverURL = serverURL;
        this.contractorServerURL = contractorServerURL;
        this.printURL = printURL;
        this.storage = storage;
        this.viasAlert = viasAlert;
        this.viasDialog = viasDialog;
        this.userPrefService = userPrefService;
        this.translate = translate;
        // App Title
        this.appTitle = 'viaMarine';
        this.selectedFirmId = 2;
        this.defaultLocale = 'tr_TR';
        this.langId = 1;
        this.prefId = '';
    }
    get userPref() {
        let t = JSON.parse(this.storage.getItem('userPref'));
        if (t.userId !== this.userId) {
            t = { userId: this.userId };
        }
        this.userPref = t;
        return t;
    }
    set userPref(t) {
        this.storage.setItem('userPref', JSON.stringify(t));
    }
    get langLocale() {
        const t = this.storage.getItem('langLocale') || this.defaultLocale;
        return t;
    }
    set langLocale(t) {
        this.storage.setItem('langLocale', t);
    }
    get numLocale() {
        const t = this.storage.getItem('numLocale') || this.defaultLocale;
        return t;
    }
    set numLocale(t) {
        this.storage.setItem('numLocale', t);
    }
    get pagePermissions() {
        return JSON.parse(this.storage.getItem('permission'));
    }
    set pagePermissions(t) {
        this.storage.setItem('permission', JSON.stringify(t));
    }
    // contractor id = contractor kullanici id
    get contractorUserId() {
        return parseInt(this.storage.getItem('contractorUserId'), 10);
    }
    set contractorUserId(t) {
        this.storage.setItem('contractorUserId', t);
    }
    get contractorName() {
        return this.storage.getItem('contractorName');
    }
    set contractorName(t) {
        this.storage.setItem('contractorName', t);
    }
    get contractorId() {
        return this.storage.getItem('contractorId');
    }
    set contractorId(t) {
        this.storage.setItem('contractorId', t);
    }
    // kullanici id
    get userId() {
        return parseInt(this.storage.getItem('userId'), 10);
    }
    set userId(t) {
        this.storage.setItem('userId', t);
    }
    // kullanici adi permanent !!!
    get rememberLoginName() {
        return this.storage.getItem('rememberLoginName', true);
    }
    set rememberLoginName(t) {
        this.storage.setItem('rememberLoginName', t, true);
    }
    // kullanici ad soyad
    get userNameSurname() {
        return this.storage.getItem('userNameSurname');
    }
    set userNameSurname(t) {
        this.storage.setItem('userNameSurname', t);
    }
    // userSectionId: number;
    get userSectionId() {
        return parseInt(this.storage.getItem('userSectionId'), 10);
    }
    set userSectionId(t) {
        this.storage.setItem('userSectionId', t);
    }
    //  userProjectType: number;
    get userProjectType() {
        return parseInt(this.storage.getItem('userProjectType'), 10);
    }
    set userProjectType(t) {
        this.storage.setItem('userProjectType', t);
    }
    //  userDepartmentId: number;
    get userDepartmentId() {
        return parseInt(this.storage.getItem('userDepartmentId'), 10);
    }
    set userDepartmentId(t) {
        this.storage.setItem('userDepartmentId', t);
    }
    // userDefaultModuleId: number;
    get userDefaultModuleId() {
        return parseInt(this.storage.getItem('userDefaultModuleId'), 10);
    }
    set userDefaultModuleId(t) {
        this.storage.setItem('userDefaultModuleId', t);
    }
    // userDefaultPageId: number;
    get userDefaultPageId() {
        return parseInt(this.storage.getItem('userDefaultPageId'), 10);
    }
    set userDefaultPageId(t) {
        this.storage.setItem('userDefaultPageId', t);
    }
    // userDefaultActionId: number;
    get userDefaultActionId() {
        return parseInt(this.storage.getItem('userDefaultActionId'), 10);
    }
    set userDefaultActionId(t) {
        this.storage.setItem('userDefaultActionId', t);
    }
    getAppTitle(moduleName) {
        return this.appTitle + (moduleName.length > 0 ? ' - ' + moduleName : '');
    }
    isLoggedIn() {
        return this.userId > 0 ? true : false;
    }
    isContractorLoggedIn() {
        return this.contractorUserId > 0 ? true : false;
    }
    logout() {
        sessionStorage.clear();
        this.userId = 0;
    }
    handleErrors(errors) {
        let errorTxt = '';
        console.log('__++__', errors);
        errors.forEach(e => {
            this.translate.get('errorTexts.' + e).subscribe((translated) => {
                if (translated === 'errorTexts.' + e) {
                    translated = e;
                }
                errorTxt += '<li>' + translated + '</li>';
            });
        });
        console.log('__++__', errorTxt);
        if (errorTxt.length > 0) {
            errorTxt = '<ul>' + errorTxt + '</ul>';
            this.viasAlert.show(errorTxt, AlertType.Error);
        }
    }
    openDialog(openedPage, config = {}) {
        return this.viasDialog.open();
    }
    openPrintView(url, hasPrintBtn = true) {
        let newUrl = '/#/framework/print-view?hpb=';
        newUrl += hasPrintBtn ? '1' : '0';
        newUrl += '&url=';
        newUrl += encodeURIComponent(url);
        window.open(newUrl, '_blank');
        // bu da ornek olarak kalsin.
        // baska bir yontem
        //
        // const navigationExtras: NavigationExtras = {
        //   queryParams: {
        //     url
        //   }
        // };
        // this.route.navigateByUrl('/framework/print-view',  { state: { url }});
    }
    getTranslate(str) {
        let restrng = '';
        this.translate.get(str).subscribe((translated) => {
            restrng = translated;
        });
        return restrng;
    }
    numberFormatter(data, digit) {
        let fractionDigits = 2;
        if (digit !== undefined) {
            fractionDigits = digit;
        }
        let val = data;
        if (isNaN(val)) {
            val = this.parseLocaleNumber(data, this.numLocale);
        }
        return Intl.NumberFormat(this.numLocale, { maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits }).format(data);
    }
    parseLocaleNumber(stringNumber, locale) {
        const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
        return parseFloat(stringNumber
            .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
            .replace(new RegExp('\\' + decimalSeparator), '.'));
    }
    requestDataFormatter(data) {
        let str = '';
        data.forEach(e => {
            str += '"' + e.id + '":' + JSON.stringify(e) + ',';
        });
        if (str.length > 0) {
            str = str.substring(0, str.length - 1);
            str = '{' + str + '}';
            str = JSON.parse(str);
        }
        return str;
    }
}
GlobalsService.ɵfac = function GlobalsService_Factory(t) { return new (t || GlobalsService)(ɵɵinject(MAIN_SERVER_URL), ɵɵinject(SERVER_URL), ɵɵinject(CONTRACTOR_SERVER_URL), ɵɵinject(PRINT_URL), ɵɵinject(StorageService), ɵɵinject(ViasAlertService), ɵɵinject(ViasDialogService), ɵɵinject(ViasUserPrefService), ɵɵinject(TranslateService)); };
GlobalsService.ɵprov = ɵɵdefineInjectable({ token: GlobalsService, factory: GlobalsService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(GlobalsService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAIN_SERVER_URL]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [SERVER_URL]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [CONTRACTOR_SERVER_URL]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PRINT_URL]
            }] }, { type: StorageService }, { type: ViasAlertService }, { type: ViasDialogService }, { type: ViasUserPrefService }, { type: TranslateService }]; }, null); })();

var ViasReturnActions;
(function (ViasReturnActions) {
    ViasReturnActions["Close"] = "close";
    ViasReturnActions["Success"] = "success";
    ViasReturnActions["RefreshSelf"] = "refresh_self";
    ViasReturnActions["RefreshParent"] = "refresh_parent";
    ViasReturnActions["RefreshAndClose"] = "refreshAndClose";
    ViasReturnActions["RefreshWorkDone"] = "refresh_work_done";
    ViasReturnActions["RefreshPPL"] = "refresh_ppl";
    ViasReturnActions["RefreshFPL"] = "refresh_fpl";
})(ViasReturnActions || (ViasReturnActions = {}));
class ViasConnectionService {
    constructor(serverUrl, http) {
        this.serverUrl = serverUrl;
        this.http = http;
        this.progressSpinnerRun = false;
    }
    send(pid, aid, data, url = this.serverUrl) {
        console.log(url);
        console.log(JSON.stringify(data));
        this.progressSpinnerRun = true;
        return new Promise((resolve, reject) => {
            let debugStr = 'json= 1&';
            debugStr += 'pid=' + pid.toString() + '&';
            debugStr += 'aid=' + aid.toString() + '&';
            debugStr += 'data=' + JSON.stringify(data);
            const params = new FormData();
            params.append('json', '1');
            params.append('pid', pid.toString());
            params.append('aid', aid.toString());
            params.append('data', JSON.stringify(data));
            console.log(params);
            this.http.post(url, params, { withCredentials: true })
                .toPromise()
                .then(res => {
                this.progressSpinnerRun = false;
                resolve(res);
            }, err => {
                this.progressSpinnerRun = false;
                reject(err);
            })
                .catch(err => {
                this.progressSpinnerRun = false;
                reject(err);
            });
        });
    }
    uploadFile(pid, aid, data, file, fileName = 'fileData', relatedPid, relatedId, relatedId2, removeOldFiles) {
        console.log(file);
        console.log(JSON.stringify(data));
        this.progressSpinnerRun = true;
        //   this.serverUrl = 'https://file.io';
        const params = new FormData();
        params.append('json', '1');
        params.append('pid', pid.toString());
        params.append('aid', aid.toString());
        params.append('data', JSON.stringify(data));
        params.append('related_pid', relatedPid);
        params.append('related_id', relatedId);
        params.append('related_id2', relatedId2);
        params.append('remove_old_files', removeOldFiles); // 1 eski dosyayı siler
        // files.forEach(file => {
        params.append(fileName, file, file.name);
        // });
        const headers = new HttpHeaders();
        headers.set('Content-Type', 'multipart/form-data');
        return this.http.post(this.serverUrl, params, {
            withCredentials: true,
            reportProgress: true,
            observe: 'events',
            headers
        })
            .pipe(tap(_ => this.progressSpinnerRun = false), catchError(val => {
            this.progressSpinnerRun = false;
            console.log(val);
            return val;
        }));
    }
    downloadFile(pid, aid, data, fileName = '', url = this.serverUrl) {
        const params = new FormData();
        params.append('json', '1');
        params.append('pid', pid.toString());
        params.append('aid', aid.toString());
        params.append('data', JSON.stringify(data));
        console.log(params);
        this.progressSpinnerRun = true;
        if (fileName === '') {
            fileName = new Date().toLocaleDateString();
        }
        this.http.post(this.serverUrl, params, { withCredentials: true, responseType: 'blob' })
            .toPromise()
            .then(res => {
            this.progressSpinnerRun = false;
            var newFile = document.createElement("a");
            newFile.href = URL.createObjectURL(res);
            newFile.download = fileName;
            // start download
            newFile.click();
        }).catch(err => {
            this.progressSpinnerRun = false;
        });
    }
}
ViasConnectionService.ɵfac = function ViasConnectionService_Factory(t) { return new (t || ViasConnectionService)(ɵɵinject(SERVER_URL), ɵɵinject(HttpClient)); };
ViasConnectionService.ɵprov = ɵɵdefineInjectable({ token: ViasConnectionService, factory: ViasConnectionService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasConnectionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [SERVER_URL]
            }] }, { type: HttpClient }]; }, null); })();

class DashboardService {
    constructor(viasService) {
        this.viasService = viasService;
    }
    getCards(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            let cards = [];
            return yield this.viasService.send(10, 10, {})
                .then(response => {
                if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                    console.log('error user pref');
                }
                else if (response.data) {
                    if (response.data['cards'] !== undefined) {
                        cards = response.data['cards'];
                    }
                }
                return cards;
            });
        });
    }
}
DashboardService.ɵfac = function DashboardService_Factory(t) { return new (t || DashboardService)(ɵɵinject(ViasConnectionService)); };
DashboardService.ɵprov = ɵɵdefineInjectable({ token: DashboardService, factory: DashboardService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DashboardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ViasConnectionService }]; }, null); })();

function InfoCardComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵclassMapInterpolate2("badge badge-subtle-", ctx_r0.card.type, " rounded-pill ms-2 ", ctx_r0.card.summaryIcon ? "material-icons" : "", "");
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.card.summary);
} }
function InfoCardComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 7);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r1.card.icon);
} }
class InfoCardComponent {
    constructor() { }
    ngOnInit() {
    }
}
InfoCardComponent.ɵfac = function InfoCardComponent_Factory(t) { return new (t || InfoCardComponent)(); };
InfoCardComponent.ɵcmp = ɵɵdefineComponent({ type: InfoCardComponent, selectors: [["vias-info-card"]], inputs: { card: "card" }, decls: 13, vars: 12, consts: [[1, "card", "overflow-hidden", 2, "min-width", "12rem"], [1, "bg-holder", "bg-card"], [1, "card-body", "position-relative"], [1, "fw-semi-bold"], [3, "class", 4, "ngIf"], ["class", "ms-1 material-icons", 4, "ngIf"], [1, "fw-semi-bold", "fs-10", "text-nowrap", 3, "href"], [1, "ms-1", "material-icons"]], template: function InfoCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "h6", 3);
        ɵɵtext(4);
        ɵɵtemplate(5, InfoCardComponent_span_5_Template, 2, 5, "span", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "div");
        ɵɵtext(7);
        ɵɵtemplate(8, InfoCardComponent_span_8_Template, 2, 1, "span", 5);
        ɵɵelementEnd();
        ɵɵelementStart(9, "a", 6);
        ɵɵtext(10);
        ɵɵelementStart(11, "span", 7);
        ɵɵtext(12, "chevron_right");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵstyleMapInterpolate1("background-image:url('../assets/images/material/corner-", ctx.card.type, ".png');");
        ɵɵadvance(3);
        ɵɵtextInterpolate(ctx.card.title);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.card.summary.length > 0);
        ɵɵadvance(1);
        ɵɵclassMapInterpolate1("display-4 fs-5 mb-2 fw-normal font-sans-serif text-", ctx.card.type, "");
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.card.count, "\u00A0\u00A0 ");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.card.icon != "");
        ɵɵadvance(1);
        ɵɵpropertyInterpolate("href", ctx.card.link, ɵɵsanitizeUrl);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.card.link_name, " ");
    } }, directives: [NgIf], styles: [".card[_ngcontent-%COMP%]{--falcon-card-bg:#fff;--falcon-card-border-color:rgba(($falcon-emphasis-color-rgb)),0.125;--falcon-card-border-radius:0.375rem;--falcon-card-border-width:0px;--falcon-card-box-shadow:0 7px 14px 0 rgba(65,69,88,0.1),0 3px 6px 0 rgba(0,0,0,0.07);--falcon-card-cap-bg:transparent;--falcon-card-cap-padding-x:1.25rem;--falcon-card-cap-padding-y:1rem;--falcon-card-group-margin:1rem;--falcon-card-img-overlay-padding:1rem;--falcon-card-inner-border-radius:0.375rem;--falcon-card-spacer-x:1.25rem;--falcon-card-spacer-y:1.25rem;--falcon-card-title-color:$falcon-secondary-color;--falcon-card-title-spacer-y:0.5rem;background-clip:border-box;background-color:var(--falcon-card-bg);border:var(--falcon-card-border-width) solid var(--falcon-card-border-color);border-radius:var(--falcon-card-border-radius);box-shadow:var(--falcon-card-box-shadow);display:flex;flex-direction:column;min-width:0;position:relative;word-wrap:break-word}.card[_ngcontent-%COMP%] > hr[_ngcontent-%COMP%]{margin-left:0;margin-right:0}.card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%]{border-bottom:inherit;border-top:inherit}.card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%]:first-child{border-top-left-radius:var(--falcon-card-inner-border-radius);border-top-right-radius:var(--falcon-card-inner-border-radius);border-top-width:0}.card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%]:last-child{border-bottom-left-radius:var(--falcon-card-inner-border-radius);border-bottom-right-radius:var(--falcon-card-inner-border-radius);border-bottom-width:0}.card[_ngcontent-%COMP%] > .card-header[_ngcontent-%COMP%] + .list-group[_ngcontent-%COMP%], .card[_ngcontent-%COMP%] > .list-group[_ngcontent-%COMP%] + .card-footer[_ngcontent-%COMP%]{border-top:0}.card-body[_ngcontent-%COMP%]{flex:1 1 auto;padding:var(--falcon-card-spacer-y) var(--falcon-card-spacer-x)}.card-title[_ngcontent-%COMP%]{color:var(--falcon-card-title-color);margin-bottom:var(--falcon-card-title-spacer-y)}.card-subtitle[_ngcontent-%COMP%]{color:var(--falcon-card-subtitle-color);margin-top:calc(-0.5*var(--falcon-card-title-spacer-y))}.card-subtitle[_ngcontent-%COMP%], .card-text[_ngcontent-%COMP%]:last-child{margin-bottom:0}.card-link[_ngcontent-%COMP%]:hover{text-decoration:none}.card-link[_ngcontent-%COMP%] + .card-link[_ngcontent-%COMP%]{margin-left:var(--falcon-card-spacer-x)}.card-header[_ngcontent-%COMP%]{background-color:var(--falcon-card-cap-bg);border-bottom:var(--falcon-card-border-width) solid var(--falcon-card-border-color);margin-bottom:0;padding:var(--falcon-card-cap-padding-y) var(--falcon-card-cap-padding-x)}.card-header[_ngcontent-%COMP%]:first-child{border-radius:var(--falcon-card-inner-border-radius) var(--falcon-card-inner-border-radius) 0 0}.card-footer[_ngcontent-%COMP%]{background-color:var(--falcon-card-cap-bg);border-top:var(--falcon-card-border-width) solid var(--falcon-card-border-color);padding:var(--falcon-card-cap-padding-y) var(--falcon-card-cap-padding-x)}.card-footer[_ngcontent-%COMP%]:last-child{border-radius:0 0 var(--falcon-card-inner-border-radius) var(--falcon-card-inner-border-radius)}.card-header-tabs[_ngcontent-%COMP%]{border-bottom:0;margin-bottom:calc(-1*var(--falcon-card-cap-padding-y));margin-left:calc(-0.5*var(--falcon-card-cap-padding-x));margin-right:calc(-0.5*var(--falcon-card-cap-padding-x))}.card-header-tabs[_ngcontent-%COMP%]   .nav-link.active[_ngcontent-%COMP%]{background-color:--falcon-card-bg;border-bottom-color:--falcon-card-bg}.card-header-pills[_ngcontent-%COMP%]{margin-left:calc(-0.5*var(--falcon-card-cap-padding-x));margin-right:calc(-0.5*var(--falcon-card-cap-padding-x))}.card-img-overlay[_ngcontent-%COMP%]{border-radius:var(--falcon-card-inner-border-radius);bottom:0;left:0;padding:var(--falcon-card-img-overlay-padding);position:absolute;right:0;top:0}.card-img[_ngcontent-%COMP%], .card-img-bottom[_ngcontent-%COMP%], .card-img-top[_ngcontent-%COMP%]{width:100%}.card-img[_ngcontent-%COMP%], .card-img-top[_ngcontent-%COMP%]{border-top-left-radius:var(--falcon-card-inner-border-radius);border-top-right-radius:var(--falcon-card-inner-border-radius)}.card-img[_ngcontent-%COMP%], .card-img-bottom[_ngcontent-%COMP%]{border-bottom-left-radius:var(--falcon-card-inner-border-radius);border-bottom-right-radius:var(--falcon-card-inner-border-radius)}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]{margin-bottom:var(--falcon-card-group-margin)}@media (min-width:576px){.card-group[_ngcontent-%COMP%]{display:flex;flex-flow:row wrap}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]{flex:1 0 0%;margin-bottom:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%] + .card[_ngcontent-%COMP%]{border-left:0;margin-left:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-header[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-img-top[_ngcontent-%COMP%]{border-top-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-footer[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:last-child)   .card-img-bottom[_ngcontent-%COMP%]{border-bottom-right-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-header[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-img-top[_ngcontent-%COMP%]{border-top-left-radius:0}.card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-footer[_ngcontent-%COMP%], .card-group[_ngcontent-%COMP%] > .card[_ngcontent-%COMP%]:not(:first-child)   .card-img-bottom[_ngcontent-%COMP%]{border-bottom-left-radius:0}}.overflow-hidden[_ngcontent-%COMP%]{overflow:hidden!important}.position-relative[_ngcontent-%COMP%]{position:relative!important}.rounded-pill[_ngcontent-%COMP%]{border-radius:50rem!important}.ms-2[_ngcontent-%COMP%]{margin-left:.5rem!important}.display-4[_ngcontent-%COMP%]{font-size:calc(1.37383rem + 1.48598vw);font-weight:900;line-height:1}@media (min-width:1200px){.display-4[_ngcontent-%COMP%]{font-size:2.48832rem}}.col-sm-6[_ngcontent-%COMP%]{flex:0 0 auto;width:50%}.h6[_ngcontent-%COMP%], h6[_ngcontent-%COMP%]{font-size:.8333333333rem}.col-md-4[_ngcontent-%COMP%]{flex:0 0 auto;width:33.33333333%!important}.fs-5[_ngcontent-%COMP%]{font-size:2.0736rem!important}a[_ngcontent-%COMP%]{color:#2c7be5!important;text-decoration:none}a[_ngcontent-%COMP%]   .material-icons[_ngcontent-%COMP%]{font-size:18px;margin-top:-2px;vertical-align:middle}a[_ngcontent-%COMP%]:hover{--falcon-link-color-rgb:($falcon-link-hover-color-rgb);text-decoration:underline}a[_ngcontent-%COMP%]:not([href]):not([class]), a[_ngcontent-%COMP%]:not([href]):not([class]):hover{color:inherit;text-decoration:none}.fw-semi-bold[_ngcontent-%COMP%]{font-weight:600!important}.text-nowrap[_ngcontent-%COMP%]{white-space:nowrap!important}.fs-10[_ngcontent-%COMP%]{font-size:.8333333333rem!important}.mb-2[_ngcontent-%COMP%]{margin-bottom:.5rem!important}.mb-3[_ngcontent-%COMP%]{margin-bottom:1rem!important}.fw-normal[_ngcontent-%COMP%]{font-weight:400!important}.font-sans-serif[_ngcontent-%COMP%]{font-family:Poppins,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol!important}.text-info[_ngcontent-%COMP%]{color:rgba(var(39,188,253)) 1!important}.bg-card[_ngcontent-%COMP%]{background-position:100%!important;background-size:contain!important;border-bottom-right-radius:.375rem!important;border-top-right-radius:.375rem!important}.bg-holder[_ngcontent-%COMP%]{-webkit-backface-visibility:hidden;backface-visibility:hidden;background-position:50%;background-repeat:no-repeat;background-size:cover;left:0;min-height:100%;overflow:hidden;position:absolute;top:0;width:100%;will-change:transform,opacity,filter;z-index:0}.badge[_ngcontent-%COMP%]{border-radius:.25rem;color:#fff;display:inline-block;font-size:.75em;font-weight:600;line-height:1;padding:.355555em .711111em;text-align:center;vertical-align:baseline;white-space:nowrap}.badge-subtle-info[_ngcontent-%COMP%]{background-color:#d8f3ff;color:#197aa4}.badge-subtle-info[href][_ngcontent-%COMP%]:focus, .badge-subtle-info[href][_ngcontent-%COMP%]:hover{background-color:#d8f3ff;color:#197aa4;text-decoration:none}.badge-subtle-success[_ngcontent-%COMP%]{background-color:#d9f8eb;color:#00894f}.badge-subtle-success[href][_ngcontent-%COMP%]:focus, .badge-subtle-success[href][_ngcontent-%COMP%]:hover{background-color:#d9f8eb;color:#00894f;text-decoration:none}.badge-subtle-warning[_ngcontent-%COMP%]{background-color:#fde6d8;color:#ac5a2b}.badge-subtle-warning[href][_ngcontent-%COMP%]:focus, .badge-subtle-warning[href][_ngcontent-%COMP%]:hover{background-color:#fde6d8;color:#ac5a2b;text-decoration:none}.badge-subtle-danger[_ngcontent-%COMP%]{background-color:#fbdbe1;color:#b82c46}.badge-subtle-danger[href][_ngcontent-%COMP%]:focus, .badge-subtle-danger[href][_ngcontent-%COMP%]:hover{background-color:#fbdbe1;color:#b82c46;text-decoration:none}.badge-subtle-light[_ngcontent-%COMP%]{background-color:#fdfefe;color:#646465}.badge-subtle-light[href][_ngcontent-%COMP%]:focus, .badge-subtle-light[href][_ngcontent-%COMP%]:hover{background-color:#fdfefe;color:#646465;text-decoration:none}.badge-subtle-dark[_ngcontent-%COMP%]{background-color:#08101b;color:#91979e}.badge-subtle-dark[href][_ngcontent-%COMP%]:focus, .badge-subtle-dark[href][_ngcontent-%COMP%]:hover{background-color:#08101b;color:#91979e;text-decoration:none}.row[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;margin-left:-1rem;margin-right:-1rem;width:95%}.row[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{flex-shrink:0;margin-top:0;max-width:95%;padding-left:1rem;padding-right:1rem;width:95%}.text-secondary[_ngcontent-%COMP%]{--falcon-text-opacity:1;color:rgba(116,129,148,var(--falcon-text-opacity))!important}.text-success[_ngcontent-%COMP%]{--falcon-text-opacity:1;color:rgba(0,210,122,var(--falcon-text-opacity))!important}.text-info[_ngcontent-%COMP%]{--falcon-text-opacity:1;color:rgba(39,188,253,var(--falcon-text-opacity))!important}.text-warning[_ngcontent-%COMP%]{--falcon-text-opacity:1;color:rgba(245,128,62,var(--falcon-text-opacity))!important}.text-danger[_ngcontent-%COMP%]{--falcon-text-opacity:1;color:rgba(230,55,87,var(--falcon-text-opacity))!important}.text-light[_ngcontent-%COMP%]{color:rgba(249,250,253,var(--falcon-text-opacity))!important}.text-dark[_ngcontent-%COMP%], .text-light[_ngcontent-%COMP%]{--falcon-text-opacity:1}.text-dark[_ngcontent-%COMP%]{color:rgba(11,23,39,var(--falcon-text-opacity))!important}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InfoCardComponent, [{
        type: Component,
        args: [{
                selector: 'vias-info-card',
                templateUrl: './info-card.component.html',
                styleUrls: ['./info-card.component.scss']
            }]
    }], function () { return []; }, { card: [{
            type: Input
        }] }); })();

function DashboardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 2);
    ɵɵelement(1, "vias-info-card", 3);
    ɵɵelementEnd();
} if (rf & 2) {
    const card_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("card", card_r1);
} }
class DashboardComponent {
    constructor(snackBar, dashboardService) {
        this.snackBar = snackBar;
        this.dashboardService = dashboardService;
        this.cards = [];
        this.horizontalPosition = 'right';
        this.verticalPosition = 'bottom';
        const config = new MatSnackBarConfig();
        config.verticalPosition = this.verticalPosition;
        config.horizontalPosition = this.horizontalPosition;
        config.duration = 5000;
        this.snackBar.open('viaMarine NG, Yeni Jenerasyon Yönetim Sistemi', '', config);
    }
    ngOnInit() {
        this.cards = [];
        this.dashboardService.getCards().then(cards => {
            this.cards = cards.map(card => ({
                type: card.type === 'success' ? CardType.Success :
                    card.type === 'warning' ? CardType.Warning :
                        CardType.Info,
                title: card.title,
                summary: card.summary,
                summaryIcon: card.summaryIcon,
                count: card.count,
                link_name: card.link_name,
                link: card.link,
                icon: card.icon
            }));
        });
    }
}
DashboardComponent.ɵfac = function DashboardComponent_Factory(t) { return new (t || DashboardComponent)(ɵɵdirectiveInject(MatSnackBar), ɵɵdirectiveInject(DashboardService)); };
DashboardComponent.ɵcmp = ɵɵdefineComponent({ type: DashboardComponent, selectors: [["vias-dashboard"]], decls: 2, vars: 1, consts: [[1, "dashboard-container"], ["class", "card-wrapper", 4, "ngFor", "ngForOf"], [1, "card-wrapper"], [3, "card"]], template: function DashboardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, DashboardComponent_div_1_Template, 2, 1, "div", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.cards);
    } }, directives: [NgForOf, InfoCardComponent], styles: [".dashboard-container[_ngcontent-%COMP%]{display:-ms-grid;display:grid;gap:15px;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));justify-content:center}.card-wrapper[_ngcontent-%COMP%]{flex:1 1 300px;max-width:400px}.example-list[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap;gap:15px;max-width:100%;min-height:60px;overflow:hidden;padding:15px;width:505px}.example-box[_ngcontent-%COMP%], .example-list[_ngcontent-%COMP%]{border:1px solid #ccc;border-radius:4px}.example-box[_ngcontent-%COMP%]{background:#fff;box-sizing:border-box;color:rgba(0,0,0,.87);cursor:move;display:inline-block;font-size:14px;min-width:115px;padding:20px 10px;text-align:center}.cdk-drag-preview[_ngcontent-%COMP%]{border-radius:4px;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);box-sizing:border-box}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DashboardComponent, [{
        type: Component,
        args: [{
                selector: 'vias-dashboard',
                templateUrl: './dashboard.component.html',
                styleUrls: ['./dashboard.component.scss']
            }]
    }], function () { return [{ type: MatSnackBar }, { type: DashboardService }]; }, null); })();

var FieldTypes;
(function (FieldTypes) {
    FieldTypes["AutoComplete"] = "autocomplete";
    FieldTypes["Button"] = "button";
    FieldTypes["Submit"] = "submit";
    FieldTypes["CheckBox"] = "checkbox";
    FieldTypes["DataGrid"] = "datagrid";
    FieldTypes["Table"] = "table";
    FieldTypes["DatePicker"] = "datepicker";
    FieldTypes["DateCombo"] = "datepicker";
    FieldTypes["ComboBox"] = "dropdown";
    FieldTypes["DropDown"] = "dropdown";
    FieldTypes["File"] = "file";
    FieldTypes["Img"] = "img";
    FieldTypes["Input"] = "text";
    FieldTypes["Text"] = "text";
    FieldTypes["Email"] = "email";
    FieldTypes["Number"] = "number";
    FieldTypes["Time"] = "time";
    FieldTypes["Password"] = "password";
    FieldTypes["Radio"] = "radio";
    FieldTypes["Currency"] = "currency";
    FieldTypes["Unit"] = "unit";
    FieldTypes["Id"] = "id";
    FieldTypes["PageViewer"] = "pageviwer";
})(FieldTypes || (FieldTypes = {}));

function AutocompleteComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 6, 7);
    ɵɵlistener("click", function AutocompleteComponent_button_4_Template_button_click_0_listener($event) { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(); return ctx_r4.onClick($event); });
    ɵɵelementStart(2, "mat-icon");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r0.item.icon_type);
} }
function AutocompleteComponent_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-option", 8);
    ɵɵlistener("click", function AutocompleteComponent_mat_option_7_Template_mat_option_click_0_listener() { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(); return ctx_r7.matInput.value = ""; });
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const opt_r6 = ctx.$implicit;
    ɵɵproperty("value", opt_r6.data);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", opt_r6.label, " ");
} }
class AutocompleteComponent {
    constructor() {
        this.onclick = new EventEmitter();
        this.onchange = new EventEmitter();
        this.valueMapper = (key) => {
            const selection = this.item.options.find(e => e.data === key);
            if (selection) {
                return selection.label;
            }
        };
    }
    ngOnInit() {
        this.myControl = this.form.get(this.item.name);
        this.filteredOptions = this.myControl.valueChanges.pipe(startWith(''), debounceTime(300), map(value => {
            if (typeof value === 'string' && value.length < 2)
                return [];
            return this._filter(value);
        }));
    }
    onClick($event) {
        this.onclick.emit($event);
    }
    ngOnChanges(changes) {
        // console.log('+___+', changes);
        // this.myControl = this.form.get(this.item.name) as FormControl;
        // this.filteredOptions = this.myControl.valueChanges.pipe(
        //   startWith(''),
        //   map(value => value ? this._filter(value) : this.item.options)
        // );
        // if (this.item.value !== undefined) {
        //   this.myControl.setValue(this.item.value);
        // }
    }
    onSelected($event) {
        // console.log('+___+', $event);
        if ($event.option.value !== undefined && $event.option.value !== null && $event.option.value.toString().length > 0) {
            this.onchange.emit($event.option.value);
        }
    }
    handleEmptyInput($event) {
        this.onchange.emit();
    }
    _filter(value) {
        const filterValue = typeof (value) === 'string' ? value.toLocaleLowerCase() : '';
        return this.item.options.filter(option => option.label.toLocaleLowerCase().indexOf(filterValue.toLocaleLowerCase()) > -1);
    }
}
AutocompleteComponent.ɵfac = function AutocompleteComponent_Factory(t) { return new (t || AutocompleteComponent)(); };
AutocompleteComponent.ɵcmp = ɵɵdefineComponent({ type: AutocompleteComponent, selectors: [["vias-autocomplete"]], inputs: { item: "item", form: "form" }, outputs: { onclick: "onclick", onchange: "onchange" }, features: [ɵɵNgOnChangesFeature], decls: 9, vars: 11, consts: [["appearance", "outline", 2, "width", "100%", 3, "formGroup"], ["matInput", "", 3, "placeholder", "matAutocomplete", "formControlName", "required", "change"], ["matSuffix", "", "color", "primary", "mat-icon-button", "", "type", "button", 3, "click", 4, "ngIf"], ["autoActiveFirstOption", "false", 3, "displayWith", "optionSelected"], ["auto", "matAutocomplete"], [3, "value", "click", 4, "ngFor", "ngForOf"], ["matSuffix", "", "color", "primary", "mat-icon-button", "", "type", "button", 3, "click"], ["iconButton", ""], [3, "value", "click"]], template: function AutocompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "input", 1);
        ɵɵlistener("change", function AutocompleteComponent_Template_input_change_3_listener($event) { return ctx.handleEmptyInput($event); });
        ɵɵelementEnd();
        ɵɵtemplate(4, AutocompleteComponent_button_4_Template, 4, 1, "button", 2);
        ɵɵelementStart(5, "mat-autocomplete", 3, 4);
        ɵɵlistener("optionSelected", function AutocompleteComponent_Template_mat_autocomplete_optionSelected_5_listener($event) { return ctx.onSelected($event); });
        ɵɵtemplate(7, AutocompleteComponent_mat_option_7_Template, 2, 2, "mat-option", 5);
        ɵɵpipe(8, "async");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(6);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.item.label);
        ɵɵadvance(1);
        ɵɵproperty("placeholder", ctx.item.label)("matAutocomplete", _r1)("formControlName", ctx.item.name)("required", ctx.item.required);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.icon);
        ɵɵadvance(1);
        ɵɵproperty("displayWith", ctx.valueMapper);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ɵɵpipeBind1(8, 9, ctx.filteredOptions));
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, MatLabel, MatInput, MatAutocompleteTrigger, DefaultValueAccessor, NgControlStatus, FormControlName, RequiredValidator, NgIf, MatAutocomplete, NgForOf, MatButton, MatSuffix, MatIcon, MatOption], pipes: [AsyncPipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AutocompleteComponent, [{
        type: Component,
        args: [{
                selector: 'vias-autocomplete',
                templateUrl: './autocomplete.component.html',
                styleUrls: ['./autocomplete.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onclick: [{
            type: Output
        }], onchange: [{
            type: Output
        }] }); })();

const _c0 = ["filterSelect"];
class AutoCompleteFilterComponent {
    constructor() {
        this.text = '';
        this.value = -1;
    }
    agInit(params) {
        this.form = new FormGroup({ filterSelect: new FormControl() });
        this.item = {
            type: FieldTypes.AutoComplete,
            name: 'filterSelect',
        };
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
        if (params.colDef.filterParams !== null) {
            this.options = params.colDef.filterParams.filterDataSource;
        }
    }
    isFilterActive() {
        return this.value !== null && this.value !== undefined && this.value !== -1;
    }
    doesFilterPass(params) {
        if (this.isLocalRefresh) {
            const val = params.data[this.params.colDef.field];
            // tslint:disable-next-line: radix
            return this.value === parseInt(val);
        }
        else {
            return true;
        }
    }
    // afterGuiAttached?(params?: { hidePopup?: Function }): void{
    //   window.setTimeout(() => {
    //     if(this.theSelect.element.nativeElement.querySelector('input') != null){
    //       this.theSelect.element.nativeElement.querySelector('input').focus();
    //     }
    // });
    // }
    getModel() {
        return { value: this.value };
    }
    setModel(model) {
        this.value = model ? model.value : -1;
    }
    // ngAfterViewInit(params: IAfterGuiAttachedParams): void {
    ngAfterViewInit() {
        this.item.options = [];
        this.options.forEach(o => {
            this.item.options.push({
                label: o.label,
                data: o.value.toString()
            });
        });
    }
    onChange(newValue) {
        if (this.value !== newValue) {
            this.value = newValue;
            this.params.filterChangedCallback();
        }
    }
}
AutoCompleteFilterComponent.ɵfac = function AutoCompleteFilterComponent_Factory(t) { return new (t || AutoCompleteFilterComponent)(); };
AutoCompleteFilterComponent.ɵcmp = ɵɵdefineComponent({ type: AutoCompleteFilterComponent, selectors: [["vias-filter-cell"]], viewQuery: function AutoCompleteFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.theSelect = _t.first);
    } }, decls: 2, vars: 2, consts: [[3, "form", "item", "onchange"], ["filterSelect", ""]], template: function AutoCompleteFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "vias-autocomplete", 0, 1);
        ɵɵlistener("onchange", function AutoCompleteFilterComponent_Template_vias_autocomplete_onchange_0_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("form", ctx.form)("item", ctx.item);
    } }, directives: [AutocompleteComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AutoCompleteFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-filter-cell',
                template: `<vias-autocomplete #filterSelect [form]="form" [item]="item" (onchange)="onChange($event)"></vias-autocomplete>`,
            }]
    }], null, { theSelect: [{
            type: ViewChild,
            args: ['filterSelect', { read: ViewContainerRef, static: false }]
        }] }); })();

const _c0$1 = ["flatpickrEl"];
const _c1 = ["eInput"];
class DgFilterComponent {
    agInit(params) {
        this.params = params;
    }
    ngAfterViewInit() {
    }
    ngOnDestroy() {
        console.log(`Destroying DateComponent`);
    }
    onDateChanged(selectedDates) {
        this.date = selectedDates[0] || null;
        this.params.onDateChanged();
    }
    getDate() {
        return this.date;
    }
    setDate(date) {
        this.date = date || null;
        this.picker.setDate(date);
    }
    setInputPlaceholder(placeholder) {
        this.eInput.nativeElement.setAttribute('placeholder', placeholder);
    }
    setInputAriaLabel(label) {
        this.eInput.nativeElement.setAttribute('aria-label', label);
    }
}
DgFilterComponent.ɵfac = function DgFilterComponent_Factory(t) { return new (t || DgFilterComponent)(); };
DgFilterComponent.ɵcmp = ɵɵdefineComponent({ type: DgFilterComponent, selectors: [["vias-filter-cell"]], viewQuery: function DgFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$1, true, ElementRef);
        ɵɵviewQuery(_c1, true, ElementRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.flatpickrEl = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.eInput = _t.first);
    } }, decls: 9, vars: 0, consts: [["filterForm", ""], ["role", "presentation", 1, "ag-input-wrapper", "custom-date-filter"], ["flatpickrEl", ""], ["type", "text", "data-input", "", 2, "width", "100%"], ["eInput", ""], ["title", "clear", "data-clear", "", 1, "input-button"], [1, "fa", "fa-times"]], template: function DgFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "form", null, 0);
        ɵɵelementStart(2, "div", 1, 2);
        ɵɵtext(4, "aaaaa ");
        ɵɵelement(5, "input", 3, 4);
        ɵɵelementStart(7, "a", 5);
        ɵɵelement(8, "i", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, NgForm], styles: [".custom-date-filter[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] {\n  position: absolute;\n  right: 20px;\n  color: rgba(0, 0, 0, 0.54);\n  cursor: pointer;\n}\n\n.custom-date-filter[_ngcontent-%COMP%]:after {\n  position: absolute;\n  content: '\f073';\n  display: block;\n  font-weight: 400;\n  font-family: 'Font Awesome 5 Free';\n  right: 5px;\n  pointer-events: none;\n  color: rgba(0, 0, 0, 0.54);\n}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DgFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-filter-cell',
                template: `<form #filterForm>
  <div
      #flatpickrEl
      class="ag-input-wrapper custom-date-filter"
      role="presentation"
    >aaaaa
      <input type="text" #eInput data-input style="width: 100%;" />
      <a class="input-button" title="clear" data-clear>
        <i class="fa fa-times"></i>
      </a>
    </div>
</form>`,
                styles: [`
.custom-date-filter a {
  position: absolute;
  right: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}

.custom-date-filter:after {
  position: absolute;
  content: '\f073';
  display: block;
  font-weight: 400;
  font-family: 'Font Awesome 5 Free';
  right: 5px;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.54);
}
  `,
                ],
            }]
    }], null, { flatpickrEl: [{
            type: ViewChild,
            args: ['flatpickrEl', { read: ElementRef }]
        }], eInput: [{
            type: ViewChild,
            args: ['eInput', { read: ElementRef }]
        }] }); })();

const _c0$2 = ["filterText"];
class TextFilterComponent {
    constructor() {
        this.value = '';
    }
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
    }
    isFilterActive() {
        return this.value !== null && this.value !== undefined && this.value !== '';
    }
    doesFilterPass(params) {
        if (this.isLocalRefresh) {
            return this.value.toLowerCase()
                .split(' ')
                .every((filterWord) => {
                return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= -1;
            });
        }
        else {
            //  db ye gidecek. hep true gelmesi lazim...
            return true;
        }
    }
    getModel() {
        return { value: this.value };
    }
    setModel(model) {
        this.value = model ? model.value : '';
    }
    ngAfterViewInit() {
        window.setTimeout(() => {
            this.theText.nativeElement.focus();
            this.theText.nativeElement.value = this.value;
        });
    }
    onChange(newValue) {
        if (this.value !== newValue) {
            this.value = newValue;
            this.params.filterChangedCallback();
        }
    }
}
TextFilterComponent.ɵfac = function TextFilterComponent_Factory(t) { return new (t || TextFilterComponent)(); };
TextFilterComponent.ɵcmp = ɵɵdefineComponent({ type: TextFilterComponent, selectors: [["vias-text-cell"]], viewQuery: function TextFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.theText = _t.first);
    } }, decls: 2, vars: 1, consts: [[3, "ngModel", "ngModelChange"], ["filterText", ""]], template: function TextFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "input", 0, 1);
        ɵɵlistener("ngModelChange", function TextFilterComponent_Template_input_ngModelChange_0_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("ngModel", _r0);
    } }, directives: [DefaultValueAccessor, NgControlStatus, NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TextFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-text-cell',
                template: `<input #filterText [ngModel]="filterText" (ngModelChange)="onChange($event)"/>`,
            }]
    }], null, { theText: [{
            type: ViewChild,
            args: ['filterText', { static: false }]
        }] }); })();

class CheckboxComponent {
    constructor() {
        this.onchange = new EventEmitter();
    }
    ngOnInit() { }
    onChange($event) {
        if (this.item.toggleFormItems !== undefined) {
            this.item.toggleFormItems.forEach(tItemName => {
                if (this.form.controls[tItemName].disabled) {
                    this.form.controls[tItemName].enable();
                }
                else {
                    this.form.controls[tItemName].disable();
                }
            });
        }
        this.onchange.emit($event);
    }
}
CheckboxComponent.ɵfac = function CheckboxComponent_Factory(t) { return new (t || CheckboxComponent)(); };
CheckboxComponent.ɵcmp = ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["vias-checkbox"]], inputs: { item: "item", form: "form" }, outputs: { onchange: "onchange" }, decls: 3, vars: 4, consts: [[3, "formGroup"], [3, "formControlName", "required", "change"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-checkbox", 1);
        ɵɵlistener("change", function CheckboxComponent_Template_mat_checkbox_change_1_listener($event) { return ctx.onChange($event); });
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("formControlName", ctx.item.name)("required", ctx.item.required);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.item.label);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, MatCheckbox, MatCheckboxRequiredValidator, NgControlStatus, FormControlName, RequiredValidator], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'vias-checkbox',
                templateUrl: './checkbox.component.html',
                styleUrls: ['./checkbox.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onchange: [{
            type: Output
        }] }); })();

function DropdownComponent_mat_option_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-option", 3);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const opt_r1 = ctx.$implicit;
    ɵɵproperty("value", opt_r1.data);
    ɵɵadvance(1);
    ɵɵtextInterpolate(opt_r1.label);
} }
class DropdownComponent {
    constructor() {
        this.onchange = new EventEmitter();
    }
    ngOnInit() {
    }
    onChange($event) {
        if (this.item.toggleFormItems !== undefined && this.item.toggleOffValues !== undefined) {
            this.item.toggleOffValues.forEach(item => {
                if (item.data === $event.value) {
                    this.item.toggleFormItems.forEach(tItemName => this.toggleItem(tItemName, true));
                }
                else {
                    this.item.toggleFormItems.forEach(tItemName => this.toggleItem(tItemName, false));
                }
            });
        }
        this.onchange.emit($event.value);
    }
    toggleItem(tItemName, disable) {
        if (disable) {
            this.form.controls[tItemName].disable();
        }
        else {
            this.form.controls[tItemName].enable();
        }
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(); };
DropdownComponent.ɵcmp = ɵɵdefineComponent({ type: DropdownComponent, selectors: [["vias-dropdown"]], inputs: { item: "item", form: "form" }, outputs: { onchange: "onchange" }, decls: 3, vars: 5, consts: [[2, "width", "100%", 3, "formGroup"], [3, "placeholder", "required", "formControlName", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-select", 1);
        ɵɵlistener("selectionChange", function DropdownComponent_Template_mat_select_selectionChange_1_listener($event) { return ctx.onChange($event); });
        ɵɵtemplate(2, DropdownComponent_mat_option_2_Template, 2, 2, "mat-option", 2);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("placeholder", ctx.item.label)("required", ctx.item.required)("formControlName", ctx.item.name);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.item.options);
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, MatSelect, RequiredValidator, NgControlStatus, FormControlName, NgForOf, MatOption], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{
                selector: 'vias-dropdown',
                templateUrl: './dropdown.component.html',
                styleUrls: ['./dropdown.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onchange: [{
            type: Output
        }] }); })();

function RadioComponent_mat_radio_button_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-radio-button", 4);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const opt_r1 = ctx.$implicit;
    ɵɵproperty("value", opt_r1.data);
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", ɵɵpipeBind1(2, 2, opt_r1.label), "\u00A0");
} }
class RadioComponent {
    constructor() { }
    ngOnInit() { }
    ngOnChanges() { }
}
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(); };
RadioComponent.ɵcmp = ɵɵdefineComponent({ type: RadioComponent, selectors: [["vias-radio"]], inputs: { item: "item", form: "form" }, features: [ɵɵNgOnChangesFeature], decls: 5, vars: 5, consts: [[3, "formGroup"], [1, "radio-label-padding"], [3, "formControlName", "required"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "label", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "mat-radio-group", 2);
        ɵɵtemplate(4, RadioComponent_mat_radio_button_4_Template, 3, 4, "mat-radio-button", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(2);
        ɵɵtextInterpolate1("", ctx.item.label, ": ");
        ɵɵadvance(1);
        ɵɵproperty("formControlName", ctx.item.name)("required", ctx.item.required);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.item.options);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, MatRadioGroup, NgControlStatus, FormControlName, RequiredValidator, NgForOf, MatRadioButton], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'vias-radio',
                templateUrl: './radio.component.html',
                styleUrls: ['./radio.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class FileComponent {
    constructor() {
        this.onchange = new EventEmitter();
    }
    ngOnInit() { }
    onChange($event) {
        if ($event.target.files !== undefined) {
            this.onchange.emit($event.target);
        }
    }
}
FileComponent.ɵfac = function FileComponent_Factory(t) { return new (t || FileComponent)(); };
FileComponent.ɵcmp = ɵɵdefineComponent({ type: FileComponent, selectors: [["vias-file"]], inputs: { item: "item", form: "form" }, outputs: { onchange: "onchange" }, decls: 2, vars: 3, consts: [[3, "formGroup"], ["type", "file", "multiple", "", 3, "formControlName", "required", "change"]], template: function FileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "input", 1);
        ɵɵlistener("change", function FileComponent_Template_input_change_1_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("formControlName", ctx.item.name)("required", ctx.item.required);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, DefaultValueAccessor, NgControlStatus, FormControlName, RequiredValidator], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FileComponent, [{
        type: Component,
        args: [{
                selector: 'vias-file',
                templateUrl: './file.component.html',
                styleUrls: ['./file.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onchange: [{
            type: Output
        }] }); })();

class ImgComponent {
    constructor() { }
    ngOnInit() { }
}
ImgComponent.ɵfac = function ImgComponent_Factory(t) { return new (t || ImgComponent)(); };
ImgComponent.ɵcmp = ɵɵdefineComponent({ type: ImgComponent, selectors: [["vias-img"]], inputs: { item: "item", form: "form" }, decls: 2, vars: 6, consts: [[3, "formGroup"], [3, "formControlName", "ngClass", "src"]], template: function ImgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelement(1, "img", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵstyleMap(ctx.item.width !== undefined ? "width:" + ctx.item.width + ";" : "" + " " + ctx.item.height !== undefined ? "height:" + ctx.item.height + ";" : "");
        ɵɵproperty("formControlName", ctx.item.name)("ngClass", ctx.item.width === undefined && ctx.item.height === undefined ? "imgAutoSize" : "")("src", ctx.item.value, ɵɵsanitizeUrl);
    } }, directives: [NgControlStatusGroup, FormGroupDirective, NgControlStatus, FormControlName, NgClass], styles: [".imgAutoSize[_ngcontent-%COMP%]{height:auto;width:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ImgComponent, [{
        type: Component,
        args: [{
                selector: 'vias-img',
                templateUrl: './img.component.html',
                styleUrls: ['./img.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

function DatepickerComponent_ng_container_8_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const validation_r2 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(validation_r2.message);
} }
function DatepickerComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 5);
    ɵɵtemplate(1, DatepickerComponent_ng_container_8_mat_error_1_Template, 2, 1, "mat-error", 6);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const validation_r2 = ctx.$implicit;
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.form.get(ctx_r1.item.name).hasError(validation_r2.name));
} }
class DatepickerComponent {
    constructor() { }
    ngOnInit() { }
}
DatepickerComponent.ɵfac = function DatepickerComponent_Factory(t) { return new (t || DatepickerComponent)(); };
DatepickerComponent.ɵcmp = ɵɵdefineComponent({ type: DatepickerComponent, selectors: [["vias-datepicker"]], inputs: { item: "item", form: "form" }, features: [ɵɵProvidersFeature([
            { provide: MAT_DATE_LOCALE, useValue: 'tr-TR' },
            { provide: MAT_DATE_FORMATS, useValue: {
                    parse: {
                        dateInput: 'DD/MM/YYYY'
                    },
                    display: {
                        dateInput: 'DD/MM/YYYY',
                        monthYearLabel: 'MMM YYYY',
                        dateA11yLabel: 'LL',
                        monthYearA11yLabel: 'MMMM YYYY',
                    }
                }
            },
            {
                provide: DateAdapter,
                useClass: MomentDateAdapter,
                deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
            },
            { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } }
        ])], decls: 9, vars: 8, consts: [["appearance", "outline", 2, "width", "100%", 3, "formGroup"], ["matInput", "", 3, "matDatepicker", "formControlName", "placeholder", "required"], ["matSuffix", "", 3, "for"], ["picker", ""], ["ngProjectAs", "mat-error", 5, ["mat-error"], 4, "ngFor", "ngForOf"], ["ngProjectAs", "mat-error", 5, ["mat-error"]], [4, "ngIf"]], template: function DatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-form-field", 0);
        ɵɵelementStart(1, "mat-label");
        ɵɵtext(2);
        ɵɵelementEnd();
        ɵɵelement(3, "input", 1);
        ɵɵelement(4, "mat-datepicker-toggle", 2);
        ɵɵelement(5, "mat-datepicker", null, 3);
        ɵɵelement(7, "mat-hint");
        ɵɵtemplate(8, DatepickerComponent_ng_container_8_Template, 2, 1, "ng-container", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(6);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(2);
        ɵɵtextInterpolate(ctx.item.label);
        ɵɵadvance(1);
        ɵɵproperty("matDatepicker", _r0)("formControlName", ctx.item.name)("placeholder", ctx.item.label)("required", ctx.item.required);
        ɵɵadvance(1);
        ɵɵproperty("for", _r0);
        ɵɵadvance(4);
        ɵɵproperty("ngForOf", ctx.item.validations);
    } }, directives: [MatFormField, NgControlStatusGroup, FormGroupDirective, MatLabel, MatInput, MatDatepickerInput, DefaultValueAccessor, NgControlStatus, FormControlName, RequiredValidator, MatDatepickerToggle, MatSuffix, MatDatepicker, MatHint, NgForOf, NgIf, MatError], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'vias-datepicker',
                templateUrl: './datepicker.component.html',
                styleUrls: ['./datepicker.component.scss'],
                providers: [
                    { provide: MAT_DATE_LOCALE, useValue: 'tr-TR' },
                    { provide: MAT_DATE_FORMATS, useValue: {
                            parse: {
                                dateInput: 'DD/MM/YYYY'
                            },
                            display: {
                                dateInput: 'DD/MM/YYYY',
                                monthYearLabel: 'MMM YYYY',
                                dateA11yLabel: 'LL',
                                monthYearA11yLabel: 'MMMM YYYY',
                            }
                        }
                    },
                    {
                        provide: DateAdapter,
                        useClass: MomentDateAdapter,
                        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
                    },
                    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } }
                ]
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class DatecomboComponent {
    constructor() { }
    ngOnInit() {
    }
}
DatecomboComponent.ɵfac = function DatecomboComponent_Factory(t) { return new (t || DatecomboComponent)(); };
DatecomboComponent.ɵcmp = ɵɵdefineComponent({ type: DatecomboComponent, selectors: [["vias-datecombo"]], decls: 2, vars: 0, template: function DatecomboComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " datecombo works!\n");
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatecomboComponent, [{
        type: Component,
        args: [{
                selector: 'vias-datecombo',
                templateUrl: './datecombo.component.html',
                styleUrls: ['./datecombo.component.scss']
            }]
    }], function () { return []; }, null); })();

function ButtonComponent_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r0.item.icon_type);
} }
class ButtonComponent {
    constructor() {
        this.onclick = new EventEmitter();
        this.type = 'button';
        this.color = 'primary';
    }
    ngOnInit() {
        if (this.item.type === FieldTypes.Submit) {
            this.type = 'submit';
        }
        if (this.item.color !== undefined) {
            this.color = this.item.color;
        }
    }
    onClick($event) {
        this.onclick.emit($event);
    }
}
ButtonComponent.ɵfac = function ButtonComponent_Factory(t) { return new (t || ButtonComponent)(); };
ButtonComponent.ɵcmp = ɵɵdefineComponent({ type: ButtonComponent, selectors: [["vias-button"]], inputs: { item: "item", form: "form" }, outputs: { onclick: "onclick" }, decls: 3, vars: 4, consts: [["mat-raised-button", "", 3, "type", "color", "click"], [4, "ngIf"]], template: function ButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "button", 0);
        ɵɵlistener("click", function ButtonComponent_Template_button_click_0_listener($event) { return ctx.onClick($event); });
        ɵɵtemplate(1, ButtonComponent_mat_icon_1_Template, 2, 1, "mat-icon", 1);
        ɵɵtext(2);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("type", ctx.type)("color", ctx.color);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.item.icon);
        ɵɵadvance(1);
        ɵɵtextInterpolate1(" ", ctx.item.label, "\n");
    } }, directives: [MatButton, NgIf, MatIcon], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ButtonComponent, [{
        type: Component,
        args: [{
                selector: 'vias-button',
                templateUrl: './button.component.html',
                styleUrls: ['./button.component.scss']
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onclick: [{
            type: Output
        }] }); })();

function InputComponent_mat_form_field_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", ɵɵpipeBind1(2, 1, ctx_r2.item.matPrefixText), "\u00A0");
} }
function InputComponent_mat_form_field_0_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate1("", ɵɵpipeBind1(2, 1, ctx_r3.item.matSuffixText), "\u00A0");
} }
function InputComponent_mat_form_field_0_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 7, 8);
    ɵɵlistener("click", function InputComponent_mat_form_field_0_button_6_Template_button_click_0_listener($event) { ɵɵrestoreView(_r8); const ctx_r7 = ɵɵnextContext(2); return ctx_r7.onClick($event); });
    ɵɵelementStart(2, "mat-icon");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r4.item.icon_type);
} }
function InputComponent_mat_form_field_0_ng_container_7_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const validation_r9 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, validation_r9.message));
} }
function InputComponent_mat_form_field_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 9);
    ɵɵtemplate(1, InputComponent_mat_form_field_0_ng_container_7_mat_error_1_Template, 3, 3, "mat-error", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const validation_r9 = ctx.$implicit;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.form.get(ctx_r5.item.name).hasError(validation_r9.name));
} }
function InputComponent_mat_form_field_0_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-form-field", 2);
    ɵɵtemplate(1, InputComponent_mat_form_field_0_span_1_Template, 3, 3, "span", 3);
    ɵɵelementStart(2, "mat-label");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementStart(4, "input", 4);
    ɵɵlistener("change", function InputComponent_mat_form_field_0_Template_input_change_4_listener($event) { ɵɵrestoreView(_r13); const ctx_r12 = ɵɵnextContext(); return ctx_r12.onChange($event); });
    ɵɵelementEnd();
    ɵɵtemplate(5, InputComponent_mat_form_field_0_span_5_Template, 3, 3, "span", 3);
    ɵɵtemplate(6, InputComponent_mat_form_field_0_button_6_Template, 4, 1, "button", 5);
    ɵɵtemplate(7, InputComponent_mat_form_field_0_ng_container_7_Template, 2, 1, "ng-container", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵpropertyInterpolate("appearance", ctx_r0.appearance);
    ɵɵpropertyInterpolate("floatLabel", ctx_r0.floatLabel);
    ɵɵproperty("formGroup", ctx_r0.form);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.matPrefix === true);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r0.item.label);
    ɵɵadvance(1);
    ɵɵstyleMap(ctx_r0.inputWidthPercent > 0 ? "width:" + ctx_r0.inputWidthPercent + "%;" : "");
    ɵɵproperty("formControlName", ctx_r0.item.name)("maxlength", ctx_r0.item.maxlength)("placeholder", ctx_r0.item.label)("required", ctx_r0.item.required)("type", ctx_r0.inputType);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.matSuffix === true);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r0.item.icon);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.item.validations);
} }
function InputComponent_mat_form_field_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 7, 8);
    ɵɵlistener("click", function InputComponent_mat_form_field_1_button_6_Template_button_click_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(2); return ctx_r18.onClick($event); });
    ɵɵelementStart(2, "mat-icon");
    ɵɵtext(3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵadvance(3);
    ɵɵtextInterpolate(ctx_r15.item.icon_type);
} }
function InputComponent_mat_form_field_1_ng_container_7_mat_error_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-error");
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const validation_r20 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, validation_r20.message));
} }
function InputComponent_mat_form_field_1_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0, 9);
    ɵɵtemplate(1, InputComponent_mat_form_field_1_ng_container_7_mat_error_1_Template, 3, 3, "mat-error", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const validation_r20 = ctx.$implicit;
    const ctx_r16 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r16.form.get(ctx_r16.item.name).hasError(validation_r20.name));
} }
function InputComponent_mat_form_field_1_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "mat-form-field", 10);
    ɵɵelementStart(1, "mat-label");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "textarea", 11, 12);
    ɵɵlistener("change", function InputComponent_mat_form_field_1_Template_textarea_change_3_listener($event) { ɵɵrestoreView(_r24); const ctx_r23 = ɵɵnextContext(); return ctx_r23.onChange($event); });
    ɵɵtext(5);
    ɵɵelementEnd();
    ɵɵtemplate(6, InputComponent_mat_form_field_1_button_6_Template, 4, 1, "button", 5);
    ɵɵtemplate(7, InputComponent_mat_form_field_1_ng_container_7_Template, 2, 1, "ng-container", 6);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵpropertyInterpolate("appearance", ctx_r1.appearance);
    ɵɵproperty("formGroup", ctx_r1.form);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ctx_r1.item.label);
    ɵɵadvance(1);
    ɵɵstyleMap(ctx_r1.inputWidthPercent > 0 ? "width:" + ctx_r1.inputWidthPercent + "%;" : "");
    ɵɵproperty("formControlName", ctx_r1.item.name)("required", ctx_r1.item.required);
    ɵɵadvance(2);
    ɵɵtextInterpolate1("\t  ", ctx_r1.item.value, "\n\t");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r1.item.icon);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r1.item.validations);
} }
class InputComponent {
    constructor() {
        this.onclick = new EventEmitter();
        this.onchange = new EventEmitter();
        this.multiline = false;
        this.matPrefix = false;
        this.matSuffix = false;
        this.appearance = 'outline';
        this.floatLabel = 'auto';
        this.inputWidthPercent = 0;
    }
    ngOnInit() {
        switch (this.item.type) {
            case FieldTypes.Number:
                this.inputType = 'number';
                break;
            case FieldTypes.Email:
                this.inputType = 'email';
                break;
            case FieldTypes.Password:
                this.inputType = 'password';
                break;
            case FieldTypes.Input:
            case FieldTypes.Text:
            case FieldTypes.Id:
            default:
                this.inputType = 'text';
                break;
        }
        if (this.item.multiline !== undefined) {
            this.multiline = this.item.multiline;
        }
        if (this.item.appearance && this.item.appearance !== undefined) {
            this.appearance = this.item.appearance;
        }
        if (this.item.floatLabel && this.item.floatLabel !== undefined) {
            this.floatLabel = this.item.floatLabel;
        }
        if (this.item.matPrefix !== undefined) {
            this.matPrefix = this.item.matPrefix;
        }
        if (this.item.matSuffix !== undefined) {
            this.matSuffix = this.item.matSuffix;
        }
        if (this.item.inputWidthPercent !== undefined) {
            this.inputWidthPercent = this.item.inputWidthPercent;
        }
        if (this.item.connectedValueSetFunction !== undefined) {
            if (this.item.name !== undefined) {
                this.form.get(this.item.name).valueChanges.subscribe((val) => {
                    this.form
                        .get(this.item.name)
                        .setValue(this.item.connectedValueSetFunction(val), {
                        emitEvent: false,
                    });
                });
            }
        }
    }
    ngOnChanges(changes) { }
    onClick($event) {
        this.onclick.emit($event);
    }
    onChange($event) {
        const val = $event.currentTarget.value;
        if (this.item.connectedValuesFormItems !== undefined) {
            this.item.connectedValuesFormItems.forEach((tItemName) => {
                // console.log(this.form.controls[tItemName]);
                this.form.controls[tItemName].setValue(val, { emitEvent: true });
            });
        }
        else {
            this.onchange.emit(val);
        }
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(); };
InputComponent.ɵcmp = ɵɵdefineComponent({ type: InputComponent, selectors: [["vias-input"]], inputs: { item: "item", form: "form" }, outputs: { onclick: "onclick", onchange: "onchange" }, features: [ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [["style", "width: 100%;", 3, "formGroup", "appearance", "floatLabel", 4, "ngIf"], ["style", "width: 100%", 3, "formGroup", "appearance", 4, "ngIf"], [2, "width", "100%", 3, "formGroup", "appearance", "floatLabel"], [4, "ngIf"], ["matInput", "", 3, "formControlName", "maxlength", "placeholder", "required", "type", "change"], ["color", "primary", "mat-icon-button", "", "type", "button", 3, "click", 4, "ngIf"], ["ngProjectAs", "mat-error", 5, ["mat-error"], 4, "ngFor", "ngForOf"], ["color", "primary", "mat-icon-button", "", "type", "button", 3, "click"], ["iconButton", ""], ["ngProjectAs", "mat-error", 5, ["mat-error"]], [2, "width", "100%", 3, "formGroup", "appearance"], ["matInput", "", "cdkTextareaAutosize", "", "cdkAutosizeMinRows", "2", "cdkAutosizeMaxRows", "5", 3, "formControlName", "required", "change"], ["autosize", "cdkTextareaAutosize"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, InputComponent_mat_form_field_0_Template, 8, 15, "mat-form-field", 0);
        ɵɵtemplate(1, InputComponent_mat_form_field_1_Template, 8, 10, "mat-form-field", 1);
    } if (rf & 2) {
        ɵɵproperty("ngIf", !ctx.multiline);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.multiline);
    } }, directives: [NgIf, MatFormField, NgControlStatusGroup, FormGroupDirective, MatLabel, MatInput, DefaultValueAccessor, NgControlStatus, FormControlName, MaxLengthValidator, RequiredValidator, NgForOf, MatButton, MatIcon, MatError, CdkTextareaAutosize], pipes: [TranslatePipe], styles: [".mat-icon[_ngcontent-%COMP%]{vertical-align:baseline}.mat-icon-button[_ngcontent-%COMP%]{height:auto;width:auto}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'vias-input',
                templateUrl: './input.component.html',
                styleUrls: ['./input.component.scss'],
            }]
    }], function () { return []; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], onclick: [{
            type: Output
        }], onchange: [{
            type: Output
        }] }); })();

class PageViewerSafeUrlPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(htmlString) {
        return this.sanitizer.bypassSecurityTrustHtml(htmlString);
    }
}
PageViewerSafeUrlPipe.ɵfac = function PageViewerSafeUrlPipe_Factory(t) { return new (t || PageViewerSafeUrlPipe)(ɵɵdirectiveInject(DomSanitizer)); };
PageViewerSafeUrlPipe.ɵpipe = ɵɵdefinePipe({ name: "safeURL", type: PageViewerSafeUrlPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PageViewerSafeUrlPipe, [{
        type: Pipe,
        args: [{
                name: 'safeURL'
            }]
    }], function () { return [{ type: DomSanitizer }]; }, null); })();

const _c0$3 = ["containerElement"];
const _c1$1 = ["contentElement"];
class PageViewerComponent {
    constructor(element) {
        this.element = element;
    }
    ngOnInit() {
        if (this.item.contentComponent !== undefined) {
            console.log(this.containerElement);
        }
        else if (this.item.htmlContent !== undefined) {
            this.htmlContent = this.item.htmlContent;
        }
        else {
            this.htmlContent = '';
        }
    }
    ngOnChanges(changes) { }
}
PageViewerComponent.ɵfac = function PageViewerComponent_Factory(t) { return new (t || PageViewerComponent)(ɵɵdirectiveInject(ElementRef)); };
PageViewerComponent.ɵcmp = ɵɵdefineComponent({ type: PageViewerComponent, selectors: [["vias-page-viewer"]], viewQuery: function PageViewerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$3, true);
        ɵɵviewQuery(_c1$1, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.containerElement = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.contentElement = _t.first);
    } }, inputs: { item: "item", form: "form" }, features: [ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [[1, "page-container"], ["containerElement", ""], [1, "page-content", 3, "innerHTML"], ["contentElement", ""]], template: function PageViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0, 1);
        ɵɵelement(2, "div", 2, 3);
        ɵɵpipe(4, "safeURL");
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("innerHTML", ɵɵpipeBind1(4, 1, ctx.htmlContent), ɵɵsanitizeHtml);
    } }, pipes: [PageViewerSafeUrlPipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PageViewerComponent, [{
        type: Component,
        args: [{
                selector: 'vias-page-viewer',
                templateUrl: './page-viewer.component.html',
                styleUrls: ['./page-viewer.component.scss']
            }]
    }], function () { return [{ type: ElementRef }]; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], containerElement: [{
            type: ViewChild,
            args: ['containerElement', { static: false }]
        }], contentElement: [{
            type: ViewChild,
            args: ['contentElement', { static: false }]
        }] }); })();

function ButtonbarComponent_ng_container_1_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "input", 4);
    ɵɵlistener("change", function ButtonbarComponent_ng_container_1_input_1_Template_input_change_0_listener($event) { ɵɵrestoreView(_r5); const ctx_r4 = ɵɵnextContext(2); return ctx_r4.buttonItemClick($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵɵnextContext().$implicit;
    ɵɵproperty("name", item_r1.name);
} }
function ButtonbarComponent_ng_container_1_button_2_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(item_r1.icon);
} }
function ButtonbarComponent_ng_container_1_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 5);
    ɵɵlistener("click", function ButtonbarComponent_ng_container_1_button_2_Template_button_click_0_listener($event) { ɵɵrestoreView(_r10); const ctx_r9 = ɵɵnextContext(2); return ctx_r9.buttonItemClick($event); });
    ɵɵtemplate(1, ButtonbarComponent_ng_container_1_button_2_mat_icon_1_Template, 2, 1, "mat-icon", 6);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵɵnextContext().$implicit;
    ɵɵproperty("name", item_r1.name)("color", item_r1.color);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r1.icon);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 4, item_r1.label), " ");
} }
function ButtonbarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵtemplate(1, ButtonbarComponent_ng_container_1_input_1_Template, 1, 1, "input", 2);
    ɵɵtemplate(2, ButtonbarComponent_ng_container_1_button_2_Template, 4, 6, "button", 3);
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r1.type == "file");
    ɵɵadvance(1);
    ɵɵproperty("ngIf", item_r1.type != "file");
} }
var ButtonColors;
(function (ButtonColors) {
    ButtonColors["Default"] = "";
    ButtonColors["Primary"] = "primary";
    ButtonColors["Accent"] = "accent";
    ButtonColors["Warn"] = "warn";
    ButtonColors["Disabled"] = "disabled";
})(ButtonColors || (ButtonColors = {}));
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes[ButtonTypes["Submit"] = 0] = "Submit";
    ButtonTypes[ButtonTypes["Button"] = 1] = "Button";
    ButtonTypes[ButtonTypes["Link"] = 2] = "Link";
    ButtonTypes[ButtonTypes["Toggle"] = 3] = "Toggle";
})(ButtonTypes || (ButtonTypes = {}));
class ButtonbarComponent {
    constructor() {
        this.itemClick = new EventEmitter();
    }
    ngOnInit() {
        this.buttons.forEach(btn => {
            if (btn.color === undefined) {
                btn.color = ButtonColors.Default;
            }
        });
    }
    buttonItemClick($event) {
        let buttonId = '';
        if ($event.target['name'] || $event.currentTarget['name']) {
            buttonId = $event.target['name'] !== undefined ? $event.target['name'] : $event.currentTarget['name'];
            const selection = this.buttons.find(e => e['name'] === buttonId);
            if ($event.target.files !== undefined) {
                selection.files = $event.target.files;
            }
            if (selection) {
                this.itemClick.emit(selection);
            }
        }
    }
}
ButtonbarComponent.ɵfac = function ButtonbarComponent_Factory(t) { return new (t || ButtonbarComponent)(); };
ButtonbarComponent.ɵcmp = ɵɵdefineComponent({ type: ButtonbarComponent, selectors: [["vias-buttonbar"]], inputs: { numLocale: "numLocale", class: "class", buttons: "buttons" }, outputs: { itemClick: "itemClick" }, decls: 2, vars: 2, consts: [[3, "ngClass"], [4, "ngFor", "ngForOf"], ["type", "file", 3, "name", "change", 4, "ngIf"], ["mat-raised-button", "", "type", "button", "isIconButton", "true", "isRoundButton", "true", 3, "name", "color", "click", 4, "ngIf"], ["type", "file", 3, "name", "change"], ["mat-raised-button", "", "type", "button", "isIconButton", "true", "isRoundButton", "true", 3, "name", "color", "click"], [4, "ngIf"]], template: function ButtonbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, ButtonbarComponent_ng_container_1_Template, 3, 2, "ng-container", 1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.class === undefined ? "buttonBarContainer" : ctx.class);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.buttons);
    } }, directives: [NgClass, NgForOf, NgIf, MatButton, MatIcon], pipes: [TranslatePipe], styles: [".buttonBarContainer[_ngcontent-%COMP%]{padding:5px;width:100%}.buttonBarContainer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-left:5px}.sideButtonBarContainer[_ngcontent-%COMP%]{padding:5px;width:auto}.sideButtonBarContainer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:2px;width:100%}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ButtonbarComponent, [{
        type: Component,
        args: [{
                selector: 'vias-buttonbar',
                templateUrl: './buttonbar.component.html',
                styleUrls: ['./buttonbar.component.scss']
            }]
    }], function () { return []; }, { numLocale: [{
            type: Input
        }], class: [{
            type: Input
        }], buttons: [{
            type: Input
        }], itemClick: [{
            type: Output
        }] }); })();

class ActionsSideToolBarComponent {
    //   @Output() itemClick: EventEmitter<ButtonBarItem> = new EventEmitter<ButtonBarItem>();
    constructor(next, route, storage, globals, viasService, dialog, translate) {
        this.next = next;
        this.route = route;
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.dialog = dialog;
        this.translate = translate;
        this.buttonBarClass = 'sideButtonBarContainer';
        this.buttonBarItems = [];
    }
    agInit(params) {
        this.params = params;
        // calculate stats when new rows loaded, i.e. onModelUpdated
        this.params.api.addEventListener('modelUpdated', this.updateTotals.bind(this));
    }
    butonclickHandler(event) {
        console.log(this.params);
        if (event.onClick) {
            event.onClick(event, this.route, this.params.api.getSelectedRows(), this.translate, this.storage, this.globals, this.viasService, this.dialog);
            //   this.itemClick.emit(event);
        }
    }
    refresh() { }
    updateTotals() {
        const sidebar = this.params.api.getSideBar();
        // 3. buton
        if (sidebar.toolPanels[2] !== undefined) {
            if (sidebar.toolPanels[2].sideMenuItems !== undefined) {
                this.buttonBarItems = sidebar.toolPanels[2].sideMenuItems;
            }
        }
        // if (this.params.api.gridOptionsWrapper.gridOptions.sideMenuItems !== undefined){
        //     this.buttonBarItems = this.params.api.gridOptionsWrapper.gridOptions.sideMenuItems as ButtonBarItem[];
        // }
        // }
        // var numGold = 0,
        //   numSilver = 0,
        //   numBronze = 0;
        // this.params.api.forEachNode(function (rowNode) {
        //   let data = rowNode.data;
        //   console.log('aaaaa', rowNode);
        // //   if (data.gold) numGold += data.gold;
        // //   if (data.silver) numSilver += data.silver;
        // //   if (data.bronze) numBronze += data.bronze;
        // });
        // this.numMedals = numGold + numSilver + numBronze;
        // this.numGold = numGold;
        // this.numSilver = numSilver;
        // this.numBronze = numBronze;
    }
}
ActionsSideToolBarComponent.ɵfac = function ActionsSideToolBarComponent_Factory(t) { return new (t || ActionsSideToolBarComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(TranslateService)); };
ActionsSideToolBarComponent.ɵcmp = ɵɵdefineComponent({ type: ActionsSideToolBarComponent, selectors: [["vias-actions-sidebar"]], decls: 2, vars: 4, consts: [[1, "actionSidebar"], [3, "numLocale", "buttons", "itemClick"]], template: function ActionsSideToolBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "vias-buttonbar", 1);
        ɵɵlistener("itemClick", function ActionsSideToolBarComponent_Template_vias_buttonbar_itemClick_1_listener($event) { return ctx.butonclickHandler($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassMap(ctx.buttonBarClass);
        ɵɵproperty("numLocale", ctx.numLocale)("buttons", ctx.buttonBarItems);
    } }, directives: [ButtonbarComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ActionsSideToolBarComponent, [{
        type: Component,
        args: [{
                selector: 'vias-actions-sidebar',
                template: `
<div class="actionSidebar">
    <vias-buttonbar
        [class]="buttonBarClass"
        [numLocale]="numLocale"
        [buttons]="buttonBarItems"
        (itemClick)="butonclickHandler($event)"
    ></vias-buttonbar>
</div>`
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: MatDialog }, { type: TranslateService }]; }, null); })();

const AG_GRID_LOCALE_EN = {
    // Set Filter
    selectAll: '(Select All)',
    selectAllSearchResults: '(Select All Search Results)',
    searchOoo: 'Search...',
    blanks: '(Blanks)',
    noMatches: 'No matches',
    // Number Filter & Text Filter
    filterOoo: 'Filter...',
    equals: 'Equals',
    notEqual: 'Not equal',
    empty: 'Choose One',
    // Number Filter
    lessThan: 'Less than',
    greaterThan: 'Greater than',
    lessThanOrEqual: 'Less than or equal',
    greaterThanOrEqual: 'Greater than or equal',
    inRange: 'In range',
    inRangeStart: 'to',
    inRangeEnd: 'from',
    // Text Filter
    contains: 'Contains',
    notContains: 'Not contains',
    startsWith: 'Starts with',
    endsWith: 'Ends with',
    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',
    // Filter Conditions
    andCondition: 'AND',
    orCondition: 'OR',
    // Filter Buttons
    applyFilter: 'Apply',
    resetFilter: 'Reset',
    clearFilter: 'Clear',
    cancelFilter: 'Cancel',
    // Filter Titles
    textFilter: 'Text Filter',
    numberFilter: 'Number Filter',
    dateFilter: 'Date Filter',
    setFilter: 'Set Filter',
    // Side Bar
    columns: 'Columns',
    filters: 'Filters',
    actionsBar: 'Actions',
    // columns tool panel
    pivotMode: 'Pivot Mode',
    groups: 'Row Groups',
    rowGroupColumnsEmptyMessage: 'Drag here to set row groups',
    values: 'Values',
    valueColumnsEmptyMessage: 'Drag here to aggregate',
    pivots: 'Column Labels',
    pivotColumnsEmptyMessage: 'Drag here to set column labels',
    // Header of the Default Group Column
    group: 'Group',
    // Other
    loadingOoo: 'Loading...',
    noRowsToShow: 'No Rows To Show',
    enabled: 'Enabled',
    // Menu
    pinColumn: 'Pin Column',
    pinLeft: 'Pin Left',
    pinRight: 'Pin Right',
    noPin: 'No Pin',
    valueAggregation: 'Value Aggregation',
    autosizeThiscolumn: 'Autosize This Column',
    autosizeAllColumns: 'Autosize All Columns',
    groupBy: 'Group by',
    ungroupBy: 'Un-Group by',
    resetColumns: 'Reset Columns',
    expandAll: 'Expand All',
    collapseAll: 'Close All',
    copy: 'Copy',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copy With Headers',
    paste: 'Paste',
    ctrlV: 'Ctrl+V',
    export: 'Export',
    csvExport: 'CSV Export',
    excelExport: 'Excel Export (.xlsx)',
    excelXmlExport: 'Excel Export (.xml)',
    // Enterprise Menu Aggregation and Status Bar
    sum: 'Sum',
    min: 'Min',
    max: 'Max',
    none: 'None',
    count: 'Count',
    average: 'Average',
    filteredRows: 'Filtered',
    selectedRows: 'Selected',
    totalRows: 'Total Rows',
    totalAndFilteredRows: 'Rows',
    more: 'More',
    to: 'to',
    of: 'of',
    page: 'Page',
    nextPage: 'Next Page',
    lastPage: 'Last Page',
    firstPage: 'First Page',
    previousPage: 'Previous Page',
    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',
    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',
    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',
    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',
    line: 'Line',
    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',
    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',
    histogramChart: 'Histogram',
    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.'
};

const AG_GRID_LOCALE_TR = {
    // Set Filter
    selectAll: '(Hepsini seç)',
    selectAllSearchResults: '(Tüm Arama Sonuçlarını Seç)',
    searchOoo: 'Arama...',
    blanks: '(Boşluklar)',
    noMatches: 'Eşleşme yok',
    // Number Filter & Text Filter
    filterOoo: 'Filtrele ...',
    equals: 'Eşittir',
    notEqual: 'Eşit Değildir',
    empty: 'Seçiniz',
    // Number Filter
    lessThan: 'Küçüktür',
    greaterThan: 'Büyüktür',
    lessThanOrEqual: 'Küçük Eşit',
    greaterThanOrEqual: 'Büyük Eşit',
    inRange: 'Aralık İçinde',
    inRangeStart: 'Başlangıç',
    inRangeEnd: 'Bitiş',
    // Text Filter
    contains: 'İçerir',
    notContains: 'İçermez',
    startsWith: 'İle Başlar',
    endsWith: 'İle Biter',
    // Date Filter
    dateFormatOoo: 'gg-aa-yyyy',
    // Filter Conditions
    andCondition: 'VE',
    orCondition: 'VEYA',
    // Filter Buttons
    applyFilter: 'Uygula',
    resetFilter: 'Sıfırla',
    clearFilter: 'Temizle',
    cancelFilter: 'İptal Et',
    // Filter Titles
    textFilter: 'Metin Filtresi',
    numberFilter: 'Rakam Filtresi',
    dateFilter: 'Tarih Filtresi',
    setFilter: 'Filtre Ayarla',
    // Side Bar
    columns: 'Sütunlar',
    filters: 'Filtreler',
    actionsBar: 'İşlemler',
    // columns tool panel
    pivotMode: 'Pivot Modu',
    groups: 'Satır Grupları',
    rowGroupColumnsEmptyMessage: 'Satır gruplarını ayarlamak için buraya sürükleyin',
    values: 'Değerler',
    valueColumnsEmptyMessage: 'Birleştirmek için buraya sürükleyin',
    pivots: 'Sütun Etiketleri',
    pivotColumnsEmptyMessage: 'Sütun etiketlerini ayarlamak için buraya sürükleyin',
    // Header of the Default Group Column
    group: 'Grup',
    // Other
    loadingOoo: 'Yükleniyor...',
    noRowsToShow: 'Gösterilecek Veri Yok',
    enabled: 'Etkin',
    // Menu
    pinColumn: 'Pin Sütunu',
    pinLeft: 'Sola Sabitle',
    pinRight: 'Sağa Sabitle',
    noPin: 'Pin Yok',
    valueAggregation: 'Değer Birleştirme',
    autosizeThiscolumn: 'Bu Sütunu Otomatik Boyutlandır',
    autosizeAllColumns: 'Tüm Sütunları Otomatik Boyutlandır',
    groupBy: 'Grupla',
    ungroupBy: 'Gruplama',
    resetColumns: 'Sütunları Sıfırla',
    expandAll: 'Hepsini genişlet',
    collapseAll: 'Hepsini kapat',
    copy: 'Kopyala',
    ctrlC: 'Ctrl + C',
    copyWithHeaders: 'Başlıklar ile Kopyala',
    paste: 'Yapıştırmak',
    ctrlV: 'Ctrl + V',
    export: 'Dışa Aktar',
    csvExport: 'CSV Dışa Aktar (.csv)',
    excelExport: 'Excel Dışa Aktar (.xlsx)',
    excelXmlExport: 'XML Dışa Aktar (.xml)',
    // Enterprise Menu Aggregation and Status Bar
    sum: 'Toplam',
    min: 'Min',
    max: 'Maks',
    none: 'Yok',
    count: 'Satır',
    average: 'Ortalama',
    filteredRows: 'Filtrelenmiş',
    selectedRows: 'Seçildi',
    totalRows: 'Toplam Satır',
    totalAndFilteredRows: 'Kayıt Sayısı',
    more: 'Daha',
    to: '',
    of: '',
    page: 'Sayfa',
    nextPage: 'Sonraki Sayfa',
    lastPage: 'Son Sayfa',
    firstPage: 'İlk sayfa',
    previousPage: 'Önceki sayfa',
    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Modu',
    pivotChart: 'Özet Şeması',
    chartRange: 'Grafik Aralığı',
    columnChart: 'Sütun',
    groupedColumn: 'Gruplanmış',
    stackedColumn: 'Yığılmış',
    normalizedColumn: '% 100 Yığılmış',
    barChart: 'Bar',
    groupedBar: 'Gruplanmış',
    stackedBar: 'Yığılmış',
    normalizedBar: '% 100 Yığılmış',
    pieChart: 'Turta',
    pie: 'Turta',
    doughnut: 'Tatlı çörek',
    line: 'Hat',
    xyChart: 'X Y (Dağılım)',
    scatter: 'Dağılım',
    bubble: 'Kabarcık',
    areaChart: 'Alan',
    area: 'Alan',
    stackedArea: 'Yığılmış',
    normalizedArea: '% 100 Yığılmış',
    histogramChart: 'Histogram',
    // Charts
    pivotChartTitle: 'Özet Şeması',
    rangeChartTitle: 'Menzil Tablosu',
    settings: 'Ayarlar',
    data: 'Veri',
    format: 'Biçim',
    categories: 'Kategoriler',
    defaultCategory: '(Yok)',
    series: 'Dizi',
    xyValues: 'X Y Değerleri',
    paired: 'Eşleştirilmiş Mod',
    axis: 'Eksen',
    navigator: 'Navigator',
    color: 'Renk',
    thickness: 'Kalınlık',
    xType: 'X Tipi',
    automatic: 'Otomatik',
    category: 'Kategori',
    number: 'Numara',
    time: 'Zaman',
    xRotation: 'X Dönüşü',
    yRotation: 'Y Dönüşü',
    ticks: 'Keneler',
    width: 'Genişlik',
    height: 'Yükseklik',
    length: 'Uzunluk',
    padding: 'Dolgu malzemesi',
    spacing: 'Aralık',
    chart: 'Grafik',
    title: 'Başlık',
    titlePlaceholder: 'Grafik başlığı - düzenlemek için çift tıklayın',
    background: 'Arka fon',
    font: 'Yazı tipi',
    top: 'Üst',
    right: 'Sağ',
    bottom: 'Alt',
    left: 'Ayrıldı',
    labels: 'Etiketler',
    size: 'Boyut',
    minSize: 'En küçük beden',
    maxSize: 'En büyük boy',
    legend: 'Efsane',
    position: 'Durum',
    markerSize: 'İşaret Boyutu',
    markerStroke: 'Marker Stroke',
    markerPadding: 'İşaretçi Dolgusu',
    itemSpacing: 'Öğe Aralığı',
    itemPaddingX: 'Öğe Dolgu X',
    itemPaddingY: 'Öğe Dolgu Y',
    layoutHorizontalSpacing: 'Yatay Aralık',
    layoutVerticalSpacing: 'Dikey Aralık',
    strokeWidth: 'Darbe genişliği',
    offset: 'Ofset',
    offsets: 'Ofsetler',
    tooltips: 'Araç ipuçları',
    callout: 'Çağır',
    markers: 'İşaretçiler',
    shadow: 'Gölge',
    blur: 'Bulanıklık',
    xOffset: 'X Ofset',
    yOffset: 'Y Ofseti',
    lineWidth: 'Hat genişliği',
    normal: 'Normal',
    bold: 'Kalın',
    italic: 'İtalik',
    boldItalic: 'Kalın italik',
    predefined: 'Önceden tanımlanmış',
    fillOpacity: 'Opaklığı Doldur',
    strokeOpacity: 'Çizgi Opaklığı',
    histogramBinCount: 'Bin sayısı',
    columnGroup: 'Sütun',
    barGroup: 'Bar',
    pieGroup: 'Turta',
    lineGroup: 'Hat',
    scatterGroup: 'X Y (Dağılım)',
    areaGroup: 'Alan',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Gruplanmış',
    stackedColumnTooltip: 'Yığılmış',
    normalizedColumnTooltip: '% 100 Yığılmış',
    groupedBarTooltip: 'Gruplanmış',
    stackedBarTooltip: 'Yığılmış',
    normalizedBarTooltip: '% 100 Yığılmış',
    pieTooltip: 'Turta',
    doughnutTooltip: 'Tatlı çörek',
    lineTooltip: 'Hat',
    groupedAreaTooltip: 'Alan',
    stackedAreaTooltip: 'Yığılmış',
    normalizedAreaTooltip: '% 100 Yığılmış',
    scatterTooltip: 'Dağılım',
    bubbleTooltip: 'Kabarcık',
    histogramTooltip: 'Histogram',
    noDataToChart: 'Grafiği gösterilecek veri yok.',
    pivotChartRequiresPivotMode: 'Pivot Chart, Pivot Modunun etkinleştirilmesini gerektirir.'
};

class StatusBarPaginationComponent {
    constructor() {
        // nav disabled   ilk   once  sonra  son // PageDirection
        this.nav = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.pageChange = new EventEmitter();
    }
    agInit(params) {
        this.nav[PageDirection.First] = true;
        this.nav[PageDirection.Previous] = true;
        this.nav[PageDirection.Next] = true;
        this.nav[PageDirection.Last] = true;
        this.params = params;
        // this.params.api.addEventListener('gridReady', this.onGridReady.bind(this));
        this.params.api.addEventListener('paginationChanged', this.onPaginationChanged.bind(this));
    }
    // onGridReady(): void {
    //     console.log("gr!@");
    // }
    onPaginationChanged($event) {
        this.gridApi = $event.api;
        this.controlPaginationDisabled();
    }
    onFirst() {
        if (this.currentPage > 1) {
            this.params.api.paginationGoToFirstPage();
            this.pageChange.emit(PageDirection.First);
        }
    }
    onPrevious() {
        if (this.currentPage > 1) {
            this.pageChange.emit(PageDirection.Previous);
        }
    }
    onNext() {
        if (this.currentPage < this.totalPages) {
            this.pageChange.emit(PageDirection.Next);
        }
    }
    onLast() {
        if (this.currentPage < this.totalPages) {
            this.pageChange.emit(PageDirection.Last);
        }
    }
    controlPaginationDisabled() {
        if (this.currentPage > 1) {
            this.nav[PageDirection.First] = false;
            this.nav[PageDirection.Previous] = false;
        }
        if (this.currentPage < this.totalPages) {
            this.nav[PageDirection.Next] = false;
            this.nav[PageDirection.Last] = false;
        }
    }
}
StatusBarPaginationComponent.ɵfac = function StatusBarPaginationComponent_Factory(t) { return new (t || StatusBarPaginationComponent)(); };
StatusBarPaginationComponent.ɵcmp = ɵɵdefineComponent({ type: StatusBarPaginationComponent, selectors: [["vias-datagrid-statusbar-pagination"]], decls: 18, vars: 10, consts: [["role", "presentation", 1, "ag-paging-page-summary-panel"], ["ref", "btFirst", "role", "button", "aria-label", "\u0130lk sayfa", "tabindex", "0", 1, "ag-paging-button", 3, "click"], ["unselectable", "on", "role", "presentation", 1, "ag-icon", "ag-icon-first"], ["ref", "btPrevious", "role", "button", "aria-label", "\u00D6nceki sayfa", "tabindex", "0", 1, "ag-paging-button", 3, "click"], ["unselectable", "on", "role", "presentation", 1, "ag-icon", "ag-icon-previous"], ["aria-hidden", "false", 1, "ag-paging-description"], ["id", "ag-30-start-page"], ["id", "ag-30-start-page-number", "ref", "lbCurrent", 1, "ag-paging-number"], ["id", "ag-30-of-page"], ["id", "ag-30-of-page-number", "ref", "lbTotal", 1, "ag-paging-number"], ["ref", "btNext", "role", "button", "aria-label", "Sonraki Sayfa", "tabindex", "0", 1, "ag-paging-button", 3, "click"], ["unselectable", "on", "role", "presentation", 1, "ag-icon", "ag-icon-next"], ["ref", "btLast", "role", "button", "aria-label", "Son Sayfa", "tabindex", "0", 1, "ag-paging-button", 3, "click"], ["unselectable", "on", "role", "presentation", 1, "ag-icon", "ag-icon-last"]], template: function StatusBarPaginationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "span", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵlistener("click", function StatusBarPaginationComponent_Template_div_click_1_listener() { return ctx.onFirst(); });
        ɵɵelement(2, "span", 2);
        ɵɵelementEnd();
        ɵɵelementStart(3, "div", 3);
        ɵɵlistener("click", function StatusBarPaginationComponent_Template_div_click_3_listener() { return ctx.onPrevious(); });
        ɵɵelement(4, "span", 4);
        ɵɵelementEnd();
        ɵɵelementStart(5, "span", 5);
        ɵɵelementStart(6, "span", 6);
        ɵɵtext(7, "Sayfa ");
        ɵɵelementEnd();
        ɵɵelementStart(8, "span", 7);
        ɵɵtext(9);
        ɵɵelementEnd();
        ɵɵelementStart(10, "span", 8);
        ɵɵtext(11, " / ");
        ɵɵelementEnd();
        ɵɵelementStart(12, "span", 9);
        ɵɵtext(13);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(14, "div", 10);
        ɵɵlistener("click", function StatusBarPaginationComponent_Template_div_click_14_listener() { return ctx.onNext(); });
        ɵɵelement(15, "span", 11);
        ɵɵelementEnd();
        ɵɵelementStart(16, "div", 12);
        ɵɵlistener("click", function StatusBarPaginationComponent_Template_div_click_16_listener() { return ctx.onLast(); });
        ɵɵelement(17, "span", 13);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵclassProp("ag-disabled", ctx.nav[0]);
        ɵɵadvance(2);
        ɵɵclassProp("ag-disabled", ctx.nav[1]);
        ɵɵadvance(6);
        ɵɵtextInterpolate(ctx.currentPage);
        ɵɵadvance(4);
        ɵɵtextInterpolate(ctx.totalPages);
        ɵɵadvance(1);
        ɵɵclassProp("ag-disabled", ctx.nav[2]);
        ɵɵadvance(2);
        ɵɵclassProp("ag-disabled", ctx.nav[3]);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatusBarPaginationComponent, [{
        type: Component,
        args: [{
                selector: 'vias-datagrid-statusbar-pagination',
                template: `<span class="ag-paging-page-summary-panel" role="presentation">
    <div ref="btFirst" class="ag-paging-button" [class.ag-disabled]="nav[0]" role="button" aria-label="İlk sayfa" tabindex="0" (click)="onFirst()">
        <span class="ag-icon ag-icon-first" unselectable="on" role="presentation"></span>
    </div>
    <div ref="btPrevious" class="ag-paging-button" [class.ag-disabled]="nav[1]" role="button" aria-label="Önceki sayfa" tabindex="0" (click)="onPrevious()">
        <span class="ag-icon ag-icon-previous" unselectable="on" role="presentation"></span>
    </div>
    <span class="ag-paging-description" aria-hidden="false">
        <span id="ag-30-start-page">Sayfa </span>
        <span id="ag-30-start-page-number" ref="lbCurrent" class="ag-paging-number">{{currentPage}}</span>
        <span id="ag-30-of-page"> / </span>
        <span id="ag-30-of-page-number" ref="lbTotal" class="ag-paging-number">{{totalPages}}</span>
    </span>
    <div ref="btNext" class="ag-paging-button" [class.ag-disabled]="nav[2]" role="button" aria-label="Sonraki Sayfa" tabindex="0" (click)="onNext()">
        <span class="ag-icon ag-icon-next" unselectable="on" role="presentation"></span>
    </div>
    <div ref="btLast" class="ag-paging-button" [class.ag-disabled]="nav[3]" role="button" aria-label="Son Sayfa" tabindex="0" (click)="onLast()">
        <span class="ag-icon ag-icon-last" unselectable="on" role="presentation"></span>
    </div>
</span>`,
            }]
    }], null, null); })();

class StatusBarTotalsComponent {
    constructor(globalService) {
        this.globalService = globalService;
        // nav disabled   ilk   once  sonra  son // PageDirection
        this.nav = [];
        this.summaryValue = '';
        this.pageChange = new EventEmitter();
    }
    agInit(params) {
        this.params = params;
        this.params.api.addEventListener(Events.EVENT_ROW_DATA_CHANGED, this.onModelChange.bind(this));
        this.params.api.addEventListener('gridReady', this.onGridReady.bind(this));
        // this.params.api.addEventListener('paginationChanged', this.onPaginationChanged.bind(this));
    }
    onGridReady($event) {
        console.log($event);
    }
    onModelChange(params) {
        this.params = params;
        let sumString = '';
        let valueRecieved = false;
        if (this.params.api['statusBarService'].allComponents.StatusPanelTotals._params.summaryData !== undefined) {
            // tslint:disable-next-line: max-line-length
            const x = this.params.api['statusBarService'].allComponents.StatusPanelTotals._params.summaryData;
            x.forEach(sD => {
                // sumString += '<div class="ag-status-name-value"> ';
                // sumString += ' <span ref="eLabel">';
                sumString += sD.title + ' : '; // </span>:&nbsp;';
                // sumString += '<span ref="eValue" class="ag-status-name-value-value">';
                let sumTotal = 0;
                let rowCount = 0;
                this.params.api.forEachNode((rowNode) => {
                    if (rowNode !== undefined) {
                        valueRecieved = true;
                        if (rowNode.data[sD.field] !== undefined) {
                            let rowTotal = 0;
                            if (sD.sumTotalFunction !== undefined) {
                                rowTotal = sD.sumTotalFunction(rowNode.data);
                            }
                            else {
                                rowTotal = rowNode.data[sD.field] * 1;
                            }
                            sumTotal += rowTotal;
                            rowCount++;
                        }
                    }
                });
                if (rowCount > 0) {
                    switch (sD.aggFunc) {
                        case AgrFuncs.count:
                            sumString += rowCount;
                            break;
                        case AgrFuncs.avrg:
                            sumString += this.globalService.numberFormatter(sumTotal / rowCount);
                            break;
                        case AgrFuncs.sum:
                        default:
                            sumString += this.globalService.numberFormatter(sumTotal);
                            break;
                    }
                    sumString += ' ';
                    if (sD.unitName.length > 0) {
                        sumString += sD.unitName;
                    }
                }
                sumString += ' ';
                // sumString += '</span></div>';
            });
        }
        if (valueRecieved) {
            this.summaryValue = sumString;
        }
    }
}
StatusBarTotalsComponent.ɵfac = function StatusBarTotalsComponent_Factory(t) { return new (t || StatusBarTotalsComponent)(ɵɵdirectiveInject(GlobalsService)); };
StatusBarTotalsComponent.ɵcmp = ɵɵdefineComponent({ type: StatusBarTotalsComponent, selectors: [["vias-datagrid-statusbar-pagination"]], decls: 2, vars: 1, consts: [[1, "ag-status-name-value", "ag-status-panel", "ag-status-panel-total-and-filtered-row-count"]], template: function StatusBarTotalsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtext(1);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵtextInterpolate(ctx.summaryValue);
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(StatusBarTotalsComponent, [{
        type: Component,
        args: [{
                selector: 'vias-datagrid-statusbar-pagination',
                template: `<div class="ag-status-name-value ag-status-panel ag-status-panel-total-and-filtered-row-count">{{summaryValue}}</div>`,
            }]
    }], function () { return [{ type: GlobalsService }]; }, null); })();

const _c0$4 = ["agGrid"];
function DatagridComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 11);
    ɵɵelementStart(1, "button", 12);
    ɵɵlistener("click", function DatagridComponent_div_5_Template_button_click_1_listener() { ɵɵrestoreView(_r7); const ctx_r6 = ɵɵnextContext(); return ctx_r6.restoreState(); });
    ɵɵtext(2, "Tablo Ayarlar\u0131n\u0131 Y\u00FCkle");
    ɵɵelementEnd();
    ɵɵelementStart(3, "button", 12);
    ɵɵlistener("click", function DatagridComponent_div_5_Template_button_click_3_listener() { ɵɵrestoreView(_r7); const ctx_r8 = ɵɵnextContext(); return ctx_r8.resetState(); });
    ɵɵtext(4, "Tablo Ayarlar\u0131n\u0131 S\u0131f\u0131rla");
    ɵɵelementEnd();
    ɵɵelementStart(5, "button", 12);
    ɵɵlistener("click", function DatagridComponent_div_5_Template_button_click_5_listener() { ɵɵrestoreView(_r7); const ctx_r9 = ɵɵnextContext(); return ctx_r9.editColumns(); });
    ɵɵtext(6, "Tablo Ayarlar\u0131");
    ɵɵelementEnd();
    ɵɵelementEnd();
} }
function DatagridComponent_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 13);
    ɵɵlistener("click", function DatagridComponent_button_10_Template_button_click_0_listener() { ɵɵrestoreView(_r11); const ctx_r10 = ɵɵnextContext(); return ctx_r10.selectedClicked(); });
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, "select"));
} }
function DatagridComponent_button_11_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r12.dgButtonsInit.addBtnIcon);
} }
function DatagridComponent_button_11_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 14);
    ɵɵlistener("click", function DatagridComponent_button_11_Template_button_click_0_listener() { ɵɵrestoreView(_r14); const ctx_r13 = ɵɵnextContext(); return ctx_r13.addClicked(); });
    ɵɵtemplate(1, DatagridComponent_button_11_mat_icon_1_Template, 2, 1, "mat-icon", 15);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("color", ctx_r3.dgButtonsInit.addBtnColor);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r3.dgButtonsInit.addBtnIcon);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 3, ctx_r3.dgButtonsInit.addBtnText), "");
} }
function DatagridComponent_button_12_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r15.dgButtonsInit.editBtnIcon);
} }
function DatagridComponent_button_12_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 16);
    ɵɵlistener("click", function DatagridComponent_button_12_Template_button_click_0_listener() { ɵɵrestoreView(_r17); const ctx_r16 = ɵɵnextContext(); return ctx_r16.editClicked(); });
    ɵɵtemplate(1, DatagridComponent_button_12_mat_icon_1_Template, 2, 1, "mat-icon", 15);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵproperty("color", ctx_r4.dgButtonsInit.editBtnColor);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r4.dgButtonsInit.editBtnIcon);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 3, ctx_r4.dgButtonsInit.editBtnText), " ");
} }
function DatagridComponent_button_13_mat_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r18 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ctx_r18.dgButtonsInit.deleteBtnIcon);
} }
function DatagridComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 16);
    ɵɵlistener("click", function DatagridComponent_button_13_Template_button_click_0_listener() { ɵɵrestoreView(_r20); const ctx_r19 = ɵɵnextContext(); return ctx_r19.deleteClicked(); });
    ɵɵtemplate(1, DatagridComponent_button_13_mat_icon_1_Template, 2, 1, "mat-icon", 15);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵɵnextContext();
    ɵɵproperty("color", ctx_r5.dgButtonsInit.deleteBtnColor);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", ctx_r5.dgButtonsInit.deleteBtnIcon);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(3, 3, ctx_r5.dgButtonsInit.deleteBtnText), " ");
} }
var AgrFuncs;
(function (AgrFuncs) {
    AgrFuncs[AgrFuncs["sum"] = 0] = "sum";
    AgrFuncs[AgrFuncs["avrg"] = 1] = "avrg";
    AgrFuncs[AgrFuncs["count"] = 2] = "count";
})(AgrFuncs || (AgrFuncs = {}));
var SortType;
(function (SortType) {
    SortType["Ascending"] = "asc";
    SortType["Descending"] = "desc";
})(SortType || (SortType = {}));
var PageDirection;
(function (PageDirection) {
    PageDirection[PageDirection["First"] = 0] = "First";
    PageDirection[PageDirection["Previous"] = 1] = "Previous";
    PageDirection[PageDirection["Next"] = 2] = "Next";
    PageDirection[PageDirection["Last"] = 3] = "Last";
})(PageDirection || (PageDirection = {}));
class DatagridComponent {
    constructor(next, route, storage, globals, viasService, dialog, translate) {
        this.next = next;
        this.route = route;
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.dialog = dialog;
        this.translate = translate;
        this.numLocale = '';
        this.dgWidth = '97%';
        this.dgHeight = '85vh';
        this.cellEditorParams = '';
        this.singleEdit = '';
        this.changeCol = null;
        this.dgColumnsArray = [];
        this.currentPage = 1;
        this.totalPages = 1;
        this.options = {};
        this.hasStateButtons = true;
        this.enableCharts = false;
        this.refresh = new EventEmitter();
        this.rowClick = new EventEmitter();
        this.dblClick = new EventEmitter();
        this.selectClick = new EventEmitter();
        this.selectChange = new EventEmitter();
        this.addClick = new EventEmitter();
        this.editClick = new EventEmitter();
        this.deleteClick = new EventEmitter();
        this.cellChange = new EventEmitter();
        this.columnStateChange = new EventEmitter();
        this.gridReady = new EventEmitter();
        this.contexMenuAction = new EventEmitter();
        this.dgButtonsInit = {
            hasAddBtn: false,
            hasEditBtn: false,
            hasDeleteBtn: false,
            addBtnText: 'add',
            editBtnText: 'edit',
            deleteBtnText: 'delete',
            addBtnColor: 'primary',
            editBtnColor: 'primary',
            deleteBtnColor: 'warn',
            addBtnIcon: '',
            editBtnIcon: '',
            deleteBtnIcon: '',
        };
        this.theme = 'ag-theme-balham';
        this.isMultipleSelect = false;
        this.columnDefs = [];
        this.statusBar = {
            statusPanels: [
                {
                    statusPanel: 'StatusPanelTotals',
                    statusPanelParams: {
                        summaryData: [],
                    },
                    align: 'left',
                },
                {
                    statusPanel: 'agAggregationComponent',
                    align: 'center',
                    statusPanelParams: {
                        aggFuncs: ['count', 'sum', 'min', 'max', 'avg'],
                    },
                },
                {
                    statusPanel: 'StatusPanelPagination',
                    align: 'right',
                },
            ],
        };
        this.sideBar = {
            toolPanels: [
                {
                    id: 'columns',
                    labelDefault: 'Columns',
                    labelKey: 'columns',
                    iconKey: 'columns',
                    toolPanel: 'agColumnsToolPanel',
                    toolPanelParams: {
                        suppressColumnMove: false,
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: false,
                        suppressColumnFilter: false,
                        suppressColumnSelectAll: false,
                        suppressColumnExpandAll: false,
                    },
                },
                {
                    id: 'filters',
                    labelDefault: 'Filters',
                    labelKey: 'filters',
                    iconKey: 'filter',
                    toolPanel: 'agFiltersToolPanel',
                },
                {
                    id: 'actionsBar',
                    labelDefault: 'İşlemler',
                    labelKey: 'customStats',
                    iconKey: 'columns',
                    toolPanel: 'ActionsSideToolBar',
                    sideMenuItems: [],
                    toolPanelParams: {
                        suppressColumnMove: false,
                        suppressRowGroups: true,
                        suppressValues: true,
                        suppressPivots: true,
                        suppressPivotMode: true,
                        suppressSideButtons: false,
                        suppressColumnFilter: false,
                        suppressColumnSelectAll: false,
                        suppressColumnExpandAll: false,
                    },
                },
            ],
            position: 'left',
            defaultToolPanel: '',
            hiddenByDefault: false,
        };
        this.defaultColDef = {
            sortable: true,
            resizable: true,
            menuTabs: ['filterMenuTab', 'generalMenuTab'],
        };
        this.emptyErrorText = '';
        this.firstLoadError = '';
        this.textFilterParams = {
            filterOptions: ['equals', 'contains', 'startsWith', 'endsWith'],
            defaultOption: 'contains',
            defaultJoinOperator: 'OR',
            newRowsAction: 'keep',
            // turkce karakter duzenleme
            textFormatter: (value) => {
                return value
                    .toLowerCase()
                    .replace(/\s/g, '')
                    .replace(/[àáâãäå]/g, 'a')
                    .replace(/æ/g, 'ae')
                    .replace(/ç/g, 'c')
                    .replace(/ş/g, 's')
                    .replace(/ğ/g, 'g')
                    .replace(/[èéêë]/g, 'e')
                    .replace(/[ìíîïİı]/g, 'i')
                    .replace(/ñ/g, 'n')
                    .replace(/[òóôõö]/g, 'o')
                    .replace(/œ/g, 'oe')
                    .replace(/[ùúûü]/g, 'u')
                    .replace(/[ýÿ]/g, 'y')
                    .replace(/\W/g, '');
            },
        };
        this.idFilterParams = {
            filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
            defaultOption: 'equals',
            defaultJoinOperator: 'OR',
            newRowsAction: 'keep',
            // filtre icine sadece rakam girilebilir
            allowedCharPattern: '\\d',
        };
        this.numericFilterParams = {
            filterOptions: ['equals', 'lessThanOrEqual', 'greaterThanOrEqual'],
            defaultOption: 'equals',
            defaultJoinOperator: 'AND',
            newRowsAction: 'keep',
            // filtre icine sadece rakam virgul ve eksi isareti girilebilir
            allowedCharPattern: '\\d\\-\\,',
            // filtre icine yazilan virgullu degeri noktali degere ceviriyor
            numberParser(text) {
                return text == null ? null : parseFloat(text.replace(',', '.'));
            },
        };
        this.dateFilterParams = {
            filterOptions: [
                'inRange',
                'equals',
                'lessThanOrEqual',
                'greaterThanOrEqual',
            ],
            defaultOption: 'equals',
            alwaysShowBothConditions: false,
            suppressAndOrCondition: true,
            newRowsAction: 'keep',
            minValidYear: 2016,
        };
        this.defaultExcelExportParams = {
            processCellCallback: (params) => {
                const coldef = params.column.getColDef();
                if (coldef.valueFormatter) {
                    const valForm = Object.assign(Object.assign({}, params), { data: params.node.data, node: params.node, colDef: params.column.getColDef() });
                    if (typeof coldef.valueFormatter === 'function') {
                        return coldef.valueFormatter(valForm);
                    }
                }
                return params.value;
                const rowIndex = 1;
                const valueGetter = params.column.getColDef().valueGetter;
                return !!valueGetter
                    ? `=CONCATENATE(A${rowIndex}, " ", B${rowIndex})`
                    : params.value;
            },
        };
        this.excelStyles = [
            {
                id: 'date',
                dataType: FieldTypes.DatePicker,
                numberFormat: { format: 'd.mm.yyyy' },
            },
            {
                id: 'dateTime',
                dataType: FieldTypes.Time,
                numberFormat: { format: 'd.mm.yyyy hh:mm:ss' },
            },
        ];
        this.pagination = true;
        this.pageChangeSubscribed = false;
        this.filterHasRun = false;
        this.pageHasChanged = false;
        //console.log('+___+1');
        this.frameworkComponents = {
            ActionsSideToolBar: ActionsSideToolBarComponent,
            StatusPanelPagination: StatusBarPaginationComponent,
            StatusPanelTotals: StatusBarTotalsComponent,
        };
        this.gridOptions = {
            rowSelection: 'single',
            rowBuffer: 75,
            suppressNoRowsOverlay: true
        };
        //   this.themeService.user$.subscribe((thme) => {
        // 	this.isDarkTheme = thme.dark;
        // 	if (this.isDarkTheme === true) {
        // 	  this.theme = 'ag-theme-balham-dark';
        // 	} else {
        // 	  this.theme = 'ag-theme-balham';
        // 	}
        //   });
    }
    ngOnChanges(changes) {
        //console.log('+___+2');
        if (this.numLocale === 'en-US') {
            this.localeText = AG_GRID_LOCALE_EN;
        }
        else {
            // tr-TR
            this.localeText = AG_GRID_LOCALE_TR;
        }
        if (this.changeCol) {
            const coldef = this.setCol(this.changeCol, 1);
            this.columnDefs.forEach((col, i) => {
                if (col.field === coldef.field) {
                    col.filterParams = coldef.filterParams;
                    col.cellEditorParams = coldef.cellEditorParams;
                }
            });
            this.gridApi.setColumnDefs(this.columnDefs);
            return;
        }
        if (this.options['sidebarVisible'] !== undefined) {
            this.sideBar.hiddenByDefault = !this.options['sidebarVisible'];
        }
        if (this.options['sortObj'] !== undefined) {
            this.sort = this.options['sortObj'];
        }
        if (this.options['locale'] === undefined) {
            this.options['locale'] = this.numLocale;
        }
        if (this.options['emptyErrorText'] !== undefined) {
            this.emptyErrorText = this.options['emptyErrorText'];
        }
        if (this.options['firstLoadError'] !== undefined) {
            this.firstLoadError = this.options['firstLoadError'];
        }
        // dg butonstan gelenleri guncelle
        if (this.dgButtons !== undefined) {
            for (const x in this.dgButtons) {
                this.dgButtonsInit[x] = this.dgButtons[x];
            }
        }
        if (this.options['functionsReadOnly'] !== undefined) {
            if (this.options['functionsReadOnly']) {
                this.gridApi.setFunctionsReadOnly(true);
                this.dgButtonsInit = {
                    hasAddBtn: false,
                    hasEditBtn: false,
                    hasDeleteBtn: false,
                    addBtnText: 'add',
                    editBtnText: 'edit',
                    deleteBtnText: 'delete',
                };
            }
        }
        if (this.options['rowStyleFunc'] !== undefined) {
            this.rowStyleFunc = this.options['rowStyleFunc'];
        }
        // basliklari duzenle
        // eger baslik bir daha gelirse
        // ve eskisi ile ayni ise degistrime
        if (this.dgColumnsArray !== this.columns) {
            this.dgColumnsArray = this.columns;
            this.columnDefs = [];
            this.dgColumnsArray.forEach((col, i) => {
                const coldef = this.setCol(col, i);
                this.columnDefs.push(coldef);
            });
        }
        if (this.gridApi !== undefined) {
            // console.log('+___+3');
            if (this.filterHasRun) {
                this.onFilterRun();
            }
            if (this.options['multipleRowSelection'] !== undefined &&
                this.options['multipleRowSelection'] === true) {
                this.gridOptions.rowSelection = 'multiple';
                this.isMultipleSelect = true;
            }
            else {
                this.gridOptions.rowSelection = 'single';
            }
            if (this.contextMenuItems !== undefined) {
                this.gridOptions.contextMenuItems = this
                    .contextMenuItems;
                this.gridOptions.getContextMenuItems = this.getContextMenuItems.bind(this);
            }
            if (this.sideMenuItems !== undefined) {
                this.sideMenuItems.forEach((smi) => {
                    smi.filters = this.filterModel;
                });
                this.sideBar.toolPanels[2].sideMenuItems = this.sideMenuItems;
                this.gridApi.setSideBar(this.sideBar);
            }
            if (this.statusBarItems !== undefined) {
                const panel = this.gridApi.statusBarService.getStatusPanel('StatusPanelTotals');
                panel._params.summaryData = this.statusBarItems;
                this.gridApi.statusBarService.registerStatusPanel('StatusPanelTotals', panel);
            }
            if (this.options['treeData'] !== undefined) {
                this.gridOptions.treeData = this.options['treeData']; // boolean
                this.gridOptions.groupDefaultExpanded = 0; // -1 hepsi açık // 0 hepsi kapalı // 1 en dıştaki başlıklar açık
                if (this.options['groupDefaultExpanded'] !== undefined) {
                    this.gridOptions.groupDefaultExpanded =
                        this.options['groupDefaultExpanded'];
                }
                if (this.options['getDataPath'] !== undefined) {
                    // Gruplamanın hangi alandan oluşacağı belirleyen fonksiyon
                    this.gridOptions.getDataPath = this.options['getDataPath'];
                }
                if (this.options['autoGroupColumnDef'] !== undefined) {
                    // Gruplanacak alan özellkleri dgcolumn a değil buraya tanımlanıyor
                    this.gridOptions.autoGroupColumnDef =
                        this.options['autoGroupColumnDef'];
                }
            }
            // if (this.options['rowClassRules'] !== undefined){
            //   this.rowClassRules = this.options['rowClassRules'];
            //   this.gridOptions.rowClassRules = this.options['rowClassRules'];
            // }else{
            //   this.gridOptions.rowClassRules = this.rowClassRules;
            // }
            if (this.rowClassRules !== undefined) {
                this.gridOptions.rowClassRules = this.rowClassRules;
            }
            this.gridOptions.suppressCellSelection = false;
            this.gridOptions.overlayLoadingTemplate =
                '<div class="ag-overlay-loading-center" style="border:0px;">' +
                    '<img src="assets/images/vias_animated_loading.gif" width="50%" border="0"/><br/><span>Veriler Yükleniyor</span></div>';
            this.gridOptions.overlayNoRowsTemplate =
                '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">' +
                    (this.firstLoadError === ''
                        ? this.emptyErrorText
                        : this.firstLoadError) +
                    '</span>';
            this.gridOptions.api.showLoadingOverlay();
            // this.gridOptions.api.resetRowHeights();
            // if (this.originalFilterModel !== undefined){
            //   console.log('+___+3.5 filter set');
            //   this.gridOptions.api.setFilterModel( this.originalFilterModel );
            // }
            // veri geldi
            if (this.columns.length > 0) {
                // console.log('+___+6');
            }
            if (this.dataSource.length > 0) {
                // console.log('+___+7');
                // data geldi. ilk bos hatasini sil
                this.options['firstLoadError'] = '';
            }
            if (changes.columnState) {
                // console.log(changes);
                // this.columnState = changes.columnState.currentValue;
                setTimeout(() => {
                    this.gridColumnApi.applyColumnState({
                        state: changes.columnState.currentValue,
                        applyOrder: true,
                    });
                }, 300);
            }
            else if (this.columnState !== undefined &&
                this.columnState.length > 0) {
                // console.log(changes);
                // this.columnState = changes.columnState.currentValue;
                setTimeout(() => {
                    this.gridColumnApi.applyColumnState({
                        state: this.columnState,
                        applyOrder: true,
                    });
                }, 300);
            }
        }
        else {
            if (this.options['multipleRowSelection'] !== undefined &&
                this.options['multipleRowSelection'] === true) {
                this.gridOptions.rowSelection = 'multiple';
                this.isMultipleSelect = true;
            }
            else {
                this.gridOptions.rowSelection = 'single';
            }
            if (this.statusBarItems !== undefined) {
                this.statusBar.statusPanels[0].statusPanelParams.summaryData =
                    this.statusBarItems;
            }
            if (this.options['treeData'] !== undefined) {
                this.gridOptions.treeData = this.options['treeData']; // boolean
                this.gridOptions.groupDefaultExpanded = 0; // -1 hepsi açık // 0 hepsi kapalı // 1 en dıştaki başlıklar açık
                if (this.options['groupDefaultExpanded'] !== undefined) {
                    this.gridOptions.groupDefaultExpanded =
                        this.options['groupDefaultExpanded'];
                }
                if (this.options['getDataPath'] !== undefined) {
                    // Gruplamanın hangi alandan oluşacağı belirleyen fonksiyon
                    this.gridOptions.getDataPath = this.options['getDataPath'];
                }
                if (this.options['autoGroupColumnDef'] !== undefined) {
                    // Gruplanacak alan özellkleri dgcolumn a değil buraya tanımlanıyor
                    this.gridOptions.autoGroupColumnDef =
                        this.options['autoGroupColumnDef'];
                }
            }
        }
    }
    onGridReady(params) {
        // console.log('+___+4');
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridReady.emit({
            dgApi: params.api,
        });
        //   this.themeService.user$.subscribe((thme) => {
        // 	this.isDarkTheme = thme.dark;
        // 	if (this.isDarkTheme === true) {
        // 	  this.theme = 'ag-theme-balham-dark';
        // 	} else {
        // 	  this.theme = 'ag-theme-balham';
        // 	}
        //   });
        // this.ngOnChanges('');
    }
    onRowDataChanged(params) {
        // console.log('burasi' + params);
        // this.gridOptions.api.ensureIndexVisible(
        //   this.gridApi.getSelectedRows(),
        //   'bottom'
        // );
    }
    setCol(col, i) {
        // sutunda bir params degiskeni lazimdi.
        // bu bos duruyor, dolayisiyla
        // diger degiskenleri de colStyles a  koyuyoruz
        const colStyles = [];
        // orn. lang locale
        colStyles['numLocale'] = this.numLocale;
        const coldef = {
            headerName: col.headerText,
            field: col.dataField,
            filterParams: {
                filterField: col.filterField,
                filterDataIdField: col.filterDataIdField,
                filterDataLabelField: col.filterDataLabelField,
                filterDataSource: [],
                values: [],
                closeOnApply: true,
                buttons: ['clear', 'reset'],
                debounceMs: 700,
                showTooltips: true,
                isLocalRefresh: this.options['isLocalRefresh'] ? true : false,
            },
        };
        if (col.noHeaderIcons !== undefined) {
            coldef.headerComponentParams = {
                template: '<div class="ag-cell-label-container" role="presentation">' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>' +
                    '  </div>' +
                    '</div>',
            };
        }
        if (col.align !== undefined) {
            colStyles['text-align'] = col.align;
        }
        if (col.sticky !== undefined) {
            coldef.lockPinned = col.sticky;
            if (col.sticky) {
                coldef.pinned = 'left';
            }
        }
        if (col.width !== undefined) {
            coldef.width = col.width;
            coldef.minWidth = col.width;
        }
        if (col.wrap !== undefined) {
            coldef.flex = 1;
            coldef.wrapText = col.wrap;
            coldef.autoHeight = col.wrap ? true : false;
        }
        if (col.labelFunction !== undefined) {
            coldef.valueGetter = col.labelFunction;
        }
        if (col.cellEditorParams !== undefined) {
            coldef.valueGetter = col.cellEditorParams;
        }
        if (col.columnColor !== undefined) {
            colStyles['color'] = col.columnColor;
        }
        if (col.columnBackgroundColor !== undefined) {
            colStyles['backgroundColor'] = col.columnBackgroundColor;
        }
        if (this.options['hasSelectButton'] !== undefined) {
            if (this.options['hasSelectButton'] === true && i === 0) {
                coldef.checkboxSelection = true;
            }
        }
        if (this.options['checkboxSelection'] !== undefined) {
            if (this.options['checkboxSelection'] === true && i === 0) {
                coldef.checkboxSelection = true;
            }
        }
        ////////////////////////////
        //    FILTRELER
        ////////////////////////////
        // ID alani
        if (col.dataType === FieldTypes.Id) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agNumberColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.idFilterParams);
            colStyles['text-align'] = 'right';
            // Numerik
        }
        else if (col.dataType === FieldTypes.Number) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agNumberColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.numericFilterParams);
            colStyles['text-align'] = 'right';
            coldef.valueFormatter = this.numberFormatter;
            // coldef.filter = 'NumericFilter';
            // döviz
        }
        else if (col.dataType === FieldTypes.Currency) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agNumberColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.numericFilterParams);
            // coldef.filter = 'agNumberColumnFilter';
            colStyles['text-align'] = 'right';
            coldef.valueFormatter = this.currencyFormatter;
            // coldef.filter = 'NumericFilter';
            // eger currency yada unit var ise bu alandan degiskeni alacagiz...
            if (col.unitField !== undefined) {
                colStyles['currencyField'] = col.unitField;
            }
            else if (col.unitDataSource !== undefined) {
                colStyles['currencyDataSource'] = col.unitDataSource;
            }
            else {
                if (col.currencyLeftField !== undefined) {
                    colStyles['currencyLeftField'] = col.currencyLeftField;
                }
                if (col.currencyRightField !== undefined) {
                    colStyles['currencyRightField'] = col.currencyRightField;
                }
            }
            // Birim
        }
        else if (col.dataType === FieldTypes.Unit) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agNumberColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.numericFilterParams);
            colStyles['text-align'] = 'right';
            coldef.valueFormatter = this.unitFormatter;
            // coldef.filter = 'NumericFilter';
            // eger currency yada unit var ise bu alandan degiskeni alacagiz...
            if (col.unitField !== undefined) {
                colStyles['unitField'] = col.unitField;
            }
            else if (col.unitDataSource !== undefined) {
                colStyles['unitDataSource'] = col.unitDataSource;
            }
            // Tarih
        }
        else if (col.dataType === FieldTypes.DatePicker) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agDateColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.dateFilterParams);
            coldef.valueFormatter = this.dateFormatter;
            coldef.cellClass = 'date';
            colStyles['text-align'] = 'right';
            // coldef.filter = 'DateFilter';
            // Saat
        }
        else if (col.dataType === FieldTypes.Time) {
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agNumberColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.numericFilterParams);
            // coldef.filter = 'agDateColumnFilter';
            coldef.cellClass = 'dateTime';
            coldef.valueFormatter = this.timeFormatter;
            colStyles['text-align'] = 'right';
            // AutoComplete
            // DropDown
        }
        else if (col.dataType === FieldTypes.AutoComplete ||
            col.dataType === FieldTypes.DropDown) {
            // coldef.filter = 'agMultiColumnFilter';
            //   coldef.filter = 'agSetColumnFilter';
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agSetColumnFilter';
            // // coldef.filter = 'agSetFilter';
            coldef.filterParams.values = [];
            // (coldef.filterParams.buttons = ['apply', 'clear', 'reset']),
            coldef.filterParams.filterDataSource = [];
            //   coldef.filterParams.isLocalRefresh = true;
            coldef.valueFormatter = this.idLabelFunction;
            coldef.valueGetter = (params) => {
                return params.data[params.column.getColId()];
            };
            if (col.filterDataSourceFunc !== undefined) {
                coldef.filterParams.filterField = col.filterField;
            }
            if (col.filterDataSource !== undefined) {
                coldef.filterParams.filterDataSource = col.filterDataSource;
                // coldef.filterParams.values = col.filterDataSource;
                col.filterDataSource.forEach((fo) => {
                    coldef.filterParams.values.push(fo.label);
                });
                // console.log(Array.isArray(coldef.filterParams.values));
                // coldef.valueFormatter = this.idLabelFunction;
            }
            // coldef.filterValueGetter = (params) =>{
            //   return   params.data[params.column.getColId()];
            // }
            // coldef.filterParams.
            coldef.filterParams.keyCreator = (params) => {
                return params.value.value;
            };
            coldef.filterParams.valueFormatter = (params) => {
                return params.value;
                // console.log(Array.isArray(params.coldef.filterParams.values));
                // if(params.value == "[object Object]"){
                //   return params.colDef.filterParams.filterDataSource.map(h=>h.label).toString().replaceAll(","," , ")
                // }else{
                //   return params.value.label;
                // }
            };
            // coldef.filterParams.valueFormatter = this.idLabelFunction;
            // } else if (col.dataType === FieldTypes.DropDown) {
            //   // coldef.filter = 'DropDownFilter';
            //   // coldef.filter = 'DgFilter';
            //   // coldef.filter = 'AutoCompleteFilter';
            //   coldef.filter = 'agMultiColumnFilter';
            // coldef.filter = 'agMultiColumnFilter';
            // coldef.filterParams = { ...coldef.filterParams, ...this.textFilterParams };
            // coldef.keyCreator = this.dropdownKeyCreator;
            // coldef.valueFormatter = this.dropdownValueFormatter;
            //   coldef.filterParams = { ...coldef.filterParams, ...this.textFilterParams };
            //   coldef.keyCreator = this.dropdownKeyCreator;
            //   coldef.valueFormatter = this.dropdownValueFormatter;
            //   if (col.filterDataSource !== undefined) {
            //     coldef.filterParams.values = col.filterDataSource as Array<FilterOptions>;
            //     // coldef.filterParams.filterDataSource = col.filterDataSource;
            //   } else {
            //     coldef.filterParams.values = [{label: '', value: -1}];
            //     // coldef.filterParams.filterDataSource = [];
            //   }
            // Text
        }
        else {
            // coldef.filter = 'TextFilter'; // 'agTextColumnFilter';
            coldef.filter = this.options['isLocalRefresh']
                ? 'agMultiColumnFilter'
                : 'agTextColumnFilter';
            coldef.filterParams = Object.assign(Object.assign({}, coldef.filterParams), this.textFilterParams);
        }
        // labelfunction yerine filtredeki degerler.
        // orn. contractor_id, project_id, unit_id vs
        if (col.labelFunctionIsFilter) {
            coldef.valueFormatter = this.idLabelFunction;
        }
        if (col.fractionDigits !== undefined) {
            colStyles['fractionDigits'] = col.fractionDigits;
        }
        ////////////////////////////
        //    EDITLER
        ////////////////////////////
        if (col.editable !== undefined) {
            if (col.editable) {
                coldef.editable = col.editable;
                coldef.cellEditorParams = {};
                if (col.dataType !== undefined) {
                    if (col.dataType === FieldTypes.AutoComplete) {
                        coldef.cellEditor = 'agRichSelectCellEditor';
                        // coldef.cellRenderer = 'EditorAutoComplate';
                        coldef.cellEditorParams.values = [];
                        coldef.valueSetter = (params) => {
                            var _a;
                            params.data[col.dataField] = (_a = col.editDataSource.find((refData) => refData.label === params.newValue)) === null || _a === void 0 ? void 0 : _a.value;
                            return true;
                        };
                        if (col.filterConnectedField !== undefined) {
                            coldef.cellEditorParams = (params) => {
                                return {
                                    values: col.editDataSource
                                        .filter((d) => d[col.filterConnectedField] ===
                                        params.data[col.filterConnectedField])
                                        .map((s) => s.label),
                                    formatValue: function (params) {
                                        var _a;
                                        if (!Number.isNaN(params * 1)) {
                                            return (_a = col.editDataSource.find((refData) => refData.value + '' === params + '')) === null || _a === void 0 ? void 0 : _a.label;
                                        }
                                        return params;
                                    },
                                };
                            };
                        }
                        else if (col.editDataSource !== undefined) {
                            coldef.cellEditorParams.values = col.editDataSource.map((s) => s.label);
                            coldef.cellEditorParams.formatValue = (params) => {
                                var _a;
                                if (!Number.isNaN(params * 1)) {
                                    return (_a = col.editDataSource.find((refData) => refData.value + '' === params + '')) === null || _a === void 0 ? void 0 : _a.label;
                                }
                                return params;
                            };
                        }
                    }
                    else if (col.dataType === FieldTypes.Text) {
                        if (col.editField === FieldTypes.Number) {
                            coldef.cellEditor = 'EditorDecimalNumeric';
                            coldef.cellEditorParams = {
                                values: col.editDataSource,
                            };
                        }
                        else if (coldef.wrapText === true) {
                            coldef.cellEditor = 'agLargeTextCellEditor';
                            coldef.cellEditorParams = {
                                maxLength: 5000,
                                cols: '50',
                                rows: '6',
                            };
                        }
                        else {
                            coldef.cellEditor = 'agTextCellEditor';
                        }
                    }
                }
            }
        }
        if (col.cellRendererFunc !== undefined) {
            coldef.cellRenderer = col.cellRendererFunc;
        }
        if (col.tooltipValueGetter !== undefined) {
            coldef.tooltipValueGetter = col.tooltipValueGetter;
        }
        if (col.cellStyleFunc !== undefined) {
            coldef.cellStyle = col.cellStyleFunc;
        }
        else {
            if (this.rowStyleFunc !== undefined) {
                coldef.cellStyle = this.rowStyleFunc;
            }
            else {
                coldef.cellStyle = Object.assign({}, colStyles);
            }
        }
        return coldef;
    }
    getRowHeight(params) {
        return params.data.rowHeight;
    }
    onPaginationChanged($event) {
        if (this.totalPages > 0) {
            if (this.gridApi !== undefined) {
                const statusBarComponent = this.gridApi.getStatusPanel('StatusPanelPagination');
                if (statusBarComponent) {
                    const componentInstance = statusBarComponent.getFrameworkComponentInstance();
                    // toplam ve bulundugu sayfayi guncelle
                    componentInstance.currentPage = this.currentPage;
                    componentInstance.totalPages = this.totalPages;
                    // bir kere subscribe oldu ise, bir daha olma
                    if (!this.pageChangeSubscribed) {
                        this.pageChangeSubscribed = true;
                        componentInstance.pageChange.subscribe((arg) => this.onChangePageEvent(arg));
                    }
                    this.gridApi.forEachNode((node) => {
                        if (this.secilmislerKlubu !== undefined) {
                            this.secilmislerKlubu.forEach((sk) => {
                                if (sk['id'] === node.data.id) {
                                    node.setSelected(true);
                                }
                            });
                        }
                    });
                }
            }
        }
    }
    onChangePageEvent(direction) {
        // console.log(direction);
        let p = 1;
        // directiona gore p ayarla
        switch (direction) {
            default:
            case PageDirection.First:
                p = 1;
                break;
            case PageDirection.Previous:
                p = this.currentPage - 1;
                break;
            case PageDirection.Next:
                p = this.currentPage + 1;
                break;
            case PageDirection.Last:
                p = this.totalPages;
                break;
        }
        // p ye gore sayfayi ayarla
        if (p !== this.currentPage && p <= this.totalPages && p >= 1) {
            this.currentPage = p;
            this.pageHasChanged = true;
            // checkbox verisini guncelle
            this.addToSecilmislerKlubu(this.gridApi.getSelectedRows());
            // sayfaya git
            this.prepareRefreshEvent(this.gridApi);
        }
    }
    onGridSort(event) {
        if (!this.options['isLocalRefresh']) {
            // event.stopPropagation();
            // event.preventDefault();
            //   this.prepareRefreshEvent(event.api);
        }
    }
    // uygulanan filtre dbden gelince calisiyor
    onFilterRun() {
        // gelen veriler ile data type esleme problemi icin
        // once butun filtreleri bir temizliyoruz.
        // grid api icindeki setfilter ayni zamanda calistiuriyor
        this.gridApi.setFilterModel(null);
        // sonra daha once kaydettigimiz orijinal halini geri yukluyoruz
        // tslint:disable-next-line: forin
        for (const key in this.originalFilterModel) {
            this.gridApi.getFilterInstance(key, (filter) => {
                const colDef = this.gridApi.getColumnDef(key);
                colDef.filter = true;
                // date setfilter vs icin gonderirken yaptiklarimizi geri al
                if (this.originalFilterModel[key].filterType === 'date') {
                    // date from
                    let d = new Date(this.originalFilterModel[key].dateFrom * 1000);
                    this.originalFilterModel[key].dateFrom =
                        d.getFullYear() +
                            '-' +
                            (d.getMonth() + 1) +
                            '-' +
                            d.getDate() +
                            ' 00:00:00';
                    // date to
                    if (this.originalFilterModel[key].dateTo != 0) {
                        d = new Date(this.originalFilterModel[key].dateTo * 1000);
                        this.originalFilterModel[key].dateTo =
                            d.getFullYear() +
                                '-' +
                                (d.getMonth() + 1) +
                                '-' +
                                d.getDate() +
                                ' 00:00:00';
                    }
                }
                else if (this.originalFilterModel[key].filterType === 'set') {
                    const colDef = this.gridApi.getColumnDef(key);
                    const values = [];
                    this.originalFilterModel[key].values.forEach((v) => {
                        const val = colDef.filterParams.filterDataSource.find((x) => x.value === v);
                        if (val !== undefined) {
                            values.push(val.label);
                        }
                    });
                    this.originalFilterModel[key].values = values;
                }
                // ama calistirmiyoruz. calistrimamasi icin geri yuklerken tek tek dolasmak lazim.
                filter.setModel(this.originalFilterModel[key]);
            });
        }
    }
    // filtrelerde b
    onGridFilterModified(event) {
        // console.log(event);
    }
    // filtre ui uzerinden set edilip uygulaya basilinca calisiyor
    onGridFilter(event) {
        if (this.filterHasRun) {
            this.filterHasRun = false;
            event.stopPropagation();
            event.preventDefault();
            return;
        }
        if (!this.options['isLocalRefresh']) {
            if (this.pageHasChanged) {
                this.gridOptions.api.setFilterModel(this.originalFilterModel);
                this.pageHasChanged = false;
                event.stopPropagation();
                event.preventDefault();
                return;
            }
            // event.stopPropagation();
            // event.preventDefault();
            if (this.originalFilterModel !== event.api.getFilterModel()) {
                // // 1. sayfaya don
                // this.currentPage = 1;
                /* if (event.afterDataChange !== undefined && event.afterDataChange){
                  //this.gridOptions.api.setFilterModel( this.originalFilterModel );
                 // this.filterHasRun = true;
                }else{
                  this.prepareRefreshEvent(event.api);
                }*/
                this.prepareRefreshEvent(event.api);
            }
        }
    }
    prepareRefreshEvent(api) {
        // this.gridOptions.api.showLoadingOverlay();
        // this.gridColumnApi.getColumnState()
        // const sortModel: {
        //   colId: string;
        //   sort: string;
        // }[] = api.getSortModel();
        const sortModel = this.gridColumnApi.getColumnState()
            .filter(col => col.sort) // Sadece sıralanmış sütunları al
            .map(col => ({
            colId: col.colId,
            sort: col.sort,
            sortIndex: col.sortIndex,
        }));
        sortModel.forEach((o) => {
            const colDef = api.getColumnDef(o.colId);
            // sort field alani bul
            this.sort.column_name = this.dgColumnsArray.find((x) => x.dataField === colDef.field).sortField;
            this.sort.sort_type =
                o.sort === 'asc' ? SortType.Ascending : SortType.Descending;
            if (this.dgColumnsArray.find((x) => x.dataField === colDef.field)
                .sortType === undefined) {
                this.dgColumnsArray.find((x) => x.dataField === colDef.field).sortType =
                    SortType.Ascending;
            }
            this.sort.sort_type = this.dgColumnsArray.find((x) => x.dataField === colDef.field).sortType;
            if (this.dgColumnsArray.find((x) => x.dataField === colDef.field)
                .sortType === SortType.Ascending) {
                this.dgColumnsArray.find((x) => x.dataField === colDef.field).sortType =
                    SortType.Descending;
            }
            else {
                this.dgColumnsArray.find((x) => x.dataField === colDef.field).sortType =
                    SortType.Ascending;
            }
        });
        this.filterModel = this.parseFilter(api);
        const e = {
            pageNo: this.currentPage,
            sort: this.sort,
            filters: this.filterModel,
        };
        this.filterHasRun = true;
        this.refresh.emit(e);
    }
    parseFilter(api) {
        const filters = api.getFilterModel();
        this.originalFilterModel = api.getFilterModel();
        const filter = {};
        // console.log(this.gridApi.getFilterModel());
        // tslint:disable-next-line: forin
        for (const key in filters) {
            const colDef = api.getColumnDef(key);
            // veritabanina gonderilecek filter alan adi
            const filterKey = colDef.filterParams.filterField;
            filter[filterKey] = filters[key];
            if (filters[key].filterType === 'date') {
                filter[filterKey].dateFrom =
                    new Date(filters[key].dateFrom).getTime() / 1000;
                filter[filterKey].dateTo =
                    new Date(filters[key].dateTo).getTime() / 1000;
            }
            else if (filters[key].filterType === 'number') {
            }
            else if (filters[key].filterType === 'set') {
                const values = [];
                filter[filterKey].values.forEach((v) => {
                    const val = colDef.filterParams.filterDataSource.find((x) => x.label === v);
                    if (val !== undefined) {
                        values.push(val.value);
                    }
                });
                filter[filterKey].values = values;
            }
        }
        return filter;
    }
    idLabelFunction(params) {
        let txt = '';
        params.colDef.filterParams.filterDataSource.forEach((obj) => {
            if (isNaN(Number(obj.value)) || isNaN(Number(params.value))) {
                if (obj.value === params.value) {
                    txt = obj.label;
                    return txt;
                    // }else if(params.value=="[object Object]"){
                    //   return params.colDef.filterParams.values[obj.value].label;
                }
                // tslint:disable-next-line: radix
            }
            else if (parseFloat(obj.value) === parseFloat(params.value)) {
                txt = obj.label;
                return txt;
                // string , boolean
            }
            else if (obj.value === params.value) {
                txt = obj.label;
                return txt;
            }
        });
        return txt;
    }
    numberFormatter(params) {
        let fractionDigits = 2;
        if (params.colDef.cellStyle.fractionDigits !== undefined) {
            fractionDigits = params.colDef.cellStyle.fractionDigits;
        }
        let val = params.value;
        if (params.value === undefined) {
            val = 0;
        }
        else if (isNaN(val)) {
            const thousandSeparator = Intl.NumberFormat('tr-TR')
                .format(11111)
                .replace(/\p{Number}/gu, '');
            const decimalSeparator = Intl.NumberFormat('tr-TR')
                .format(1.1)
                .replace(/\p{Number}/gu, '');
            val = parseFloat(val
                .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
                .replace(new RegExp('\\' + decimalSeparator), '.'));
        }
        return Intl.NumberFormat('tr-TR', {
            maximumFractionDigits: fractionDigits,
            minimumFractionDigits: fractionDigits,
        }).format(val);
    }
    parseLocaleNumber(stringNumber, locale) {
        const thousandSeparator = Intl.NumberFormat(locale)
            .format(11111)
            .replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale)
            .format(1.1)
            .replace(/\p{Number}/gu, '');
        return parseFloat(stringNumber
            .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
            .replace(new RegExp('\\' + decimalSeparator), '.'));
    }
    currencyFormatter(params) {
        let currencySymbolRight = '';
        let currencySymbolLeft = '';
        // get_currency
        if (params.colDef.cellStyle.currencyDataSource !== undefined) {
            params.colDef.cellStyle.currencyDataSource.forEach((c) => {
                if (c.id === params.colDef.cellStyle.currencyField) {
                    currencySymbolLeft = c.symbol_left;
                    currencySymbolRight = c.symbol_right;
                }
            });
            // currencyRightField orn. customer_symbol_right  contractor_symbol_right
            // currencyLeftField orn. customer_symbol_left contractor_symbol_left
        }
        else if (params.colDef.cellStyle.currencyRightField !== undefined ||
            params.colDef.cellStyle.currencyLeftField !== undefined) {
            if (params.data[params.colDef.cellStyle.currencyRightField] !== undefined) {
                currencySymbolRight =
                    params.data[params.colDef.cellStyle.currencyRightField];
            }
            if (params.data[params.colDef.cellStyle.currencyLeftField] !== undefined) {
                currencySymbolLeft =
                    params.data[params.colDef.cellStyle.currencyLeftField];
            }
            // TL USD vs
        }
        else if (params.colDef.cellStyle.currencyField !== undefined) {
            if (params.data[params.colDef.cellStyle.currencyField] !== undefined) {
                currencySymbolRight =
                    params.data[params.colDef.cellStyle.currencyField];
            }
        }
        return (currencySymbolLeft +
            ' ' +
            Intl.NumberFormat(params.colDef.cellStyle.numLocale, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
            }).format(params.value) +
            ' ' +
            currencySymbolRight);
    }
    unitFormatter(params) {
        let unitName = '';
        // get_units
        if (params.colDef.cellStyle.unitDataSource !== undefined) {
            params.colDef.cellStyle.unitDataSource.forEach((c) => {
                if (c.id === params.colDef.cellStyle.unitField) {
                    unitName = c.symbol_right;
                }
            });
            // unit_name
        }
        else if (params.colDef.cellStyle.unitField !== undefined) {
            if (params.data[params.colDef.cellStyle.unitField] !== undefined) {
                unitName = params.data[params.colDef.cellStyle.unitField];
            }
        }
        return (Intl.NumberFormat(params.colDef.cellStyle.numLocale, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }).format(params.value) +
            ' ' +
            unitName);
    }
    dateFormatter(params) {
        if (params.value == null ||
            params.value === '' ||
            params.value === 0 ||
            params.value === '0' ||
            params.value === undefined) {
            return '-';
        }
        const d = new Date(params.value * 1000);
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
        };
        return d.toLocaleDateString('tr-TR', options);
    }
    timeFormatter(params) {
        const d = new Date(params.value * 1000);
        const options = {
            hour12: false,
            hour: '2-digit',
            minute: '2-digit',
        };
        return d.toLocaleDateString('tr-TR', options);
    }
    dropdownValueFormatter(params) {
        return params.value.value;
    }
    // FilterOptions interface kullaniyor burada
    dropdownKeyCreator(params) {
        return params.value;
        return params.value.value.toString();
    }
    addClicked() {
        this.addClick.emit({});
    }
    editClicked() {
        const selectedRows = this.gridApi.getSelectedNodes();
        if (selectedRows.length > 0) {
            const event = {
                index: selectedRows[0].id,
                item: selectedRows[0].data,
            };
            this.editClick.emit(event);
        }
    }
    deleteClicked() {
        const selectedRows = this.gridApi.getSelectedNodes();
        if (selectedRows.length > 0) {
            const event = {
                index: selectedRows[0].id,
                item: selectedRows[0].data,
            };
            this.deleteClick.emit(event);
        }
    }
    selectedClicked() {
        this.addToSecilmislerKlubu(this.gridApi.getSelectedRows());
        const event = {
            selectedItems: this.secilmislerKlubu,
        };
        this.selectClick.emit(event);
    }
    addToSecilmislerKlubu(selectedRows) {
        if (this.secilmislerKlubu === undefined) {
            this.secilmislerKlubu = [];
        }
        if (selectedRows.length > 0) {
            selectedRows.forEach((sr) => {
                for (const s in this.secilmislerKlubu) {
                    if (this.secilmislerKlubu[s].id === sr.id) {
                        delete this.secilmislerKlubu[s];
                    }
                }
                this.secilmislerKlubu.push(sr);
            });
        }
    }
    onFirstDataRendered($event) {
        // this.setValue('#undoInput', 0);
        // this.disable('#undoInput', true);
        // this.disable('#undoBtn', true);
        // this.setValue('#redoInput', 0);
        // this.disable('#redoInput', true);
        // this.disable('#redoBtn', true);
    }
    disable(id, disabled) {
        document.querySelector(id).disabled = disabled;
    }
    setValue(id, value) {
        document.querySelector(id).value = value;
    }
    onCellValueChanged($event) {
        const event = {
            newValue: $event.newValue,
            columnId: $event.column.colId,
            rowData: $event.data,
        };
        this.cellChange.emit(event);
    }
    getContextMenuItems(params) {
        const customItems = params.api.gridOptionsWrapper.gridOptions.contextMenuItems;
        if (Array.isArray(customItems)) {
            // Flatten array manually using reduce
            const formattedCustomItems = customItems.reduce((acc, item) => {
                if (item.name === 'separator') {
                    // Separator ekle
                    acc.push('separator');
                }
                else if (item && typeof item === 'object' && item.name) {
                    acc.push(Object.assign(Object.assign({}, item), { action: () => {
                            // Gelen action fonksiyonunu çağır ve params'i ilet
                            if (item === null || item === void 0 ? void 0 : item.action) {
                                item.action(params, this.route, this.translate, this.storage, this.globals, this.viasService, this.dialog);
                            }
                        } }));
                }
                else {
                    console.warn('Invalid menu item:', item);
                }
                return acc;
            }, []);
            return [...formattedCustomItems, 'separator', ...params.defaultItems];
        }
        else {
            return params.defaultItems;
        }
    }
    ;
    onContextMenuAction($event) {
        this.contexMenuAction.emit($event);
        // DataGridEvent
    }
    onCellDoubleClicked($event) {
        if ($event.node.selected) {
            const event = {
                index: $event.rowIndex,
                item: $event.data,
            };
            this.dblClick.emit(event);
        }
    }
    /*
      (rowSelected)="onRowSelected($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (gridSizeChanged)="onGridSizeChanged($event)"
      (gridReady)="onGridReady($event)"
      */
    onRowSelected($event) {
        // console.log("onue-sr",this.gridApi.getSelectedRows());
        // console.log("onur-rs",$event);
        if ($event.node.selected) {
            const event = {
                index: $event.rowIndex,
                item: $event.data,
            };
            this.rowClick.emit(event);
        }
    }
    onSelectionChanged($event) {
        // console.log("onur-cs",$event);
        // if ($event !== undefined) {
        //   const event: DataGridEvent = {
        //     index: $event.rowIndex,
        //     item: $event.data
        //   };
        //   this.selec.emit(event);
        // }
        for (const i in $event.api.selectionController.selectedNodes) {
            if ($event.api.selectionController.selectedNodes[i] === undefined) {
                for (const s in this.secilmislerKlubu) {
                    if (this.secilmislerKlubu[s].id ===
                        $event.api.getDisplayedRowAtIndex(i).data.id) {
                        delete this.secilmislerKlubu[s];
                    }
                }
            }
        }
        const selectedRows = this.gridApi.getSelectedRows();
        if (selectedRows !== undefined) {
            const event = {
                selectedItems: selectedRows,
            };
            this.selectChange.emit(event);
        }
    }
    onDataChange($event) {
        const event = {
            pageNo: 1,
            sort: { column_name: 'id', sort_type: SortType.Ascending },
            filters: {},
        };
        this.refresh.emit(event);
    }
    rowClickHandler(index, row) {
        // this.selectedRowIndex = index;
        // this.selectedRowItem = row;
        // const event: DataGridEvent = {
        //   index: this.selectedRowIndex,
        //   item: this.selectedRowItem,
        // };
        // this.rowClick.emit(event);
    }
    onGridSizeChanged(params) {
        // const gridWidth = document.getElementById('dg-container').offsetWidth;
        // const columnsToShow = [];
        // const columnsToHide = [];
        // let totalColsWidth = 0;
        // const allColumns = params.columnApi.getAllColumns();
        // for (let i = 0; i < allColumns.length; i++) {
        //   const column = allColumns[i];
        //   totalColsWidth += column.getMinWidth();
        //   if (totalColsWidth > gridWidth) {
        //     columnsToHide.push(column.colId);
        //   } else {
        //     columnsToShow.push(column.colId);
        //   }
        // }
        // params.columnApi.setColumnsVisible(columnsToShow, true);
        // params.columnApi.setColumnsVisible(columnsToHide, false);
        // params.api.sizeColumnsToFit();
        // params.api.resetRowHeights();
    }
    onColumnResized($event) {
        this.columnStateChange.emit({
            tableId: this.tableId,
            state: this.gridColumnApi.getColumnState(),
        });
        // console.log('column state saved');
    }
    onColumnVisible($event) {
        this.columnStateChange.emit({
            tableId: this.tableId,
            state: this.gridColumnApi.getColumnState(),
        });
        // console.log('column state saved');
    }
    onColumnMoved($event) {
        this.columnStateChange.emit({
            tableId: this.tableId,
            state: this.gridColumnApi.getColumnState(),
        });
        // console.log('column state saved');
    }
    clearFilters() {
        this.gridApi.setFilterModel(null);
    }
    restoreState() {
        if (!this.columnState) {
            // console.log('no columns state to restore by, you must save state first');
            return;
        }
        this.gridColumnApi.applyColumnState({
            state: this.columnState,
            applyOrder: true,
        });
        // console.log('column state restored');
    }
    resetState() {
        this.gridColumnApi.resetColumnState();
        // console.log('column state reset');
    }
    undo() {
        this.gridApi.undoCellEditing();
    }
    redo() {
        this.gridApi.redoCellEditing();
    }
    editColumns() { }
}
DatagridComponent.ɵfac = function DatagridComponent_Factory(t) { return new (t || DatagridComponent)(ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(TranslateService)); };
DatagridComponent.ɵcmp = ɵɵdefineComponent({ type: DatagridComponent, selectors: [["vias-datagrid"]], viewQuery: function DatagridComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$4, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.agGrid = _t.first);
    } }, inputs: { numLocale: "numLocale", dgWidth: "dgWidth", dgHeight: "dgHeight", cellEditorParams: "cellEditorParams", singleEdit: "singleEdit", dataSource: "dataSource", columns: "columns", changeCol: "changeCol", rowClassRules: "rowClassRules", currentPage: "currentPage", totalPages: "totalPages", contextMenuItems: "contextMenuItems", sideMenuItems: "sideMenuItems", statusBarItems: "statusBarItems", options: "options", dgButtons: "dgButtons", columnState: "columnState", tableId: "tableId", hasStateButtons: "hasStateButtons", enableCharts: "enableCharts", rowStyleFunc: "rowStyleFunc" }, outputs: { refresh: "refresh", rowClick: "rowClick", dblClick: "dblClick", selectClick: "selectClick", selectChange: "selectChange", addClick: "addClick", editClick: "editClick", deleteClick: "deleteClick", cellChange: "cellChange", columnStateChange: "columnStateChange", gridReady: "gridReady", contexMenuAction: "contexMenuAction" }, features: [ɵɵNgOnChangesFeature], decls: 14, vars: 29, consts: [["id", "dg-container"], ["id", "dg-header"], [2, "float", "left"], ["mat-stroked-button", "", "type", "button", 2, "line-height", "23px !important", 3, "click"], ["class", "filterButtonGroup", 4, "ngIf"], ["id", "dataGrid", 2, "width", "100%", "height", "100%", 3, "ngClass", "gridOptions", "rowData", "columnDefs", "defaultColDef", "localeText", "frameworkComponents", "debounceVerticalScrollbar", "getContextMenuItems", "sideBar", "statusBar", "defaultExportParams", "excelStyles", "enableRangeSelection", "enableFillHandle", "undoRedoCellEditing", "undoRedoCellEditingLimit", "enableCellChangeFlash", "enableCharts", "suppressCopyRowsToClipboard", "sortChanged", "filterModified", "filterChanged", "paginationChanged", "rowSelected", "selectionChanged", "firstDataRendered", "cellValueChanged", "gridReady", "columnResized", "columnVisible", "columnMoved", "cellDoubleClicked", "rowDataChanged"], ["agGrid", ""], ["id", "#dg-footer"], ["mat-raised-button", "", "color", "primary", "type", "button", 3, "click", 4, "ngIf"], ["mat-raised-button", "", "type", "button", 3, "color", "click", 4, "ngIf"], ["mat-raised-button", "", "type", "button", "translate", "", 3, "color", "click", 4, "ngIf"], [1, "filterButtonGroup"], ["mat-stroked-button", "", "type", "button", 3, "click"], ["mat-raised-button", "", "color", "primary", "type", "button", 3, "click"], ["mat-raised-button", "", "type", "button", 3, "color", "click"], [4, "ngIf"], ["mat-raised-button", "", "type", "button", "translate", "", 3, "color", "click"]], template: function DatagridComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "button", 3);
        ɵɵlistener("click", function DatagridComponent_Template_button_click_3_listener() { return ctx.clearFilters(); });
        ɵɵtext(4, "Filtreleri Temizle");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(5, DatagridComponent_div_5_Template, 7, 0, "div", 4);
        ɵɵelementEnd();
        ɵɵelementStart(6, "ag-grid-angular", 5, 6);
        ɵɵlistener("sortChanged", function DatagridComponent_Template_ag_grid_angular_sortChanged_6_listener($event) { return ctx.onGridSort($event); })("filterModified", function DatagridComponent_Template_ag_grid_angular_filterModified_6_listener($event) { return ctx.onGridFilterModified($event); })("filterChanged", function DatagridComponent_Template_ag_grid_angular_filterChanged_6_listener($event) { return ctx.onGridFilter($event); })("paginationChanged", function DatagridComponent_Template_ag_grid_angular_paginationChanged_6_listener($event) { return ctx.onPaginationChanged($event); })("rowSelected", function DatagridComponent_Template_ag_grid_angular_rowSelected_6_listener($event) { return ctx.onRowSelected($event); })("selectionChanged", function DatagridComponent_Template_ag_grid_angular_selectionChanged_6_listener($event) { return ctx.onSelectionChanged($event); })("firstDataRendered", function DatagridComponent_Template_ag_grid_angular_firstDataRendered_6_listener($event) { return ctx.onFirstDataRendered($event); })("cellValueChanged", function DatagridComponent_Template_ag_grid_angular_cellValueChanged_6_listener($event) { return ctx.onCellValueChanged($event); })("gridReady", function DatagridComponent_Template_ag_grid_angular_gridReady_6_listener($event) { return ctx.onGridReady($event); })("columnResized", function DatagridComponent_Template_ag_grid_angular_columnResized_6_listener($event) { return ctx.onColumnResized($event); })("columnVisible", function DatagridComponent_Template_ag_grid_angular_columnVisible_6_listener($event) { return ctx.onColumnVisible($event); })("columnMoved", function DatagridComponent_Template_ag_grid_angular_columnMoved_6_listener($event) { return ctx.onColumnMoved($event); })("cellDoubleClicked", function DatagridComponent_Template_ag_grid_angular_cellDoubleClicked_6_listener($event) { return ctx.onCellDoubleClicked($event); })("rowDataChanged", function DatagridComponent_Template_ag_grid_angular_rowDataChanged_6_listener($event) { return ctx.onRowDataChanged($event); });
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 7);
        ɵɵelementStart(9, "div");
        ɵɵtemplate(10, DatagridComponent_button_10_Template, 3, 3, "button", 8);
        ɵɵtemplate(11, DatagridComponent_button_11_Template, 4, 5, "button", 9);
        ɵɵtemplate(12, DatagridComponent_button_12_Template, 4, 5, "button", 10);
        ɵɵtemplate(13, DatagridComponent_button_13_Template, 4, 5, "button", 10);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵstyleProp("width", ctx.dgWidth)("height", ctx.dgHeight);
        ɵɵadvance(5);
        ɵɵproperty("ngIf", ctx.hasStateButtons);
        ɵɵadvance(1);
        ɵɵproperty("ngClass", ctx.theme)("gridOptions", ctx.gridOptions)("rowData", ctx.dataSource)("columnDefs", ctx.columnDefs)("defaultColDef", ctx.defaultColDef)("localeText", ctx.localeText)("frameworkComponents", ctx.frameworkComponents)("debounceVerticalScrollbar", true)("getContextMenuItems", ctx.getContextMenuItems)("sideBar", ctx.sideBar)("statusBar", ctx.statusBar)("defaultExportParams", ctx.defaultExcelExportParams)("excelStyles", ctx.excelStyles)("enableRangeSelection", true)("enableFillHandle", true)("undoRedoCellEditing", true)("undoRedoCellEditingLimit", 20)("enableCellChangeFlash", true)("enableCharts", ctx.enableCharts)("suppressCopyRowsToClipboard", true);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.options["hasSelectButton"]);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.dgButtonsInit.hasAddBtn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.dgButtonsInit.hasEditBtn);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.dgButtonsInit.hasDeleteBtn);
    } }, directives: [MatButton, NgIf, AgGridAngular, NgClass, MatIcon, TranslateDirective], pipes: [TranslatePipe], styles: ["#dg-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;height:83vh;width:98%}@media (min-width:320px) and (max-width:480px){#dg-container[_ngcontent-%COMP%]{height:78vh}}#dg-header[_ngcontent-%COMP%]{margin-bottom:5px!important}#dg-footer[_ngcontent-%COMP%]{margin-top:.5rem}#agGrid[_ngcontent-%COMP%]{flex:1 1 0px}.filterButtonGroup[_ngcontent-%COMP%]{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;float:right;gap:9px;justify-content:space-between!important}.filterButtonGroup[_ngcontent-%COMP%]   .mat-stroked-button[_ngcontent-%COMP%]{line-height:23px!important}.app-dark   [_nghost-%COMP%]     .statusButton{background-color:#262527!important;border-color:#51453a!important;color:#ffcc85!important}.app-dark   [_nghost-%COMP%]     .statusButton1{background-color:#1d2527!important;border-color:#354739!important;color:#90d67f!important}.app-dark   [_nghost-%COMP%]     .statusButton2{background-color:#1c2231!important;border-color:#303b5a!important;color:#85a9ff!important}.red[_ngcontent-%COMP%]{background-color:rgba(204,34,34,.27)}.bold[_ngcontent-%COMP%]{font-weight:700}.separator[_ngcontent-%COMP%]{border-top:1px solid #ccc;height:0;margin:4px 0}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DatagridComponent, [{
        type: Component,
        args: [{
                selector: 'vias-datagrid',
                templateUrl: './datagrid.component.html',
                styleUrls: ['./datagrid.component.scss'],
            }]
    }], function () { return [{ type: ActivatedRoute }, { type: Router }, { type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: MatDialog }, { type: TranslateService }]; }, { agGrid: [{
            type: ViewChild,
            args: ['agGrid', { static: false }]
        }], numLocale: [{
            type: Input
        }], dgWidth: [{
            type: Input
        }], dgHeight: [{
            type: Input
        }], cellEditorParams: [{
            type: Input
        }], singleEdit: [{
            type: Input
        }], dataSource: [{
            type: Input
        }], columns: [{
            type: Input
        }], changeCol: [{
            type: Input
        }], rowClassRules: [{
            type: Input
        }], currentPage: [{
            type: Input
        }], totalPages: [{
            type: Input
        }], contextMenuItems: [{
            type: Input
        }], sideMenuItems: [{
            type: Input
        }], statusBarItems: [{
            type: Input
        }], options: [{
            type: Input
        }], dgButtons: [{
            type: Input
        }], columnState: [{
            type: Input
        }], tableId: [{
            type: Input
        }], hasStateButtons: [{
            type: Input
        }], enableCharts: [{
            type: Input
        }], rowStyleFunc: [{
            type: Input
        }], refresh: [{
            type: Output
        }], rowClick: [{
            type: Output
        }], dblClick: [{
            type: Output
        }], selectClick: [{
            type: Output
        }], selectChange: [{
            type: Output
        }], addClick: [{
            type: Output
        }], editClick: [{
            type: Output
        }], deleteClick: [{
            type: Output
        }], cellChange: [{
            type: Output
        }], columnStateChange: [{
            type: Output
        }], gridReady: [{
            type: Output
        }], contexMenuAction: [{
            type: Output
        }] }); })();

function TableComponent_vias_buttonbar_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-buttonbar", 2);
    ɵɵlistener("itemClick", function TableComponent_vias_buttonbar_2_Template_vias_buttonbar_itemClick_0_listener($event) { ɵɵrestoreView(_r2); const ctx_r1 = ɵɵnextContext(); return ctx_r1.butonclickHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("numLocale", ctx_r0.numLocale)("buttons", ctx_r0.item.tableButtonBarItems);
} }
// tslint:disable-next-line: no-conflicting-lifecycle
class TableComponent {
    constructor(globals, viasService, storage, next, route, translate, dialog) {
        this.globals = globals;
        this.viasService = viasService;
        this.storage = storage;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.dialog = dialog;
        this.cellChange = new EventEmitter();
        this.dgChange = new EventEmitter();
        this.rowClick = new EventEmitter();
        this.dblClick = new EventEmitter();
        this.selectChange = new EventEmitter();
        this.addClick = new EventEmitter();
        this.editClick = new EventEmitter();
        this.deleteClick = new EventEmitter();
        this.dataSource = [];
        this.datagridOptions = {};
        this.dgWidth = '100%';
        this.dgHeight = '300px';
        this.dgButtons = {
            hasAddBtn: false, hasEditBtn: false, hasDeleteBtn: false,
            addBtnText: 'add', editBtnText: 'edit', deleteBtnText: 'delete'
        };
        translate.use(globals.langLocale.substr(0, 2));
    }
    ngOnInit() {
        if (this.item.hasMultiSelectTable === undefined) {
            this.item.hasMultiSelectTable = false;
        }
        this.datagridOptions['multipleRowSelection'] = this.item.hasMultiSelectTable;
        this.datagridOptions['hasSelectButton'] = false;
        this.datagridOptions['hasSelectButton'] = false;
        this.datagridOptions['isLocalRefresh'] = true;
        this.datagridOptions['sidebarVisible'] = false;
        if (this.item.tableOptions !== undefined) {
            for (const x in this.item.tableOptions) {
                this.datagridOptions[x] = this.item.tableOptions[x];
            }
        }
        if (this.item.tableStatusBarItems !== undefined) {
            this.statusBarItems = this.item.tableStatusBarItems;
        }
        if (this.item.width !== undefined) {
            this.dgWidth = this.item.width;
        }
        if (this.item.height !== undefined) {
            this.dgHeight = this.item.height;
        }
        if (this.item.disabled !== undefined) {
            if (this.item.disabled) {
                this.datagridOptions['functionsReadOnly'] = true;
            }
        }
        if (this.item.tableDGButtons !== undefined) {
            for (const x in this.item.tableDGButtons) {
                this.dgButtons[x] = this.item.tableDGButtons[x];
            }
        }
        this.dcolumns = this.item.tableColumns;
        // this.dataSource = this.item.tableDataSource;
        this.numLocale = this.globals.numLocale;
        // this.translateDGCols(this.columns);
    }
    ngOnChanges() {
        if (this.item !== undefined) {
            if (this.item.tableColumns !== undefined) {
                this.dcolumns = this.item.tableColumns;
            }
        }
    }
    ngDoCheck() {
        if (this.item !== undefined) {
            if (this.item.tableDGButtons !== undefined) {
                for (const x in this.item.tableDGButtons) {
                    this.dgButtons[x] = this.item.tableDGButtons[x];
                }
            }
            if (this.item.tableOptions !== undefined) {
                for (const x in this.item.tableOptions) {
                    this.datagridOptions[x] = this.item.tableOptions[x];
                }
            }
        }
    }
    butonclickHandler(event) {
        if (this.tableSelectedItems !== undefined) {
            if (this.tableSelectedItems.length > 1) {
                this.tableSelectedItem['items'] = this.tableSelectedItems;
            }
            else {
                delete this.tableSelectedItem['items'];
                this.tableSelectedItem['item'] = this.tableSelectedItems[0];
            }
        }
        if (event.onClick) {
            event.onClick(event, this.item, this.tableSelectedItem, this.route, this.translate, this.storage, this.globals, this.viasService, this.dialog);
        }
    }
    tableCellChange($event) {
        this.cellChange.emit($event);
        this.dgChange.emit(this.item.tableDataSource);
    }
    tableClickHandler($event) {
        this.tableSelectedItem = $event;
        this.rowClick.emit($event);
    }
    tableDoubleClicked($event) {
        this.dblClick.emit($event);
    }
    tableSelectBtnClickHandler($event) {
        this.rowClick.emit($event);
    }
    tableSelectChangeHandler(event) {
        if (event.selectedItems !== undefined) {
            this.tableSelectedItems = event.selectedItems;
        }
        this.selectChange.emit(event);
    }
    tableAddBtnClickHandler($event) {
        this.addClick.emit($event);
    }
    tableEditBtnClickHandler($event) {
        this.editClick.emit($event);
    }
    tableDeleteBtnClickHandler($event) {
        if (this.tableSelectedItems !== undefined) {
            if (this.tableSelectedItems.length > 1) {
                $event['items'] = this.tableSelectedItems;
            }
        }
        this.deleteClick.emit($event);
    }
}
TableComponent.ɵfac = function TableComponent_Factory(t) { return new (t || TableComponent)(ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialog)); };
TableComponent.ɵcmp = ɵɵdefineComponent({ type: TableComponent, selectors: [["vias-table"]], inputs: { item: "item", form: "form" }, outputs: { cellChange: "cellChange", dgChange: "dgChange", rowClick: "rowClick", dblClick: "dblClick", selectChange: "selectChange", addClick: "addClick", editClick: "editClick", deleteClick: "deleteClick" }, features: [ɵɵNgOnChangesFeature], decls: 4, vars: 10, consts: [[3, "dgWidth", "dgHeight", "dataSource", "options", "columns", "numLocale", "hasStateButtons", "statusBarItems", "dgButtons", "cellChange", "rowClick", "dblClick", "selectClick", "selectChange", "addClick", "editClick", "deleteClick"], [3, "numLocale", "buttons", "itemClick", 4, "ngIf"], [3, "numLocale", "buttons", "itemClick"]], template: function TableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "vias-datagrid", 0);
        ɵɵlistener("cellChange", function TableComponent_Template_vias_datagrid_cellChange_0_listener($event) { return ctx.tableCellChange($event); })("rowClick", function TableComponent_Template_vias_datagrid_rowClick_0_listener($event) { return ctx.tableClickHandler($event); })("dblClick", function TableComponent_Template_vias_datagrid_dblClick_0_listener($event) { return ctx.tableDoubleClicked($event); })("selectClick", function TableComponent_Template_vias_datagrid_selectClick_0_listener($event) { return ctx.tableSelectBtnClickHandler($event); })("selectChange", function TableComponent_Template_vias_datagrid_selectChange_0_listener($event) { return ctx.tableSelectChangeHandler($event); })("addClick", function TableComponent_Template_vias_datagrid_addClick_0_listener($event) { return ctx.tableAddBtnClickHandler($event); })("editClick", function TableComponent_Template_vias_datagrid_editClick_0_listener($event) { return ctx.tableEditBtnClickHandler($event); })("deleteClick", function TableComponent_Template_vias_datagrid_deleteClick_0_listener($event) { return ctx.tableDeleteBtnClickHandler($event); });
        ɵɵelementEnd();
        ɵɵelement(1, "br");
        ɵɵtemplate(2, TableComponent_vias_buttonbar_2_Template, 1, 2, "vias-buttonbar", 1);
        ɵɵelement(3, "br");
    } if (rf & 2) {
        ɵɵproperty("dgWidth", ctx.dgWidth)("dgHeight", ctx.dgHeight)("dataSource", ctx.item.tableDataSource)("options", ctx.datagridOptions)("columns", ctx.dcolumns)("numLocale", ctx.numLocale)("hasStateButtons", false)("statusBarItems", ctx.statusBarItems)("dgButtons", ctx.dgButtons);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.item.hasTableButtonbar && (ctx.item.disabled === undefined || ctx.item.disabled === false));
    } }, directives: [DatagridComponent, NgIf, ButtonbarComponent], styles: [".selected[_ngcontent-%COMP%]{background:rgba(231,242,245,.74)}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TableComponent, [{
        type: Component,
        args: [{
                selector: 'vias-table',
                templateUrl: './table.component.html',
                styleUrls: ['./table.component.scss']
            }]
    }], function () { return [{ type: GlobalsService }, { type: ViasConnectionService }, { type: StorageService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }, { type: MatDialog }]; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], cellChange: [{
            type: Output
        }], dgChange: [{
            type: Output
        }], rowClick: [{
            type: Output
        }], dblClick: [{
            type: Output
        }], selectChange: [{
            type: Output
        }], addClick: [{
            type: Output
        }], editClick: [{
            type: Output
        }], deleteClick: [{
            type: Output
        }] }); })();

const fieldMatcher = {
    autocomplete: AutocompleteComponent,
    button: ButtonComponent,
    submit: ButtonComponent,
    checkbox: CheckboxComponent,
    datepicker: DatepickerComponent,
    combobox: DropdownComponent,
    dropdown: DropdownComponent,
    text: InputComponent,
    number: InputComponent,
    email: InputComponent,
    file: FileComponent,
    img: ImgComponent,
    password: InputComponent,
    radio: RadioComponent,
    table: TableComponent,
    pageviwer: PageViewerComponent,
};
class FormItemDirective {
    constructor(resolver, container) {
        this.resolver = resolver;
        this.container = container;
        this.itemClick = new EventEmitter();
    }
    ngOnInit() {
        const factory = this.resolver.resolveComponentFactory(fieldMatcher[this.item.type]);
        this.componentRef = this.container.createComponent(factory);
        // forward events for table
        if (this.item.type === FieldTypes.Table) {
            if (this.item.tableCellChange !== undefined) {
                this.componentRef.instance.cellChange.subscribe($event => this.item.tableCellChange($event));
            }
            if (this.item.tableChange !== undefined) {
                this.componentRef.instance.dgChange.subscribe($event => this.item.tableChange($event));
            }
            if (this.item.tableClick !== undefined) {
                this.componentRef.instance.rowClick.subscribe($event => this.item.tableClick($event));
            }
            if (this.item.tableDblClick !== undefined) {
                this.componentRef.instance.dblClick.subscribe($event => this.item.tableDblClick($event));
            }
            if (this.item.tableSelectChange !== undefined) {
                this.componentRef.instance.selectChange.subscribe($event => this.item.tableSelectChange($event));
            }
            if (this.item.tableAddClick !== undefined) {
                this.componentRef.instance.addClick.subscribe($event => this.item.tableAddClick($event));
            }
            if (this.item.tableEditClick !== undefined) {
                this.componentRef.instance.editClick.subscribe($event => this.item.tableEditClick($event));
            }
            if (this.item.tableDeleteClick !== undefined) {
                this.componentRef.instance.deleteClick.subscribe($event => this.item.tableDeleteClick($event));
            }
        }
        // forward events for DropDown
        if (this.item.type === FieldTypes.DropDown) {
            if (this.item.onChangedFunc !== undefined) {
                this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
            }
        }
        if (this.item.type === FieldTypes.AutoComplete) {
            if (this.item.onChangedFunc !== undefined) {
                this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
            }
        }
        if (this.item.type === FieldTypes.File) {
            if (this.item.onChangedFunc !== undefined) {
                this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
            }
        }
        // forward events for input icon
        if (this.componentRef.componentType.name === 'InputComponent') {
            if (this.item.iconClick !== undefined && this.item.icon) {
                this.componentRef.instance.onclick.subscribe($event => {
                    this.itemClick.emit(this.item);
                });
            }
            if (this.item.onChangedFunc !== undefined) {
                this.componentRef.instance.onchange.subscribe($event => this.item.onChangedFunc($event));
            }
        }
        // forward events for button
        if (this.item.type === FieldTypes.Button) {
            if (this.item.iconClick !== undefined) {
                this.componentRef.instance.onclick.subscribe($event => {
                    this.itemClick.emit(this.item);
                });
            }
        }
        // assign item and form
        this.componentRef.instance.item = this.item;
        this.componentRef.instance.form = this.form;
    }
}
FormItemDirective.ɵfac = function FormItemDirective_Factory(t) { return new (t || FormItemDirective)(ɵɵdirectiveInject(ComponentFactoryResolver), ɵɵdirectiveInject(ViewContainerRef)); };
FormItemDirective.ɵdir = ɵɵdefineDirective({ type: FormItemDirective, selectors: [["", "viasFormItem", ""]], inputs: { item: "item", form: "form" }, outputs: { itemClick: "itemClick" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormItemDirective, [{
        type: Directive,
        args: [{
                selector: '[viasFormItem]'
            }]
    }], function () { return [{ type: ComponentFactoryResolver }, { type: ViewContainerRef }]; }, { item: [{
            type: Input
        }], form: [{
            type: Input
        }], itemClick: [{
            type: Output
        }] }); })();

function FormComponent_mat_tab_group_1_mat_tab_1_ng_template_1_mat_icon_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-icon", 10);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const tab_r6 = ɵɵnextContext(2).$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(tab_r6.icon);
} }
function FormComponent_mat_tab_group_1_mat_tab_1_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, FormComponent_mat_tab_group_1_mat_tab_1_ng_template_1_mat_icon_0_Template, 2, 1, "mat-icon", 9);
    ɵɵtext(1);
} if (rf & 2) {
    const tab_r6 = ɵɵnextContext().$implicit;
    ɵɵproperty("ngIf", tab_r6.icon.length > 0);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", tab_r6.label, " ");
} }
function FormComponent_mat_tab_group_1_mat_tab_1_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 13);
    ɵɵelementContainerStart(1, 14);
    ɵɵlistener("itemClick", function FormComponent_mat_tab_group_1_mat_tab_1_div_3_div_1_Template_ng_container_itemClick_1_listener() { ɵɵrestoreView(_r17); const formItem_r13 = ɵɵnextContext().$implicit; const ctx_r15 = ɵɵnextContext(3); return ctx_r15.onFormItemClick(formItem_r13); });
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const formItem_r13 = ɵɵnextContext().$implicit;
    const ctx_r14 = ɵɵnextContext(3);
    ɵɵproperty("ngClass", formItem_r13.componentFixedWidth !== undefined ? formItem_r13.componentFixedWidth === 2 ? "formItem2Div" : formItem_r13.componentFixedWidth === 3 ? "formItem3Div" : "" : "formItem");
    ɵɵadvance(1);
    ɵɵproperty("item", formItem_r13)("form", ctx_r14.form);
} }
function FormComponent_mat_tab_group_1_mat_tab_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 11);
    ɵɵtemplate(1, FormComponent_mat_tab_group_1_mat_tab_1_div_3_div_1_Template, 2, 3, "div", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const formItem_r13 = ctx.$implicit;
    const i_r7 = ɵɵnextContext().index;
    ɵɵadvance(1);
    ɵɵproperty("ngIf", formItem_r13.tabIndex === i_r7);
} }
function FormComponent_mat_tab_group_1_mat_tab_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-tab", 6);
    ɵɵtemplate(1, FormComponent_mat_tab_group_1_mat_tab_1_ng_template_1_Template, 2, 2, "ng-template", 7);
    ɵɵelement(2, "br");
    ɵɵtemplate(3, FormComponent_mat_tab_group_1_mat_tab_1_div_3_Template, 2, 1, "div", 8);
    ɵɵelementEnd();
} if (rf & 2) {
    const tab_r6 = ctx.$implicit;
    const ctx_r5 = ɵɵnextContext(2);
    ɵɵpropertyInterpolate("disabled", tab_r6.disabled);
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", ctx_r5.formItems);
} }
function FormComponent_mat_tab_group_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-tab-group");
    ɵɵtemplate(1, FormComponent_mat_tab_group_1_mat_tab_1_Template, 4, 2, "mat-tab", 5);
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", ctx_r0.tabArr);
} }
function FormComponent_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "div", 13);
    ɵɵelementContainerStart(1, 14);
    ɵɵlistener("itemClick", function FormComponent_ng_template_2_div_0_Template_ng_container_itemClick_1_listener() { ɵɵrestoreView(_r23); const formItem_r21 = ctx.$implicit; const ctx_r22 = ɵɵnextContext(2); return ctx_r22.onFormItemClick(formItem_r21); });
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const formItem_r21 = ctx.$implicit;
    const ctx_r20 = ɵɵnextContext(2);
    ɵɵproperty("ngClass", formItem_r21.componentFixedWidth !== undefined ? formItem_r21.componentFixedWidth === 2 ? "formItem2Div" : formItem_r21.componentFixedWidth === 3 ? "formItem3Div" : "" : "formItem");
    ɵɵadvance(1);
    ɵɵproperty("item", formItem_r21)("form", ctx_r20.form);
} }
function FormComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵtemplate(0, FormComponent_ng_template_2_div_0_Template, 2, 3, "div", 15);
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("ngForOf", ctx_r1.formItems);
} }
function FormComponent_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 16);
    ɵɵlistener("click", function FormComponent_button_3_Template_button_click_0_listener() { ɵɵrestoreView(_r25); const ctx_r24 = ɵɵnextContext(); return ctx_r24.moveToNext(false); });
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2, "arrow_back_ios");
    ɵɵelementEnd();
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(3);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(4, 1, "previous"), " ");
} }
function FormComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "button", 16);
    ɵɵlistener("click", function FormComponent_button_4_Template_button_click_0_listener() { ɵɵrestoreView(_r27); const ctx_r26 = ɵɵnextContext(); return ctx_r26.moveToNext(true); });
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementStart(3, "mat-icon");
    ɵɵtext(4, "arrow_forward_ios");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "next"), " ");
} }
function FormComponent_vias_button_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "vias-button", 17);
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵproperty("item", ctx_r4.submitBtnItem)("form", ctx_r4.form);
} }
class FormComponent {
    constructor(fb) {
        this.fb = fb;
        this.formItems = [];
        this.tabs = [];
        this.tabSelectedIndex = 0;
        this.hasSubmitBtn = false;
        this.submitBtnText = '';
        this.tabSelectedIndexChange = new EventEmitter();
        this.formSubmit = new EventEmitter();
        this.formChange = new EventEmitter();
        this.formItemClick = new EventEmitter();
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        this.form = this.createControl();
        // const formItem = this.formItems[0];
        // let x =
        if (this.hasSubmitBtn) {
            this.submitBtnItem = {
                type: FieldTypes.Submit,
                name: 'frmSubmitBtn',
                label: this.submitBtnText
            };
        }
        this.tabArr = [];
        this.tabs.forEach(t => {
            if (t.icon === undefined) {
                t.icon = '';
            }
            if (t.disabled === undefined) {
                t.disabled = false;
            }
            this.tabArr.push(t);
        });
        if (this.tabSelectedIndex !== undefined) {
            console.log('+___+ move to ' + this.tabSelectedIndex);
            this.moveToTab(this.tabSelectedIndex);
        }
        // console.log(changes);
        // // eger formitems icinde degisiklik oldu ise
        // if (changes['formItems'] !== undefined){
        //   // ilk set ettigi degisiklik degil ise
        //   if (!changes['formItems'].firstChange ){
        //     // tabloyu (yani dg) tekrar cizmesi lazim
        //     changes['formItems'].currentValue.forEach( item => {
        //       if (item.type === FieldTypes.Table){
        //        if(this.form.controls[item.name] !== undefined){
        //          console.log(this.form.controls[item.name]);
        //          this.form.controls[item.name].setValue(item, {onlySelf: true});
        //        }
        //       }
        //     });
        //   }
        // }
        this.onChanges();
    }
    get value() {
        return this.form.value;
    }
    // ngDoCheck(): void{
    //   console.log('onur');
    // }
    onChanges() {
        this.form.valueChanges
            // tslint:disable-next-line:deprecation
            .pipe(startWith(null), pairwise())
            .subscribe(([prev, next]) => {
            // tslint:disable-next-line: forin
            for (const itemName in next) {
                let emit = false;
                // eskiden null ise
                if (prev === null) {
                    // yeni deger var ise
                    if (next[itemName] !== null) {
                        emit = true;
                    }
                    // eskiden varsa degismisse !!!
                }
                else if (prev.hasOwnProperty(itemName)) {
                    // degerleri degismis ise gonder
                    // ilk degisiklik buldugunu gonderecek
                    if (prev[itemName] !== next[itemName]) {
                        emit = true;
                    }
                    // eskiden yoksa, ilk degisiklik direk gonder
                }
                else {
                    emit = true;
                }
                if (emit) {
                    const fi = this.formItems.find(fix => fix.name === itemName);
                    if (fi.type === FieldTypes.DatePicker) {
                        if (next[itemName] !== undefined && next[itemName] !== null) {
                            if (next[itemName]._d !== undefined) {
                                next[itemName] = next[itemName]._d;
                            }
                        }
                    }
                    this.formChange.emit({ itemName, val: next[itemName] });
                    return;
                }
            }
        });
    }
    createControl() {
        const group = this.fb.group({});
        // form item icin islemler yap
        this.formItems.forEach(item => {
            // eger db den gelen data source iceride options a yazilacak ise
            if (item.optionsDataSource !== undefined) {
                // tablo var ise diye tablo datasini da doldur.
                if (item.tableColumns !== undefined) {
                    item.tableDataSource = item.optionsDataSource;
                }
                else {
                    item.options = [];
                    // id ve label alanlarini duzelt
                    item.optionsDataSource.forEach(e => {
                        const opt = { data: '-1', label: '' };
                        if (item.optionsDataIdField !== undefined) {
                            opt.data = e[item.optionsDataIdField];
                        }
                        else {
                            opt.data = e['data'];
                        }
                        if (item.optionsDataLabelField !== undefined) {
                            opt.label = e[item.optionsDataLabelField];
                        }
                        else {
                            opt.label = e['label'];
                        }
                        item.options.push(opt);
                    });
                }
            }
            if (item.tableChange === undefined) {
                item.tableChange = ($event) => {
                    this.formChange.emit({ itemName: item.name, val: $event });
                };
            }
            // bu item icin validationlari calistir
            const control = this.fb.control({
                value: item.value,
                disabled: item.disabled
            }, this.bindValidations(item.validations || []));
            // bu item i formcontrol icine ekle
            group.addControl(item.name, control);
        });
        return group;
    }
    bindValidations(validations) {
        if (validations.length > 0) {
            const validList = [];
            validations.forEach(valid => {
                validList.push(valid.validator);
            });
            return Validators.compose(validList);
        }
        return null;
    }
    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.form.valid) {
            this.formSubmit.emit(this.form.value);
        }
        else {
            this.validateAllFormFields(this.form);
        }
    }
    onFormItemClick(event) {
        this.formItemClick.emit(event);
    }
    onTabSelectedIndexChange(index) {
        this.tabSelectedIndexChange.emit(index);
    }
    validateAllFormFields(formGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    moveToNext(isNext = true) {
        if (!this.tabGroup || !(this.tabGroup instanceof MatTabGroup)) {
            return;
        }
        if (isNext) {
            this.moveToTab(this.tabGroup.selectedIndex + 1);
        }
        else {
            this.moveToTab(this.tabGroup.selectedIndex - 1);
        }
    }
    moveToTab(tabIndex = 0) {
        if (!this.tabGroup || !(this.tabGroup instanceof MatTabGroup)) {
            return;
        }
        const tabCount = this.tabGroup._tabs.length;
        if (tabIndex > tabCount - 1) {
            tabIndex = tabCount - 1;
        }
        else if (tabIndex < 0) {
            tabIndex = 0;
        }
        this.tabGroup.selectedIndex = tabIndex;
        //      this.tabGroup.selectedIndex = (this.tabGroup.selectedIndex + 1) % tabCount;
    }
}
FormComponent.ɵfac = function FormComponent_Factory(t) { return new (t || FormComponent)(ɵɵdirectiveInject(FormBuilder)); };
FormComponent.ɵcmp = ɵɵdefineComponent({ type: FormComponent, selectors: [["vias-form"]], viewQuery: function FormComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(MatTabGroup, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.tabGroup = _t.first);
    } }, inputs: { numLocale: "numLocale", formItems: "formItems", tabs: "tabs", tabSelectedIndex: "tabSelectedIndex", tabFunc: "tabFunc", hasSubmitBtn: "hasSubmitBtn", submitBtnText: "submitBtnText" }, outputs: { tabSelectedIndexChange: "tabSelectedIndexChange", formSubmit: "formSubmit", formChange: "formChange", formItemClick: "formItemClick" }, features: [ɵɵNgOnChangesFeature], decls: 7, vars: 6, consts: [[1, "dynamic-form", 3, "formGroup", "submit"], [4, "ngIf"], [3, "ngIf"], ["mat-raised-button", "", "type", "button", "color", "primary", 3, "click", 4, "ngIf"], [3, "item", "form", 4, "ngIf"], [3, "disabled", 4, "ngFor", "ngForOf"], [3, "disabled"], ["mat-tab-label", ""], ["style", "display: inline;", 4, "ngFor", "ngForOf"], ["class", "tab-icon", 4, "ngIf"], [1, "tab-icon"], [2, "display", "inline"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["viasFormItem", "", 3, "item", "form", "itemClick"], [3, "ngClass", 4, "ngFor", "ngForOf"], ["mat-raised-button", "", "type", "button", "color", "primary", 3, "click"], [3, "item", "form"]], template: function FormComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "form", 0);
        ɵɵlistener("submit", function FormComponent_Template_form_submit_0_listener($event) { return ctx.onSubmit($event); });
        ɵɵtemplate(1, FormComponent_mat_tab_group_1_Template, 2, 1, "mat-tab-group", 1);
        ɵɵtemplate(2, FormComponent_ng_template_2_Template, 1, 1, "ng-template", 2);
        ɵɵtemplate(3, FormComponent_button_3_Template, 5, 3, "button", 3);
        ɵɵtemplate(4, FormComponent_button_4_Template, 5, 3, "button", 3);
        ɵɵelement(5, "br");
        ɵɵtemplate(6, FormComponent_vias_button_6_Template, 1, 2, "vias-button", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.tabArr.length > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.tabArr.length === 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.tabArr.length > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.tabArr.length > 0);
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.hasSubmitBtn);
    } }, directives: [ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, NgIf, MatTabGroup, NgForOf, MatTab, MatTabLabel, MatIcon, NgClass, FormItemDirective, MatButton, ButtonComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(FormComponent, [{
        type: Component,
        args: [{
                selector: 'vias-form',
                templateUrl: './form.component.html',
                styleUrls: ['./form.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }]; }, { numLocale: [{
            type: Input
        }], formItems: [{
            type: Input
        }], tabs: [{
            type: Input
        }], tabSelectedIndex: [{
            type: Input
        }], tabFunc: [{
            type: Input
        }], hasSubmitBtn: [{
            type: Input
        }], submitBtnText: [{
            type: Input
        }], tabSelectedIndexChange: [{
            type: Output
        }], formSubmit: [{
            type: Output
        }], formChange: [{
            type: Output
        }], formItemClick: [{
            type: Output
        }], tabGroup: [{
            type: ViewChild,
            args: [MatTabGroup, { static: false }]
        }] }); })();

// import * as purchasing from 'src/app/purchasing/purchasing-page-meta';
var ResponseFieldDataSourceType;
(function (ResponseFieldDataSourceType) {
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["datagridDataSource"] = 0] = "datagridDataSource";
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["datagridFilterDataSource"] = 1] = "datagridFilterDataSource";
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["pageGeneralDataSource"] = 2] = "pageGeneralDataSource";
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["formDataSource"] = 3] = "formDataSource";
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["formFieldDataSource"] = 4] = "formFieldDataSource";
    ResponseFieldDataSourceType[ResponseFieldDataSourceType["currencyDataSource"] = 5] = "currencyDataSource";
})(ResponseFieldDataSourceType || (ResponseFieldDataSourceType = {}));
const PAGEMETA_PROVIDER = new InjectionToken('PageMeta Provider', {
    providedIn: 'root',
    factory: () => { },
});
class PageMetaService {
    // constructor( @Inject(PAGEMETA_PROVIDER) private pageMetaDef: any) {}
    constructor() { }
    // public loadPageMeta(pageName: string): PageMeta {
    //   return new this.pageMetaDef[pageName]();
    // }
    // getInstance(name: string, ...args: any[]) {
    //     var instance = Object.create(this.context[name].prototype);
    //     instance.constructor.apply(instance, args);
    //     return instance;
    // }
    getPage(uri, moduleName, pageName) {
        return new Promise((resolve, reject) => {
            // console.log(
            //   '1!!!!!!!',
            //   `${uri}/${moduleName}/${moduleName}-page-meta.ts`
            // );
            import(`${uri}/${moduleName}/${moduleName}-page-meta`).then((res) => {
                // console.log(res);
                resolve(new res.PageMetaDefs[pageName]());
            }, (err) => {
                // console.log('hahahahahaha', err);
                reject(err);
            });
        });
        return null;
    }
}
PageMetaService.ɵfac = function PageMetaService_Factory(t) { return new (t || PageMetaService)(); };
PageMetaService.ɵprov = ɵɵdefineInjectable({ token: PageMetaService, factory: PageMetaService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PageMetaService, [{
        type: Injectable,
        args: [{
                providedIn: 'root',
            }]
    }], function () { return []; }, null); })();

class PageComponent {
    constructor(storage, globals, viasService, next, route, translate, dialogData = {}) {
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.dialogData = dialogData;
        // Gerekli Bilgiler
        this.pageName = '';
        this.moduleName = '';
        this.pageTitle = '';
        this.pid = 0;
        this.editPid = 0;
        this.aid = 0;
        // Sayfa Settings
        this.hasDatagrid = true;
        this.hasButtonbar = true;
        this.hasEditForm = true;
        this.enableCharts = false;
        this.columns = [];
        this.dataSource = [];
        this.sortObj = { column_name: 'id', sort_type: SortType.Descending };
        this.pageno = 1;
        this.totalPages = 1;
        this.filtersObj = {};
        this.datagridId = '';
        this.dgButtons = {
            hasAddBtn: true, hasEditBtn: true, hasDeleteBtn: true
        };
        this.datagridOptions = {};
        // sol menu
        this.sideMenuItems = [];
        // sol menu
        this.statusBarItems = [];
        // alt taraf Buttonbar
        this.buttonBarItems = [];
        this.pageGeneralData = {};
        // Form
        this.formItems = [];
        this.tabs = [];
        this.tabSelectedIndex = 0;
        this.hasSubmitBtn = false;
        this.submitBtnText = '';
        this.loadAid = 1;
        this.fromDialog = false;
        this.breadcrumbs = [];
        translate.use(globals.langLocale.substr(0, 2));
        if (dialogData['meta'] !== undefined) {
            if (dialogData['pageName'] !== undefined) {
                this.pageName = dialogData['pageName'];
            }
            if (dialogData['moduleName'] !== undefined) {
                this.moduleName = dialogData['moduleName'];
            }
            if (dialogData['aid'] !== undefined) {
                this.loadAid = dialogData['aid'] * 1;
            }
            this.fromDialog = true;
            this.generatePageFromMeta(dialogData['meta']);
        }
        else {
            this.next.queryParams.subscribe(params => {
                if (params.aid !== undefined) {
                    this.loadAid = params.aid * 1; // numbera cevir
                }
                console.log(this.route.getCurrentNavigation());
                console.log(this.route);
                if (this.route.getCurrentNavigation().extras.queryParams !== undefined) {
                    params = this.route.getCurrentNavigation().extras.queryParams;
                }
                this.data$ = params;
            });
        }
    }
    ngOnInit() {
        this.numLocale = this.globals.numLocale;
        const snapshot = this.next.snapshot;
        if (snapshot.data.pageName != null) {
            this.pageName = snapshot.data.pageName;
        }
        if (snapshot.data.moduleName != null) {
            this.moduleName = snapshot.data.moduleName;
        }
        if (snapshot.data.meta) {
            const meta = snapshot.data.meta;
            meta.then(m => {
                const metaData = new m();
                this.generatePageFromMeta(metaData);
            }).catch(err => {
                console.log('!!!!!err!!!', err);
            });
        }
        // let url = './';
        // if (snapshot.data.moduleUrl != null) {
        //   url = snapshot.data.moduleUrl;
        // }
        // // console.log(this.moduleName);
        // if (this.moduleName.length > 0 && this.pageName.length > 0) {
        //   const pms: PageMetaService = new PageMetaService();
        //   pms.getPage(url, this.moduleName, this.pageName).then(
        //     metaData => {
        //       console.log(metaData);
        //       this.generatePageFromMeta(metaData);
        //     }
        //   ).catch(err => {
        //     console.log('!!!!!err!!!', err);
        //   });
        // }
    }
    ngOnChanges() {
    }
    ngOnDestroy() {
    }
    generatePageFromMeta(pageMeta) {
        // activated route snapshot icindeki data objesini pagemetaya yaz
        if (!this.fromDialog) {
            pageMeta.snapShotData = Object.assign(Object.assign({}, this.next.snapshot.data), this.next.snapshot.queryParams);
        }
        if (pageMeta.datagridOptions !== undefined) {
            this.datagridOptions = Object.assign(Object.assign({}, this.datagridOptions), pageMeta.datagridOptions);
        }
        if (pageMeta.dataGridInitialSort !== undefined) {
            this.sortObj = pageMeta.dataGridInitialSort;
        }
        this.datagridOptions['sortObj'] = this.sortObj;
        if (pageMeta.datagridFirstLoadError !== undefined) {
            this.translate.get(pageMeta.datagridFirstLoadError).subscribe((translated) => {
                this.datagridOptions['firstLoadError'] = translated;
            });
        }
        this.translate.get('errorTexts.e_general_053').subscribe((translated) => {
            this.datagridOptions['emptyErrorText'] = translated;
        });
        if (pageMeta.rowClassRules !== undefined) {
            this.rowClassRules = pageMeta.rowClassRules;
        }
        // bunlar alt siniflara ovverride edilen yere tasinmali!!!
        // this.columns = pageMeta.dataGridColumns;
        if (pageMeta.tabs !== undefined) {
            pageMeta.tabs.forEach(t => {
                if (typeof (t) === 'string') {
                    this.translate.get(t).subscribe((translated) => {
                        this.tabs.push({
                            label: translated
                        });
                    });
                }
                else {
                    this.translate.get(t.label).subscribe((translated) => {
                        t.label = translated;
                        if (t.disabledFunc !== undefined) {
                            t.disabled = t.disabledFunc(this);
                        }
                        this.tabs.push(t);
                    });
                }
            });
        }
        if (pageMeta.tabSelectedIndex !== undefined) {
            this.tabSelectedIndex = pageMeta.tabSelectedIndex;
        }
        if (pageMeta.hasSubmitBtn !== undefined) {
            this.hasSubmitBtn = pageMeta.hasSubmitBtn;
        }
        if (pageMeta.submitBtnText !== undefined) {
            this.translate.get(pageMeta.submitBtnText).subscribe((translated) => {
                this.submitBtnText = translated;
            });
        }
        this.datagridId = pageMeta.pid + '_' + this.moduleName + '_' + this.pageName;
        if (this.globals.userPref.tableState !== undefined) {
            let tsres;
            this.globals.userPref.tableState.forEach(ts => {
                if (ts.tableId === this.datagridId) {
                    tsres = ts.state;
                }
            });
            this.datagridColumnState = tsres;
        }
        this.pid = pageMeta.pid;
        if (pageMeta.editPid !== undefined) {
            this.editPid = pageMeta.editPid;
        }
        if (pageMeta.dataGridColumns !== undefined) {
            this.translateDGCols(pageMeta.dataGridColumns);
        }
        if (pageMeta.formItems !== undefined) {
            this.translateFormCols(pageMeta.formItems);
        }
        if (pageMeta.buttonBarItems !== undefined) {
            this.buttonBarItems = pageMeta.buttonBarItems;
        }
        if (pageMeta.datagridSideMenuItems !== undefined) {
            this.sideMenuItems = pageMeta.datagridSideMenuItems;
        }
        if (pageMeta.datagridStatusBarItems !== undefined) {
            this.statusBarItems = pageMeta.datagridStatusBarItems;
        }
        if (pageMeta.datagridContextMenuItems !== undefined) {
            this.contextMenuItems = pageMeta.datagridContextMenuItems;
        }
        if (pageMeta.datagridSelectBtnClickHandler !== undefined) {
            this.datagridSelectBtnClickHandler = pageMeta.datagridSelectBtnClickHandler;
        }
        if (pageMeta.datagridCellChangeHandler !== undefined) {
            this.datagridCellChangeHandler = pageMeta.datagridCellChangeHandler;
        }
        if (pageMeta.datagridDoubleClickHandler !== undefined) {
            this.datagridDoubleClickHandler = pageMeta.datagridDoubleClickHandler;
        }
        if (pageMeta.enableCharts !== undefined) {
            this.enableCharts = pageMeta.enableCharts;
        }
        // bu islem listone servis sonucunda dolarak calisacak
        //this.formItems = pageMeta.formItems;
        // console.log(pageMeta);
        this.pageMeta = pageMeta;
        // tslint:disable-next-line: max-line-length
        let listPageLabel = 'pageNames.page_' + String(Number(this.pageMeta.pid) + (this.pageMeta.listAid !== undefined ? Number(this.pageMeta.listAid) : 0));
        if (this.pageMeta.listPageLabel !== undefined) {
            listPageLabel = this.pageMeta.listPageLabel;
        }
        // set breadcrumbs
        if (this.hasEditForm) {
            if (this.pageMeta.listPageName !== undefined && this.pageMeta.listAid !== undefined) {
                this.breadcrumbs.push({ label: listPageLabel, url: '#/' + this.moduleName + '/' + this.pageMeta.listPageName });
            }
            let editPageLabel = this.pageName;
            if (this.pageMeta.editPageLabel !== undefined) {
                editPageLabel = this.pageMeta.editPageLabel;
            }
            this.breadcrumbs.push({ label: editPageLabel, url: 'javascript:void(0)' });
        }
        else {
            this.breadcrumbs.push({ label: listPageLabel, url: 'javascript:void(0)' });
        }
    }
    translateDGCols(pmg) {
        pmg.forEach(e => {
            if (e.filterDataSourceFunc !== undefined) {
                e.filterDataSource = e.filterDataSourceFunc();
                e.filterDataSource.forEach(el => {
                    this.translate.get(el.label).subscribe((translated) => {
                        el.label = translated;
                    });
                });
                e.editDataSource = e.filterDataSource;
            }
            this.translate.get(e.headerText).subscribe((translated) => {
                e.headerText = translated;
            });
        });
    }
    translateFormCols(pmg) {
        pmg.forEach(e => {
            if (e.options !== undefined) {
                // e.optionsDataSourceFunc !== undefined ||
                // e.options = e.optionsDataSourceFunc();
                e.options.forEach(el => {
                    this.translate.get(el.label).subscribe((translated) => {
                        el.label = translated;
                    });
                });
            }
            if (e.tableColumns !== undefined) {
                e.tableColumns.forEach(tc => {
                    if (tc.filterDataSourceFunc !== undefined) {
                        tc.filterDataSource = tc.filterDataSourceFunc();
                        tc.filterDataSource.forEach(el => {
                            this.translate.get(el.label).subscribe((translated) => {
                                el.label = translated;
                            });
                        });
                        tc.editDataSource = tc.filterDataSource;
                    }
                    this.translate.get(tc.headerText).subscribe((translated) => {
                        tc.headerText = translated;
                    });
                });
            }
            this.translate.get(e.label).subscribe((translated) => {
                e.label = translated;
            });
        });
    }
    /**
     * Datagrid sort, sayfa degisim ve filtre durumunun handler methodu
     * @param $event DataGridRefreshEvent
     */
    datagridRefreshHandler($event) {
        this.sortObj = $event.sort;
        this.datagridOptions['sortObj'] = this.sortObj;
        this.pageno = $event.pageNo;
        // filtersobj icindekilere degisiklik ekliyoruz. mevcutlari kaldirmiyoruz.
        // this.filtersObj = $event.filters;
        for (const fo in $event.filters) {
            this.filtersObj[fo] = $event.filters[fo];
        }
        //Filtreden çıkartılan alanların filtersObj dan çıkartılması için
        for (const fi in this.filtersObj) {
            if ($event.filters[fi] === undefined) {
                delete this.filtersObj[fi];
            }
        }
        console.log($event);
        this.refreshData();
    }
    /**
     * Button bar tiklaninca methoda gonderen handler
     * @param $event Buttonbar event
     */
    butonclickHandler(event) { }
    formItemChangeOption(itemName, data) {
        const index = this.formItems.findIndex(e => e['name'] === itemName);
        this.formItems[index].options = data;
    }
    /**
     * Form submit edilince calisan handler method
     * @param $event FormEvent
     */
    formSubmitHandler($event) { }
    /**
     * Form icinde bir sey degisince edilince calisan handler method
     * @param $event object
     */
    formChangeHandler($event) { }
    tabSelectedIndexChange(index) { }
    /**
     * viasService call with pid aid
     * standart listeleme icin
     * handle promise response
     * no need o
     */
    refreshData() {
        let sendData = {
            sort: this.sortObj,
            page_no: this.pageno,
            filters: '',
            ng_filters: this.filtersObj
        };
        this.runInitDataFieldsFunction();
        if (this.pageMeta.initDataFields !== undefined) {
            sendData = Object.assign(Object.assign({}, sendData), this.pageMeta.initDataFields);
        }
        console.log(sendData);
        this.viasService.send(this.pid, this.aid, sendData).then(response => {
            if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                this.globals.handleErrors(response.error);
            }
            this.viasServiceHandler(response);
        }, err => {
            alert(err);
            console.log(err);
        });
    }
    runInitDataFieldsFunction() {
        if (this.pageMeta.initDataFieldsFunction !== undefined) {
            const ifields = this.pageMeta.initDataFieldsFunction();
            if (this.pageMeta.initDataFields !== undefined) {
                this.pageMeta.initDataFields = Object.assign(Object.assign({}, this.pageMeta.initDataFields), ifields);
            }
            else {
                this.pageMeta.initDataFields = ifields;
            }
        }
    }
    /**
     * viasService icin Handler
     * OVERRIDE
     * standart listeleme sonucu
     */
    viasServiceHandler(r) {
        console.log(r);
        console.log('------cevap geldi');
    }
    responseFieldParserForForm(data, responseFields, formItems) {
        for (let i = 0; i < formItems.length; i++) {
            const formItem = formItems[i];
            if (formItem.id === undefined) {
                formItem.id = formItem.name;
            }
            let datax = {};
            // Table columns set
            if (formItem.type === FieldTypes.Table) {
                formItem.tableColumns.forEach(col => {
                    if (col.filterDataIdField === undefined) {
                        col.filterDataIdField = 'id';
                    }
                    if (col.filterDataLabelField === undefined) {
                        col.filterDataLabelField = 'name';
                    }
                    if (col.filterField === undefined) {
                        col.filterField = col.dataField;
                    }
                    if (col.sortField === undefined) {
                        col.sortField = col.dataField;
                    }
                    if (col.editable !== undefined) {
                        if (col.editable) {
                            if (col.editDataIdField === undefined) {
                                col.editDataIdField = col.filterDataIdField;
                            }
                            if (col.editDataLabelField === undefined) {
                                col.editDataLabelField = col.filterDataLabelField;
                            }
                            if (col.editField === undefined) {
                                col.editField = col.filterField;
                            }
                        }
                    }
                });
            }
            responseFields.forEach(rf => {
                if (rf.responseFieldType === ResponseFieldDataSourceType.formDataSource) {
                    if (data[rf.fieldName] !== undefined) {
                        datax = data[rf.fieldName];
                        formItem.value = datax[formItem.id];
                    }
                }
                // formun formDataSource dışında kullandığı bir data var ise
                if (rf.responseFieldType === ResponseFieldDataSourceType.formFieldDataSource) {
                    if (formItem.dataSource !== undefined) {
                        if (formItem.dataSource === rf.fieldName) {
                            if (data[rf.fieldName] !== undefined) {
                                datax = data[rf.fieldName];
                                if (datax.hasOwnProperty('length')) {
                                    formItem.value = datax;
                                }
                                else {
                                    formItem.value = datax[formItem.id];
                                }
                            }
                        }
                    }
                }
            });
            // option ile yazili form itemlar !!!
            // response field lardan al getir
            if (formItem.optionsFieldName !== undefined) {
                responseFields.forEach(rf => {
                    if (rf.responseFieldType === ResponseFieldDataSourceType.formFieldDataSource) {
                        if (rf.componentName === formItem.optionsFieldName) {
                            // tablo var ise diye tablo datasini da doldur.
                            if (formItem.tableColumns !== undefined) {
                                // Columns FilterDataSource, EditDataSource
                                formItem.tableColumns.forEach((tbCol, key) => {
                                    if (tbCol.filterField !== undefined && tbCol.dataType === FieldTypes.AutoComplete) {
                                        const tbRf = responseFields.find(dt => dt.componentName === tbCol.filterField);
                                        if (tbRf !== undefined) {
                                            if (data[tbRf.fieldName] !== undefined) {
                                                tbCol.filterDataSource = [];
                                                for (const [key, obj] of Object.entries(data[tbRf.fieldName])) {
                                                    if (obj !== undefined) {
                                                        if (rf.isKeyValuePair !== undefined) {
                                                            tbCol.filterDataSource.push({
                                                                // tslint:disable-next-line: radix
                                                                value: parseInt(key),
                                                                label: obj.toString()
                                                            });
                                                        }
                                                        else {
                                                            if (obj[tbCol.filterDataLabelField].toString() !== undefined) {
                                                                const pushedData = {
                                                                    // tslint:disable-next-line: radix
                                                                    value: obj[tbCol.filterDataIdField],
                                                                    label: obj[tbCol.filterDataLabelField]
                                                                };
                                                                if (rf.connectedComponentName !== undefined) {
                                                                    pushedData[rf.connectedComponentName] = obj[rf.connectedComponentName];
                                                                }
                                                                tbCol.filterDataSource.push(pushedData);
                                                            }
                                                        }
                                                    }
                                                }
                                                tbCol.editDataSource = tbCol.filterDataSource;
                                                formItem.tableColumns.splice(key, 1, tbCol);
                                            }
                                        }
                                    }
                                });
                                formItem.tableDataSource = [];
                                formItem.tableDataSource = data[rf.fieldName];
                                if (formItem.onChangedFunc !== undefined) {
                                    formItem.onChangedFunc(formItem.tableDataSource, this);
                                }
                            }
                            else {
                                formItem.options = [];
                                // digerlerini ekle
                                if (data[rf.fieldName] !== undefined) {
                                    for (const [key, obj] of Object.entries(data[rf.fieldName])) {
                                        if (obj !== undefined) {
                                            if (rf.isKeyValuePair !== undefined) {
                                                formItem.options.push({
                                                    data: key,
                                                    label: obj.toString()
                                                });
                                            }
                                            else {
                                                if (obj[formItem.optionsDataLabelField].toString().length > 0) {
                                                    formItem.options.push({
                                                        data: obj[formItem.optionsDataIdField],
                                                        label: obj[formItem.optionsDataLabelField]
                                                    });
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });
            }
            // changed lifecyle icin
            // kolonu geri yaz
            formItems.splice(i, 1, formItem);
        }
        responseFields.forEach(rf => {
            if (rf.responseFieldType === ResponseFieldDataSourceType.pageGeneralDataSource) {
                if (data[rf.fieldName] !== undefined) {
                    this.pageGeneralData[rf.fieldName] = data[rf.fieldName];
                }
            }
        });
        return formItems;
    }
    responseFieldParserForDataGrid(data, responseFields, dataGridColumns) {
        let dataSource = [];
        // bazi alanlari set et.
        dataGridColumns.forEach(col => {
            if (col.filterDataIdField === undefined) {
                col.filterDataIdField = 'id';
            }
            if (col.filterDataLabelField === undefined) {
                col.filterDataLabelField = 'name';
            }
            if (col.filterField === undefined) {
                col.filterField = col.dataField;
            }
            if (col.sortField === undefined) {
                col.sortField = col.dataField;
            }
            if (col.editable !== undefined) {
                if (col.editable) {
                    if (col.editDataIdField === undefined) {
                        col.editDataIdField = col.filterDataIdField;
                    }
                    if (col.editDataLabelField === undefined) {
                        col.editDataLabelField = col.filterDataLabelField;
                    }
                    if (col.editField === undefined) {
                        col.editField = col.filterField;
                    }
                }
            }
        });
        responseFields.forEach(rf => {
            if (rf.responseFieldType === ResponseFieldDataSourceType.datagridDataSource) {
                if (data[rf.fieldName] !== undefined) {
                    dataSource = data[rf.fieldName];
                }
            }
            else if (rf.responseFieldType === ResponseFieldDataSourceType.datagridFilterDataSource) {
                // colonu bul
                const colInd = dataGridColumns.findIndex(x => x.filterField === rf.componentName);
                const col = dataGridColumns[colInd];
                col.filterDataSource = [];
                // digerlerini ekle
                if (data[rf.fieldName] !== undefined) {
                    for (const [key, obj] of Object.entries(data[rf.fieldName])) {
                        if (obj !== undefined) {
                            if (rf.isKeyValuePair !== undefined) {
                                col.filterDataSource.push({
                                    // tslint:disable-next-line: radix
                                    value: parseInt(key),
                                    label: obj.toString()
                                });
                            }
                            else {
                                if (obj[col.filterDataLabelField].toString() !== undefined) {
                                    const pushedData = {
                                        // tslint:disable-next-line: radix
                                        value: obj[col.filterDataIdField],
                                        label: obj[col.filterDataLabelField]
                                    };
                                    if (rf.connectedComponentName !== undefined) {
                                        pushedData[rf.connectedComponentName] = obj[rf.connectedComponentName];
                                    }
                                    col.filterDataSource.push(pushedData);
                                }
                            }
                        }
                    }
                }
                // edit datasi filter ile ayni
                col.editDataSource = col.filterDataSource;
                // changed lifecyle icin
                // kolonu geri yaz
                dataGridColumns.splice(colInd, 1, col);
            }
            else if (rf.responseFieldType === ResponseFieldDataSourceType.pageGeneralDataSource) {
                if (data[rf.fieldName] !== undefined) {
                    this.pageGeneralData[rf.fieldName] = data[rf.fieldName];
                }
            }
        });
        return { dataSource, dataGridColumns };
    }
    /**
     * Datagrid tek tiklaninca calisan method
     * @param event DataGridEvent
     */
    // datagridClickHandler?(index: number, item: DataGridColumn);
    datagridClickHandler(event) {
        this.datagridSelectedItem = event;
    }
    datagridSelectBtnClickHandler(event) {
    }
    datagridCellChangeHandler(event) {
    }
    datagridAddBtnClickHandler(event) {
        // this.route.navigate('');
    }
    datagridEditBtnClickHandler(event) {
        console.log(event.item);
    }
    datagridDeleteBtnClickHandler(event) {
        console.log(event.item);
    }
    datagridColumnStateChangeHandler($event) {
        const usrprf = this.globals.userPref;
        if (usrprf.tableState === undefined) {
            usrprf.tableState = [];
        }
        let found = false;
        usrprf.tableState.forEach(ts => {
            if (ts.tableId === this.datagridId) {
                ts.state = $event.state;
                found = true;
            }
        });
        if (!found) {
            usrprf.tableState.push($event);
        }
        this.globals.userPref = usrprf;
        this.globals.userPrefService.setPref(usrprf);
    }
}
PageComponent.ɵfac = function PageComponent_Factory(t) { return new (t || PageComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
PageComponent.ɵcmp = ɵɵdefineComponent({ type: PageComponent, selectors: [["vias-page"]], features: [ɵɵNgOnChangesFeature], decls: 0, vars: 0, template: function PageComponent_Template(rf, ctx) { }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-page',
                template: '',
            }]
    }], function () { return [{ type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

function BreadcrumbComponent_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵelementContainerStart(1);
    ɵɵelementStart(2, "a", 4);
    ɵɵelementStart(3, "mat-icon", 5);
    ɵɵtext(4, "home");
    ɵɵelementEnd();
    ɵɵelementEnd();
    ɵɵelementStart(5, "span", 6);
    ɵɵtext(6, " \u00BB ");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
} }
function BreadcrumbComponent_li_3_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 6);
    ɵɵtext(1, " \u00BB ");
    ɵɵelementEnd();
} }
const _c0$5 = function (a0) { return [a0]; };
function BreadcrumbComponent_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "li");
    ɵɵelementContainerStart(1);
    ɵɵelementStart(2, "a", 7);
    ɵɵtext(3);
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵtemplate(5, BreadcrumbComponent_li_3_span_5_Template, 2, 0, "span", 8);
    ɵɵelementContainerEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const breadcrumb_r2 = ctx.$implicit;
    const isLast_r4 = ctx.last;
    ɵɵadvance(2);
    ɵɵclassProp("breadcrumb-history-link", !isLast_r4);
    ɵɵproperty("href", ɵɵpureFunction1(7, _c0$5, breadcrumb_r2.url), ɵɵsanitizeUrl);
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(4, 5, breadcrumb_r2.label), " ");
    ɵɵadvance(2);
    ɵɵproperty("ngIf", !isLast_r4);
} }
class BreadcrumbComponent {
    constructor() {
        this.breadcrumbs = [];
    }
    ngOnInit() { }
}
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(); };
BreadcrumbComponent.ɵcmp = ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["vias-breadcrumb"]], inputs: { breadcrumbs: "breadcrumbs" }, decls: 4, vars: 2, consts: [[1, "route-content-top"], [1, "breadcrumbs"], [4, "ngIf"], [4, "ngFor", "ngForOf"], ["href", "#/"], [1, "customIcon"], [2, "vertical-align", "sub"], [1, "breadcrumb-current-route", 2, "text-decoration", "none", "vertical-align", "sub", 3, "href"], ["style", "vertical-align: sub;", 4, "ngIf"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "ol", 1);
        ɵɵtemplate(2, BreadcrumbComponent_li_2_Template, 7, 0, "li", 2);
        ɵɵtemplate(3, BreadcrumbComponent_li_3_Template, 6, 9, "li", 3);
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.breadcrumbs.length > 0);
        ɵɵadvance(1);
        ɵɵproperty("ngForOf", ctx.breadcrumbs);
    } }, directives: [NgIf, NgForOf, MatIcon], pipes: [TranslatePipe], styles: [".customIcon[_ngcontent-%COMP%]{color:#3f51b5;vertical-align:-webkit-baseline-middle}.breadcrumbs[_ngcontent-%COMP%]{background:none;font-size:1em;margin:0}ol.breadcrumbs[_ngcontent-%COMP%]{list-style-type:none;padding:0}.breadcrumb-current-route[_ngcontent-%COMP%]{color:inherit;font-weight:500}.breadcrumb-history-link[_ngcontent-%COMP%]{color:#3f51b5;cursor:pointer;text-decoration:underline}ol.breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{list-style-type:none}@media only screen and (min-width:960px){ol.breadcrumbs[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{display:inline;list-style-type:none}.route-content-top[_ngcontent-%COMP%]{height:30px}}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'vias-breadcrumb',
                templateUrl: './breadcrumb.component.html',
                styleUrls: ['./breadcrumb.component.scss']
            }]
    }], function () { return []; }, { breadcrumbs: [{
            type: Input
        }] }); })();

function DefaultMasterDetailPageComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "vias-breadcrumb", 5);
    ɵɵelement(2, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("breadcrumbs", ctx_r0.breadcrumbs);
} }
function DefaultMasterDetailPageComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "h2");
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate2("", ɵɵpipeBind1(3, 2, ctx_r1.moduleName), " - ", ɵɵpipeBind1(4, 4, ctx_r1.pageName), "");
} }
function DefaultMasterDetailPageComponent_vias_datagrid_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-datagrid", 6);
    ɵɵlistener("refresh", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_refresh_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.datagridRefreshHandler($event); })("rowClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_rowClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r7 = ɵɵnextContext(); return ctx_r7.datagridClickHandler($event); })("dblClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_dblClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r8 = ɵɵnextContext(); return ctx_r8.datagridDoubleClickHandler($event); })("selectClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_selectClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r9 = ɵɵnextContext(); return ctx_r9.datagridSelectBtnClickHandler($event); })("addClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_addClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r10 = ɵɵnextContext(); return ctx_r10.datagridAddBtnClickHandler($event); })("editClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_editClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r11 = ɵɵnextContext(); return ctx_r11.datagridEditBtnClickHandler($event); })("deleteClick", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_deleteClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r12 = ɵɵnextContext(); return ctx_r12.datagridDeleteBtnClickHandler($event); })("columnStateChange", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_columnStateChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r13 = ɵɵnextContext(); return ctx_r13.datagridColumnStateChangeHandler($event); })("cellChange", function DefaultMasterDetailPageComponent_vias_datagrid_3_Template_vias_datagrid_cellChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r14 = ɵɵnextContext(); return ctx_r14.datagridCellChangeHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("dataSource", ctx_r2.dataSource)("numLocale", ctx_r2.numLocale)("columns", ctx_r2.columns)("currentPage", ctx_r2.pageno)("totalPages", ctx_r2.totalPages)("options", ctx_r2.datagridOptions)("rowClassRules", ctx_r2.rowClassRules)("tableId", ctx_r2.datagridId)("sideMenuItems", ctx_r2.sideMenuItems)("statusBarItems", ctx_r2.statusBarItems)("contextMenuItems", ctx_r2.contextMenuItems)("columnState", ctx_r2.datagridColumnState)("dgButtons", ctx_r2.dgButtons)("enableCharts", ctx_r2.enableCharts);
} }
function DefaultMasterDetailPageComponent_vias_buttonbar_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-buttonbar", 7);
    ɵɵlistener("itemClick", function DefaultMasterDetailPageComponent_vias_buttonbar_4_Template_vias_buttonbar_itemClick_0_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(); return ctx_r15.butonclickHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("numLocale", ctx_r3.numLocale)("buttons", ctx_r3.buttonBarItems);
} }
function DefaultMasterDetailPageComponent_vias_form_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-form", 8, 9);
    ɵɵlistener("formChange", function DefaultMasterDetailPageComponent_vias_form_5_Template_vias_form_formChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.formChangeHandler($event); })("formSubmit", function DefaultMasterDetailPageComponent_vias_form_5_Template_vias_form_formSubmit_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); return ctx_r20.formSubmitHandler($event); })("formItemClick", function DefaultMasterDetailPageComponent_vias_form_5_Template_vias_form_formItemClick_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(); return ctx_r21.formItemClickHandler($event); })("tabSelectedIndexChange", function DefaultMasterDetailPageComponent_vias_form_5_Template_vias_form_tabSelectedIndexChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); return ctx_r22.tabSelectedIndexChange($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵproperty("tabs", ctx_r4.tabs)("tabSelectedIndex", ctx_r4.tabSelectedIndex)("hasSubmitBtn", ctx_r4.hasSubmitBtn)("submitBtnText", ctx_r4.submitBtnText)("numLocale", ctx_r4.numLocale)("formItems", ctx_r4.formItems);
} }
class DefaultMasterDetailPageComponent extends PageComponent {
    constructor(storage, globals, viasService, next, route, translate) {
        super(storage, globals, viasService, next, route, translate);
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.hasDatagrid = true;
        this.hasEditForm = true;
    }
    generatePageFromMeta(pageMeta) {
        super.generatePageFromMeta(pageMeta);
        this.aid = pageMeta.listAid;
        this.hasButtonbar = pageMeta.hasButtonBarInList;
        console.log(pageMeta);
        this.refreshData();
    }
    viasServiceHandler(r) {
        console.log(r);
        console.log('------cevap geldi');
        if (r.data) {
            console.log(r.data);
            if (r.data['duty_code']) {
                this.dataSource = r.data['duty_code'];
            }
            if (r.data['total_page']) {
                this.totalPages = r.data['total_page'];
            }
            if (r.data['page_no']) {
                this.pageno = r.data['page_no'];
            }
        }
    }
}
DefaultMasterDetailPageComponent.ɵfac = function DefaultMasterDetailPageComponent_Factory(t) { return new (t || DefaultMasterDetailPageComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService)); };
DefaultMasterDetailPageComponent.ɵcmp = ɵɵdefineComponent({ type: DefaultMasterDetailPageComponent, selectors: [["vias-default-master-detail-page"]], features: [ɵɵInheritDefinitionFeature], decls: 6, vars: 6, consts: [[3, "ngClass"], [4, "ngIf"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange", 4, "ngIf"], [3, "numLocale", "buttons", "itemClick", 4, "ngIf"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange", 4, "ngIf"], [3, "breadcrumbs"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange"], [3, "numLocale", "buttons", "itemClick"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange"], ["form", ""]], template: function DefaultMasterDetailPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, DefaultMasterDetailPageComponent_ng_container_1_Template, 3, 1, "ng-container", 1);
        ɵɵtemplate(2, DefaultMasterDetailPageComponent_ng_container_2_Template, 5, 6, "ng-container", 1);
        ɵɵtemplate(3, DefaultMasterDetailPageComponent_vias_datagrid_3_Template, 1, 14, "vias-datagrid", 2);
        ɵɵtemplate(4, DefaultMasterDetailPageComponent_vias_buttonbar_4_Template, 1, 2, "vias-buttonbar", 3);
        ɵɵtemplate(5, DefaultMasterDetailPageComponent_vias_form_5_Template, 2, 6, "vias-form", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.fromDialog ? "" : "fullScreen");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasDatagrid);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasButtonbar);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasEditForm);
    } }, directives: [NgClass, NgIf, BreadcrumbComponent, DatagridComponent, ButtonbarComponent, FormComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DefaultMasterDetailPageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-default-master-detail-page',
                templateUrl: '../page/page.component.html',
                styleUrls: ['../page/page.component.scss']
            }]
    }], function () { return [{ type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }]; }, null); })();

const _c0$6 = ["notes"];
function ConfirmationDialogComponent_mat_form_field_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-form-field", 5);
    ɵɵelementStart(1, "mat-label");
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
    ɵɵelement(4, "textarea", 6, 7);
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(3, 1, "note"));
} }
class ConfirmationDialogComponent {
    constructor(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.question = 'confirmationProcess';
        this.is_note = false;
        this.confirmText = 'yes';
        this.rejectText = 'nope';
        if (data.is_note !== undefined) {
            this.is_note = data.is_note;
        }
        if (data.question !== undefined) {
            this.question = data.question;
        }
        if (data.confirmText !== undefined) {
            this.confirmText = data.confirmText;
        }
        if (data.rejectText !== undefined) {
            this.rejectText = data.rejectText;
        }
    }
    onNoYesClick(confirm) {
        let data = { confirm: confirm };
        if (this.is_note) {
            data['notes'] = this.notes.nativeElement.value;
        }
        this.dialogRef.close(data);
    }
}
ConfirmationDialogComponent.ɵfac = function ConfirmationDialogComponent_Factory(t) { return new (t || ConfirmationDialogComponent)(ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ConfirmationDialogComponent.ɵcmp = ɵɵdefineComponent({ type: ConfirmationDialogComponent, selectors: [["vias-confirmation-dialog"]], viewQuery: function ConfirmationDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$6, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.notes = _t.first);
    } }, decls: 12, vars: 10, consts: [["mat-dialog-content", ""], ["style", "width: 100%", 4, "ngIf"], ["mat-dialog-actions", ""], ["mat-button", "", "color", "warn", 3, "click"], ["mat-button", "", "color", "primary", 3, "click"], [2, "width", "100%"], ["matInput", "", "cdkTextareaAutosize", "", "cdkAutosizeMinRows", "1", "cdkAutosizeMaxRows", "5"], ["notes", "", "autosize", "cdkTextareaAutosize"]], template: function ConfirmationDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "h3");
        ɵɵtext(2);
        ɵɵpipe(3, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(4, ConfirmationDialogComponent_mat_form_field_4_Template, 7, 3, "mat-form-field", 1);
        ɵɵelementStart(5, "div", 2);
        ɵɵelementStart(6, "button", 3);
        ɵɵlistener("click", function ConfirmationDialogComponent_Template_button_click_6_listener() { return ctx.onNoYesClick(false); });
        ɵɵtext(7);
        ɵɵpipe(8, "translate");
        ɵɵelementEnd();
        ɵɵelementStart(9, "button", 4);
        ɵɵlistener("click", function ConfirmationDialogComponent_Template_button_click_9_listener() { return ctx.onNoYesClick(true); });
        ɵɵtext(10);
        ɵɵpipe(11, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate(ɵɵpipeBind1(3, 4, ctx.question));
        ɵɵadvance(2);
        ɵɵproperty("ngIf", ctx.is_note);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ɵɵpipeBind1(8, 6, ctx.rejectText));
        ɵɵadvance(3);
        ɵɵtextInterpolate(ɵɵpipeBind1(11, 8, ctx.confirmText));
    } }, directives: [NgIf, MatButton, MatFormField, MatLabel, MatInput, CdkTextareaAutosize], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ConfirmationDialogComponent, [{
        type: Component,
        args: [{
                selector: 'vias-confirmation-dialog',
                templateUrl: './confirmation-dialog.component.html',
                styleUrls: ['./confirmation-dialog.component.scss']
            }]
    }], function () { return [{ type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { notes: [{
            type: ViewChild,
            args: ['notes', { static: false }]
        }] }); })();

function DefaultListPageComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "vias-breadcrumb", 5);
    ɵɵelement(2, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("breadcrumbs", ctx_r0.breadcrumbs);
} }
function DefaultListPageComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "h2");
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate2("", ɵɵpipeBind1(3, 2, ctx_r1.moduleName), " - ", ɵɵpipeBind1(4, 4, ctx_r1.pageName), "");
} }
function DefaultListPageComponent_vias_datagrid_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-datagrid", 6);
    ɵɵlistener("refresh", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_refresh_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.datagridRefreshHandler($event); })("rowClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_rowClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r7 = ɵɵnextContext(); return ctx_r7.datagridClickHandler($event); })("dblClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_dblClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r8 = ɵɵnextContext(); return ctx_r8.datagridDoubleClickHandler($event); })("selectClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_selectClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r9 = ɵɵnextContext(); return ctx_r9.datagridSelectBtnClickHandler($event); })("addClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_addClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r10 = ɵɵnextContext(); return ctx_r10.datagridAddBtnClickHandler($event); })("editClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_editClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r11 = ɵɵnextContext(); return ctx_r11.datagridEditBtnClickHandler($event); })("deleteClick", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_deleteClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r12 = ɵɵnextContext(); return ctx_r12.datagridDeleteBtnClickHandler($event); })("columnStateChange", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_columnStateChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r13 = ɵɵnextContext(); return ctx_r13.datagridColumnStateChangeHandler($event); })("cellChange", function DefaultListPageComponent_vias_datagrid_3_Template_vias_datagrid_cellChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r14 = ɵɵnextContext(); return ctx_r14.datagridCellChangeHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("dataSource", ctx_r2.dataSource)("numLocale", ctx_r2.numLocale)("columns", ctx_r2.columns)("currentPage", ctx_r2.pageno)("totalPages", ctx_r2.totalPages)("options", ctx_r2.datagridOptions)("rowClassRules", ctx_r2.rowClassRules)("tableId", ctx_r2.datagridId)("sideMenuItems", ctx_r2.sideMenuItems)("statusBarItems", ctx_r2.statusBarItems)("contextMenuItems", ctx_r2.contextMenuItems)("columnState", ctx_r2.datagridColumnState)("dgButtons", ctx_r2.dgButtons)("enableCharts", ctx_r2.enableCharts);
} }
function DefaultListPageComponent_vias_buttonbar_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-buttonbar", 7);
    ɵɵlistener("itemClick", function DefaultListPageComponent_vias_buttonbar_4_Template_vias_buttonbar_itemClick_0_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(); return ctx_r15.butonclickHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("numLocale", ctx_r3.numLocale)("buttons", ctx_r3.buttonBarItems);
} }
function DefaultListPageComponent_vias_form_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-form", 8, 9);
    ɵɵlistener("formChange", function DefaultListPageComponent_vias_form_5_Template_vias_form_formChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.formChangeHandler($event); })("formSubmit", function DefaultListPageComponent_vias_form_5_Template_vias_form_formSubmit_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); return ctx_r20.formSubmitHandler($event); })("formItemClick", function DefaultListPageComponent_vias_form_5_Template_vias_form_formItemClick_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(); return ctx_r21.formItemClickHandler($event); })("tabSelectedIndexChange", function DefaultListPageComponent_vias_form_5_Template_vias_form_tabSelectedIndexChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); return ctx_r22.tabSelectedIndexChange($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵproperty("tabs", ctx_r4.tabs)("tabSelectedIndex", ctx_r4.tabSelectedIndex)("hasSubmitBtn", ctx_r4.hasSubmitBtn)("submitBtnText", ctx_r4.submitBtnText)("numLocale", ctx_r4.numLocale)("formItems", ctx_r4.formItems);
} }
class DefaultListPageComponent extends PageComponent {
    constructor(storage, globals, viasService, next, route, translate, tableDialog, dialogData = {}, dialogRef) {
        super(storage, globals, viasService, next, route, translate, dialogData);
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.tableDialog = tableDialog;
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.hasDatagrid = true;
        this.hasEditForm = false;
    }
    generatePageFromMeta(pageMeta) {
        // parent cagir
        super.generatePageFromMeta(pageMeta);
        this.aid = pageMeta.listAid;
        this.hasButtonbar = pageMeta.hasButtonBarInList;
        this.dgButtons = {
            hasAddBtn: pageMeta.datagridHasAddBtn,
            hasEditBtn: pageMeta.datagridHasEditBtn,
            editBtnText: pageMeta.datagridEditBtnText,
            hasDeleteBtn: pageMeta.datagridHasDeleteBtn
        };
        if (pageMeta.dataGridInitialSort) {
            this.sortObj = pageMeta.dataGridInitialSort;
        }
        this.datagridOptions['hasSelectButton'] = this.pageMeta.hasSelectButton;
        this.datagridOptions['multipleRowSelection'] = this.pageMeta.hasMultiSelectDataGrid;
        if (this.data$ !== undefined) {
            if (this.data$['initDataFields']) {
                pageMeta.initDataFields = Object.assign(Object.assign({}, pageMeta.initDataFields), this.data$['initDataFields']);
            }
            if (this.data$['initDataFieldsForFilterObject']) {
                pageMeta.initDataFieldsForFilterObject = Object.assign(Object.assign({}, pageMeta.initDataFieldsForFilterObject), this.data$['initDataFieldsForFilterObject']);
            }
        }
        if (pageMeta.initDataFieldsForFilterObject !== undefined) {
            this.filtersObj = pageMeta.initDataFieldsForFilterObject;
        }
        this.refreshData();
    }
    viasServiceHandler(r) {
        super.viasServiceHandler(r);
        if (r.data !== undefined) {
            const resp = this.responseFieldParserForDataGrid(r.data, this.pageMeta.responseFields, this.pageMeta.dataGridColumns);
            this.dataSource = resp.dataSource;
            this.columns = resp.dataGridColumns;
            // this.pageMeta.responseFields.forEach(rf => {
            //   if (rf.responseFieldType === ResponseFieldDataSourceType.datagridDataSource) {
            //     if (r.data[rf.fieldName] !== undefined) {
            //       this.dataSource = r.data[rf.fieldName];
            //     }
            //   } else if (rf.responseFieldType === ResponseFieldDataSourceType.datagridFilterDataSource) {
            //     // colonu bul
            //     const colInd: number = this.pageMeta.dataGridColumns.findIndex(
            //       x => x.filterField === rf.componentName
            //     );
            //     const col: DataGridColumn = this.pageMeta.dataGridColumns[colInd];
            //     // seciniz ekle
            //     col.filterDataSource = [{ value: 0, label: 'Seçiniz' } as FilterOptions];
            //     // digerlerini ekle
            //     r.data[rf.fieldName].forEach(obj => {
            //       col.filterDataSource.push({
            //         value: obj[col.filterDataIdField],
            //         label: obj[col.filterDataLabelField]
            //       });
            //     });
            //     // changed lifecyle icin
            //     // kolonu geri yaz
            //     this.pageMeta.dataGridColumns.splice(colInd, 1, col);
            //   }
            // });
            if (r.data[this.pageMeta.pageTotalsField] !== undefined) {
                this.totalPages = r.data[this.pageMeta.pageTotalsField];
                this.datagridOptions['totalPages'] = this.totalPages;
            }
            if (r.data[this.pageMeta.pageNoField] !== undefined) {
                this.pageno = r.data[this.pageMeta.pageNoField];
                this.datagridOptions['pageno'] = this.pageno;
            }
            // islem bitti colonlari gonder
            this.columns = this.pageMeta.dataGridColumns;
        }
    }
    datagridDoubleClickHandler(event) {
        if (this.pageMeta.hasSelectButton) {
            this.datagridSelectBtnClickHandler(event);
        }
        else {
            this.datagridEditBtnClickHandler(event);
        }
    }
    datagridSelectBtnClickHandler(event) {
        if (this.fromDialog) {
            this.dialogRef.close({ data: event });
        }
        else {
            let prevPageData;
            if (this.route['lastSuccessfulNavigation'].previousNavigation.extras.queryParams) {
                prevPageData = this.route['lastSuccessfulNavigation'].previousNavigation.extras.queryParams.page_data;
            }
            else {
                prevPageData = this.route['lastSuccessfulNavigation'].previousNavigation.extractedUrl.queryParams;
            }
            const navigationExtras = {
                queryParams: {
                    page_data: prevPageData,
                    return_data: event.selectedItems
                }
            };
            const prevUrl = this.route['lastSuccessfulNavigation'].previousNavigation.extractedUrl.root.children.primary.segments;
            if (prevUrl.length === 2) {
                this.route.navigate(['/' + prevUrl[0].path + '/' + prevUrl[1].path], navigationExtras);
            }
        }
    }
    datagridAddBtnClickHandler(event) {
        console.log(this.pageMeta.editPageName);
        const passedData = { aid: this.pageMeta.addAid };
        const navigationExtras = {
            queryParams: passedData
        };
        this.route.navigate(['/' + this.moduleName + '/' + this.pageMeta.editPageName], navigationExtras);
    }
    datagridEditBtnClickHandler(event) {
        if (this.pageMeta.passedDataFields !== undefined) {
            const passedData = { aid: this.pageMeta.editAid };
            this.pageMeta.passedDataFields.forEach(pd => {
                if (pd.value !== undefined) {
                    passedData[pd.dbQueryField] = pd.value;
                }
                else {
                    passedData[pd.dbQueryField] = event.item[pd.datagridField];
                }
            });
            const navigationExtras = {
                queryParams: passedData
            };
            // eger # ile geliyor ise adres veriyordur
            // orn
            // editPageName = '#repair-planning/edit-project';
            if (this.pageMeta.editPageName.charAt(0) === '#') {
                // kullanirken bastaki # isaretini kaldiracagiz
                this.route.navigate([this.pageMeta.editPageName.substr(1)], navigationExtras);
            }
            else {
                this.route.navigate(['/' + this.moduleName + '/' + this.pageMeta.editPageName], navigationExtras);
            }
        }
    }
    datagridDeleteBtnClickHandler(event) {
        console.log(event.item);
        if (event.item !== undefined) {
            this.tableDialog.open(ConfirmationDialogComponent, {
                panelClass: 'pageDialog',
                data: {
                    question: 'willbedeleted',
                    confirmText: 'delete',
                    rejectText: 'rejectAction'
                }
            })
                .afterClosed()
                .subscribe(r => {
                if (r !== undefined) {
                    if (r.confirm) {
                        this.viasService.send(this.pid, this.pageMeta.deleteAid, event.item).then(response => {
                            if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                                this.globals.handleErrors(response.error);
                            }
                            this.viasServiceHandler(response);
                        }, err => {
                            alert(err);
                            console.log(err);
                        });
                    }
                }
            });
        }
    }
    butonclickHandler(event) {
        if (event.onClick) {
            event.onClick(event, this.datagridSelectedItem, this.pageMeta, this.route, this.translate, this.storage, this.globals, this.viasService, this.tableDialog, this.filtersObj);
        }
    }
}
DefaultListPageComponent.ɵfac = function DefaultListPageComponent_Factory(t) { return new (t || DefaultListPageComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵɵdirectiveInject(MatDialogRef)); };
DefaultListPageComponent.ɵcmp = ɵɵdefineComponent({ type: DefaultListPageComponent, selectors: [["vias-default-list-page"]], features: [ɵɵInheritDefinitionFeature], decls: 6, vars: 6, consts: [[3, "ngClass"], [4, "ngIf"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange", 4, "ngIf"], [3, "numLocale", "buttons", "itemClick", 4, "ngIf"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange", 4, "ngIf"], [3, "breadcrumbs"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange"], [3, "numLocale", "buttons", "itemClick"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange"], ["form", ""]], template: function DefaultListPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, DefaultListPageComponent_ng_container_1_Template, 3, 1, "ng-container", 1);
        ɵɵtemplate(2, DefaultListPageComponent_ng_container_2_Template, 5, 6, "ng-container", 1);
        ɵɵtemplate(3, DefaultListPageComponent_vias_datagrid_3_Template, 1, 14, "vias-datagrid", 2);
        ɵɵtemplate(4, DefaultListPageComponent_vias_buttonbar_4_Template, 1, 2, "vias-buttonbar", 3);
        ɵɵtemplate(5, DefaultListPageComponent_vias_form_5_Template, 2, 6, "vias-form", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.fromDialog ? "" : "fullScreen");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasDatagrid);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasButtonbar);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasEditForm);
    } }, directives: [NgClass, NgIf, BreadcrumbComponent, DatagridComponent, ButtonbarComponent, FormComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DefaultListPageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-default-list-page',
                templateUrl: '../page/page.component.html',
                styleUrls: ['../page/page.component.scss']
            }]
    }], function () { return [{ type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }, { type: MatDialog }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: MatDialogRef }]; }, null); })();

const _c0$7 = ["form"];
function DefaultEditPageComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelement(1, "vias-breadcrumb", 5);
    ɵɵelement(2, "br");
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("breadcrumbs", ctx_r0.breadcrumbs);
} }
function DefaultEditPageComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementContainerStart(0);
    ɵɵelementStart(1, "h2");
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵpipe(4, "translate");
    ɵɵelementEnd();
    ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵtextInterpolate2("", ɵɵpipeBind1(3, 2, ctx_r1.moduleName), " - ", ɵɵpipeBind1(4, 4, ctx_r1.pageName), "");
} }
function DefaultEditPageComponent_vias_datagrid_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-datagrid", 6);
    ɵɵlistener("refresh", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_refresh_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r5 = ɵɵnextContext(); return ctx_r5.datagridRefreshHandler($event); })("rowClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_rowClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r7 = ɵɵnextContext(); return ctx_r7.datagridClickHandler($event); })("dblClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_dblClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r8 = ɵɵnextContext(); return ctx_r8.datagridDoubleClickHandler($event); })("selectClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_selectClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r9 = ɵɵnextContext(); return ctx_r9.datagridSelectBtnClickHandler($event); })("addClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_addClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r10 = ɵɵnextContext(); return ctx_r10.datagridAddBtnClickHandler($event); })("editClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_editClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r11 = ɵɵnextContext(); return ctx_r11.datagridEditBtnClickHandler($event); })("deleteClick", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_deleteClick_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r12 = ɵɵnextContext(); return ctx_r12.datagridDeleteBtnClickHandler($event); })("columnStateChange", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_columnStateChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r13 = ɵɵnextContext(); return ctx_r13.datagridColumnStateChangeHandler($event); })("cellChange", function DefaultEditPageComponent_vias_datagrid_3_Template_vias_datagrid_cellChange_0_listener($event) { ɵɵrestoreView(_r6); const ctx_r14 = ɵɵnextContext(); return ctx_r14.datagridCellChangeHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵɵnextContext();
    ɵɵproperty("dataSource", ctx_r2.dataSource)("numLocale", ctx_r2.numLocale)("columns", ctx_r2.columns)("currentPage", ctx_r2.pageno)("totalPages", ctx_r2.totalPages)("options", ctx_r2.datagridOptions)("rowClassRules", ctx_r2.rowClassRules)("tableId", ctx_r2.datagridId)("sideMenuItems", ctx_r2.sideMenuItems)("statusBarItems", ctx_r2.statusBarItems)("contextMenuItems", ctx_r2.contextMenuItems)("columnState", ctx_r2.datagridColumnState)("dgButtons", ctx_r2.dgButtons)("enableCharts", ctx_r2.enableCharts);
} }
function DefaultEditPageComponent_vias_buttonbar_4_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-buttonbar", 7);
    ɵɵlistener("itemClick", function DefaultEditPageComponent_vias_buttonbar_4_Template_vias_buttonbar_itemClick_0_listener($event) { ɵɵrestoreView(_r16); const ctx_r15 = ɵɵnextContext(); return ctx_r15.butonclickHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵɵnextContext();
    ɵɵproperty("numLocale", ctx_r3.numLocale)("buttons", ctx_r3.buttonBarItems);
} }
function DefaultEditPageComponent_vias_form_5_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-form", 8, 9);
    ɵɵlistener("formChange", function DefaultEditPageComponent_vias_form_5_Template_vias_form_formChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r18 = ɵɵnextContext(); return ctx_r18.formChangeHandler($event); })("formSubmit", function DefaultEditPageComponent_vias_form_5_Template_vias_form_formSubmit_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r20 = ɵɵnextContext(); return ctx_r20.formSubmitHandler($event); })("formItemClick", function DefaultEditPageComponent_vias_form_5_Template_vias_form_formItemClick_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r21 = ɵɵnextContext(); return ctx_r21.formItemClickHandler($event); })("tabSelectedIndexChange", function DefaultEditPageComponent_vias_form_5_Template_vias_form_tabSelectedIndexChange_0_listener($event) { ɵɵrestoreView(_r19); const ctx_r22 = ɵɵnextContext(); return ctx_r22.tabSelectedIndexChange($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵɵnextContext();
    ɵɵproperty("tabs", ctx_r4.tabs)("tabSelectedIndex", ctx_r4.tabSelectedIndex)("hasSubmitBtn", ctx_r4.hasSubmitBtn)("submitBtnText", ctx_r4.submitBtnText)("numLocale", ctx_r4.numLocale)("formItems", ctx_r4.formItems);
} }
class DefaultEditPageComponent extends PageComponent {
    constructor(storage, globals, viasService, next, route, translate, tableDialog, dialogData = {}, dialogRef) {
        super(storage, globals, viasService, next, route, translate, dialogData);
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.tableDialog = tableDialog;
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.formSubmitFields = {};
        this.hasDatagrid = false;
        this.hasEditForm = true;
    }
    set formRef(form) {
        if (!form) {
            return;
        }
        this.afterFormInit(form);
    }
    afterFormInit(form) {
        // formRef init olunca set ediliyor, yokdsa null
        this.formRefx = form;
        form.formChange.subscribe(changed => {
            // item bul
            const item = this.formItems.find(e => e.name === changed.itemName);
            if (item.onChangedServiceCall !== undefined) {
                const csca = item.onChangedServiceCall;
                csca.forEach(csc => {
                    let data = {};
                    data[csc.data] = changed.val;
                    if (csc.initData !== undefined) {
                        data = Object.assign(Object.assign({}, data), csc.initData);
                    }
                    this.viasService.send(csc.pid, csc.aid, data)
                        .then(r => {
                        console.log(r);
                        if (r.error) {
                            this.globals.handleErrors(r.error);
                        }
                        if (r.data !== undefined) {
                            if (r.data[csc.returnField] !== undefined) {
                                // baska alana deger olarak gir
                                // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                                // tslint:disable-next-line: triple-equals
                                if (csc.otherFieldVal !== undefined && (csc.serviceWorkStatusEditMode == true || this.loadAid != 3)) {
                                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                                    // baska alana data source
                                }
                                else if (csc.otherFieldDataSource !== undefined) {
                                    const fItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                                    const res = r.data[csc.returnField];
                                    const opt = [];
                                    for (const s in res) {
                                        if (s !== undefined) {
                                            opt.push({
                                                label: res[s][fItem.optionsDataLabelField],
                                                data: res[s][fItem.optionsDataIdField]
                                            });
                                        }
                                    }
                                    fItem.options = opt;
                                }
                            }
                        }
                    })
                        .catch(err => {
                        console.log(err);
                    });
                });
            }
            // onchange fonk varsa calistir
            if (item.onChangedFunc !== undefined) {
                console.log(item.onChangedFunc);
                item.onChangedFunc(changed.val, this);
            }
        });
    }
    generatePageFromMeta(pageMeta) {
        super.generatePageFromMeta(pageMeta);
        // this.aid = pageMeta.inspectAid;
        this.editPid = pageMeta.editPid;
        this.submitAid = pageMeta.submitAid;
        this.hasButtonbar = pageMeta.hasButtonBarInEdit;
        this.dgButtons = {
            hasAddBtn: pageMeta.datagridHasAddBtn,
            hasEditBtn: pageMeta.datagridHasEditBtn,
            hasDeleteBtn: pageMeta.datagridHasDeleteBtn
        };
        let disabledOnInspect = false;
        if (pageMeta.formDisableFunctionOnLoad !== undefined) {
            disabledOnInspect = pageMeta.formDisableFunctionOnLoad();
        }
        else if (this.loadAid === pageMeta.inspectAid) {
            disabledOnInspect = true;
        }
        if (pageMeta.formItems !== undefined) {
            pageMeta.formItems.forEach(fi => {
                // disabledOnInspect
                if (fi.disabledOnInspect !== undefined) {
                    if (fi.disabledOnInspect && disabledOnInspect) {
                        fi.disabled = true;
                    }
                }
                // Add
                if (fi.tableAddDialogFields !== undefined) {
                    fi.tableAddClick = ($event) => {
                        this.dialogOpener(fi, $event, fi.tableAddDialogFields);
                    };
                }
                // Edit
                if (fi.tableEditDialogFields !== undefined) {
                    fi.tableEditClick = ($event) => {
                        this.dialogOpener(fi, $event, fi.tableEditDialogFields);
                    };
                    if (fi.tableDblClick === undefined) {
                        fi.tableDblClick = ($event) => {
                            this.dialogOpener(fi, $event, fi.tableEditDialogFields);
                        };
                    }
                }
                // Delete
                if (fi.tableDeleteDialogFields !== undefined) {
                    fi.tableDeleteClick = ($event) => {
                        this.dialogOpener(fi, $event, fi.tableDeleteDialogFields);
                    };
                }
            });
            // bu islem listone servis sonucunda dolarak calisacak
            // zaten super de var di bu fazla olmus...
            this.formItems = pageMeta.formItems;
        }
        // console.log(pageMeta);
        this.viasListOneService();
    }
    dialogOpener(fi, $event, field) {
        if (field.data !== undefined) {
            if (field.data['row'] !== undefined) {
                delete field.data['row'];
            }
        }
        const data = Object.assign({ row: $event.item, parentRef: this }, field.data);
        const panelClass = ['pageDialog'];
        if (field.className !== undefined) {
            panelClass.push(field.className);
        }
        this.tableDialog.open(field.openedPage, {
            panelClass,
            data
        })
            .afterClosed()
            .subscribe(response => {
            field.callBackFunction($event, response, fi, this);
        });
    }
    viasListOneService() {
        let sendData = this.data$;
        if (this.pageMeta.editInitDataFields !== undefined) {
            sendData = Object.assign(Object.assign({}, sendData), this.pageMeta.editInitDataFields);
        }
        const pidx = this.editPid !== undefined && this.editPid > 0 ? this.editPid : this.pid;
        // this.pageMeta.inspectAid
        // this.viasService.send(pidx, this.aid, sendData).then(
        this.viasService.send(pidx, this.pageMeta.inspectAid, sendData).then(response => {
            if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                this.globals.handleErrors(response.error);
            }
            this.viasServiceHandler(response);
        }, err => {
            this.globals.handleErrors([err]);
        });
    }
    viasServiceHandler(r) {
        super.viasServiceHandler(r);
        if (r.data) {
            const x = this.responseFieldParserForForm(r.data, this.pageMeta.responseFields, this.pageMeta.formItems);
            this.formItems = x;
            // form init edildikten sonra,
            // datalar geldikten sonra
            // form ref ile icindeki value lari set et
            this.formItems.forEach(item => {
                // value "0" olarak gördüğünden edit sayfasında işlem yapmıyordu
                // son değişiklik sonrasında formRefx.form.controls boş olduğu için çalışmıyor
                if (this.formRefx.form.controls[item.name] !== undefined) {
                    if (item.type === 'checkbox') {
                        this.formRefx.form.controls[item.name].setValue(item.value * 1);
                    }
                    else if (item.type === 'datepicker') {
                        const d = item.value * 1 === 0 ? null : new Date(item.value * 1000);
                        this.formRefx.form.controls[item.name].setValue(d);
                    }
                    else {
                        this.formRefx.form.controls[item.name].setValue(item.value);
                    }
                }
                if (item.type === 'table') {
                    item.tableButtonBarData = Object.assign(Object.assign({}, item.tableButtonBarData), this.pageGeneralData);
                }
            });
            // sabit submit degerlerini ayarla
            this.formSubmitFields = {};
            if (this.pageMeta.formSubmitFields !== null &&
                this.pageMeta.formSubmitFields !== undefined &&
                this.pageMeta.formSubmitFields.length > 0) {
                this.pageMeta.formSubmitFields.forEach(fsf => {
                    let val = fsf.value;
                    if (fsf.responseFieldType === ResponseFieldDataSourceType.formDataSource) {
                        if (r.data[fsf.responseFieldName] !== undefined) {
                            const datax = r.data[fsf.responseFieldName];
                            val = datax[fsf.responseFieldId];
                        }
                    }
                    this.formSubmitFields[fsf.postFieldName] = val;
                });
            }
        }
        else {
            this.formItems = this.pageMeta.formItems;
        }
    }
    formItemClickHandler($event) {
        if ($event.iconClick !== undefined) {
            $event.iconClick(this, this.storage, this.globals, this.viasService, this.next, this.route, this.translate, this.tableDialog);
        }
    }
    formChangeHandler($event) {
        if (this.pageMeta.formChangeFunction !== undefined) {
            if (this.pageMeta.formChangeFunctionItems !== undefined) {
                this.pageMeta.formChangeFunctionItems.forEach(fi => {
                    if ($event['itemName'] === fi) {
                        this.pageMeta.formChangeFunction($event, this);
                    }
                });
            }
        }
    }
    formTableEditHandler($event) {
        this.tableAddDialogRun($event);
    }
    formSubmitHandler($event) {
        console.log($event);
        console.log(this.formRefx);
        if (this.pageMeta.formBeforeSubmitFunction !== undefined) {
            this.pageMeta.formBeforeSubmitFunction(this, this.formRefx.form, this.storage, this.globals, this.viasService, this.next, this.route, this.translate);
        }
        else {
            const sendData = {};
            this.formItems.forEach(fi => {
                let val = $event[fi.name];
                if (fi.type === FieldTypes.DateCombo) {
                    const d = new Date(val);
                    val = d.getTime() / 1000;
                }
                sendData[fi.name] = val;
            });
            for (const key in this.formSubmitFields) {
                if (this.formSubmitFields[key]) {
                    sendData[key] = this.formSubmitFields[key];
                }
            }
            this.viasService.send(this.pid, this.submitAid, sendData).then(response => {
                // super.viasServiceHandler(response);
                this.globals.viasAlert.show('successful', AlertType.Success);
                this.viasSubmitServiceHandler(response);
            }, err => {
                this.globals.handleErrors([err]);
                // alert(err);
                // console.log(err);
            });
        }
    }
    viasSubmitServiceHandler(response) {
        if (response.error !== null && response.error !== undefined && response.error.length > 0) {
            this.globals.handleErrors(response.error);
        }
        else {
            if (this.pageMeta.formAfterSubmitFunction !== undefined) {
                this.pageMeta.formAfterSubmitFunction(response, this.storage, this.globals, this.viasService, this.next, this.route, this.translate);
            }
            else {
                switch (response.return_action) {
                    // kendini guncelle
                    case 'refresh':
                    case 'refresh_self':
                        this.viasListOneService();
                        break;
                    // formu kapat arkadaki sayfayi guncelle
                    default:
                    case '':
                    case 'success':
                        this.route.navigate(['/' + this.moduleName + '/' + this.pageMeta.listPageName]);
                        break;
                }
            }
        }
    }
}
DefaultEditPageComponent.ɵfac = function DefaultEditPageComponent_Factory(t) { return new (t || DefaultEditPageComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵɵdirectiveInject(MatDialogRef)); };
DefaultEditPageComponent.ɵcmp = ɵɵdefineComponent({ type: DefaultEditPageComponent, selectors: [["vias-default-edit-page"]], viewQuery: function DefaultEditPageComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$7, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.formRef = _t.first);
    } }, features: [ɵɵInheritDefinitionFeature], decls: 6, vars: 6, consts: [[3, "ngClass"], [4, "ngIf"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange", 4, "ngIf"], [3, "numLocale", "buttons", "itemClick", 4, "ngIf"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange", 4, "ngIf"], [3, "breadcrumbs"], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "statusBarItems", "contextMenuItems", "columnState", "dgButtons", "enableCharts", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange", "cellChange"], [3, "numLocale", "buttons", "itemClick"], [3, "tabs", "tabSelectedIndex", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick", "tabSelectedIndexChange"], ["form", ""]], template: function DefaultEditPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵtemplate(1, DefaultEditPageComponent_ng_container_1_Template, 3, 1, "ng-container", 1);
        ɵɵtemplate(2, DefaultEditPageComponent_ng_container_2_Template, 5, 6, "ng-container", 1);
        ɵɵtemplate(3, DefaultEditPageComponent_vias_datagrid_3_Template, 1, 14, "vias-datagrid", 2);
        ɵɵtemplate(4, DefaultEditPageComponent_vias_buttonbar_4_Template, 1, 2, "vias-buttonbar", 3);
        ɵɵtemplate(5, DefaultEditPageComponent_vias_form_5_Template, 2, 6, "vias-form", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.fromDialog ? "" : "fullScreen");
        ɵɵadvance(1);
        ɵɵproperty("ngIf", !ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.fromDialog);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasDatagrid);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasButtonbar);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasEditForm);
    } }, directives: [NgClass, NgIf, BreadcrumbComponent, DatagridComponent, ButtonbarComponent, FormComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DefaultEditPageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-default-edit-page',
                templateUrl: '../page/page.component.html',
                styleUrls: ['../page/page.component.scss']
            }]
    }], function () { return [{ type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }, { type: MatDialog }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: MatDialogRef }]; }, { formRef: [{
            type: ViewChild,
            args: ['form', { static: false }]
        }] }); })();

class OnlyNumericDirective {
    constructor(el) {
        this.el = el;
        this.regex = new RegExp(/^[0-9]+([,.]+[0-9]*){0,1}$/g);
        this.specialKeys = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];
    }
    onKeyDown(event) {
        if (this.specialKeys.indexOf(event.key) !== -1) {
            return;
        }
        const current = this.el.nativeElement.value;
        const next = current.concat(event.key);
        if (next && !String(next).match(this.regex)) {
            event.preventDefault();
        }
    }
}
OnlyNumericDirective.ɵfac = function OnlyNumericDirective_Factory(t) { return new (t || OnlyNumericDirective)(ɵɵdirectiveInject(ElementRef)); };
OnlyNumericDirective.ɵdir = ɵɵdefineDirective({ type: OnlyNumericDirective, selectors: [["", "viasOnlyNumeric", ""]], hostBindings: function OnlyNumericDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("keydown", function OnlyNumericDirective_keydown_HostBindingHandler($event) { return ctx.onKeyDown($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(OnlyNumericDirective, [{
        type: Directive,
        args: [{
                selector: '[viasOnlyNumeric]'
            }]
    }], function () { return [{ type: ElementRef }]; }, { onKeyDown: [{
            type: HostListener,
            args: ['keydown', ['$event']]
        }] }); })();

const _c0$8 = ["filterText"];
class NumericFilterComponent {
    constructor() {
        this.value = '';
    }
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
    }
    isFilterActive() {
        return this.value !== null && this.value !== undefined && this.value !== '';
    }
    doesFilterPass(params) {
        if (this.isLocalRefresh) {
            return this.value.toLowerCase()
                .split(' ')
                .every((filterWord) => {
                return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
            });
        }
        else {
            //  db ye gidecek. hep true gelmesi lazim...
            return true;
        }
    }
    getModel() {
        return { value: this.value };
    }
    setModel(model) {
        this.value = model ? model.value : '';
    }
    ngAfterViewInit() {
        window.setTimeout(() => {
            this.theText.nativeElement.focus();
            this.theText.nativeElement.value = this.value;
        });
    }
    onChange(newValue) {
        if (this.value !== newValue) {
            this.value = newValue;
            this.params.filterChangedCallback();
        }
    }
}
NumericFilterComponent.ɵfac = function NumericFilterComponent_Factory(t) { return new (t || NumericFilterComponent)(); };
NumericFilterComponent.ɵcmp = ɵɵdefineComponent({ type: NumericFilterComponent, selectors: [["vias-numeric-cell"]], viewQuery: function NumericFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$8, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.theText = _t.first);
    } }, decls: 2, vars: 2, consts: [["viasOnlyNumeric", "", 3, "value", "ngModel", "ngModelChange"], ["filterText", ""]], template: function NumericFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "input", 0, 1);
        ɵɵlistener("ngModelChange", function NumericFilterComponent_Template_input_ngModelChange_0_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("value", _r0)("ngModel", _r0);
    } }, directives: [DefaultValueAccessor, OnlyNumericDirective, NgControlStatus, NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NumericFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-numeric-cell',
                template: `<input #filterText viasOnlyNumeric [value]="filterText" [ngModel]="filterText" (ngModelChange)="onChange($event)"/>`,
            }]
    }], null, { theText: [{
            type: ViewChild,
            args: ['filterText', { static: false }]
        }] }); })();

const _c0$9 = ["dateRange"];
const _c1$2 = ["dateStart"];
const _c2 = ["dateEnd"];
class DateFilterComponent {
    constructor() {
        this.value = 0;
        this.dateRangeValue = 0;
        this.startDate = new Date();
        this.endDate = new Date();
    }
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
    }
    isFilterActive() {
        return this.startDate !== null && this.startDate !== undefined && this.startDate.getTime() !== 0;
    }
    doesFilterPass(params) {
        if (this.isLocalRefresh) {
            const itemVal = Number.parseInt(this.valueGetter(params.node), 10);
            return (itemVal > this.startDate.getTime() / 1000
                && itemVal < this.endDate.getTime() / 1000);
            // return this.value.toLowerCase()
            // .split(' ')
            // .every((filterWord) => {
            //     return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) >= 0;
            // });
        }
        else {
            //  db ye gidecek. hep true gelmesi lazim...
            return true;
        }
    }
    getModel() {
        return { value: this.value };
    }
    setModel(model) {
        this.value = model ? model.value : '';
    }
    ngAfterViewInit() {
        window.setTimeout(() => {
            // this.dateRange.nativeElement.classList.add('ag-custom-component-popup');
            //   this.dateRange.nativeElement.value = this.value;
        });
    }
    onDateRangeChange(val) {
        switch (Number.parseInt(val, 10)) {
            default:
            case 0:
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case -1:
                this.startDate = new Date();
                this.startDate.setDate(this.startDate.getDate() - 1);
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setDate(this.endDate.getDate() - 1);
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 1:
                this.startDate = new Date();
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 7:
                this.startDate = new Date();
                this.startDate.setDate(this.startDate.getDate() - 7);
                this.startDate.setHours(0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate.setHours(23, 59, 59, 999);
                break;
            case 30:
                this.startDate = new Date();
                this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), 1, 0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 0, 23, 59, 59, 999);
                break;
            case 365:
                this.startDate = new Date();
                this.startDate = new Date(this.startDate.getFullYear(), 0, 1, 0, 0, 0, 0);
                this.endDate = new Date();
                this.endDate = new Date(this.endDate.getFullYear(), 11, 31, 23, 59, 59, 999);
                break;
        }
        this.params.filterChangedCallback();
    }
}
DateFilterComponent.ɵfac = function DateFilterComponent_Factory(t) { return new (t || DateFilterComponent)(); };
DateFilterComponent.ɵcmp = ɵɵdefineComponent({ type: DateFilterComponent, selectors: [["vias-date-cell"]], viewQuery: function DateFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$9, true);
        ɵɵviewQuery(_c1$2, true);
        ɵɵviewQuery(_c2, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dateRange = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dateStart = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.dateEnd = _t.first);
    } }, features: [ɵɵProvidersFeature([{ provide: MAT_DATE_LOCALE, useValue: 'tr-TR' }])], decls: 25, vars: 7, consts: [[1, "ag-input-wrapper", "custom-date-filter"], ["panelClass", "ag-custom-component-popup", 3, "ngModel", "ngModelChange"], ["dateRange", ""], ["value", "0"], ["value", "1"], ["value", "-1"], ["value", "7"], ["value", "30"], ["value", "365"], [3, "matDatepicker", "value"], [3, "for"], ["panelClass", "ag-custom-component-popup"], ["dateStart", ""], ["dateEnd", ""]], template: function DateFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-select", 1, 2);
        ɵɵlistener("ngModelChange", function DateFilterComponent_Template_mat_select_ngModelChange_1_listener($event) { return ctx.onDateRangeChange($event); });
        ɵɵelementStart(3, "mat-option", 3);
        ɵɵtext(4, "Tarih Aral\u0131\u011F\u0131");
        ɵɵelementEnd();
        ɵɵelementStart(5, "mat-option", 4);
        ɵɵtext(6, "Bug\u00FCn");
        ɵɵelementEnd();
        ɵɵelementStart(7, "mat-option", 5);
        ɵɵtext(8, "D\u00FCn");
        ɵɵelementEnd();
        ɵɵelementStart(9, "mat-option", 6);
        ɵɵtext(10, "Bir Haftal\u0131k");
        ɵɵelementEnd();
        ɵɵelementStart(11, "mat-option", 7);
        ɵɵtext(12, "Bu Ay");
        ɵɵelementEnd();
        ɵɵelementStart(13, "mat-option", 8);
        ɵɵtext(14, "Bu Y\u0131l");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(15, "br");
        ɵɵelement(16, "input", 9);
        ɵɵelement(17, "mat-datepicker-toggle", 10);
        ɵɵelement(18, "mat-datepicker", 11, 12);
        ɵɵelement(20, "br");
        ɵɵelement(21, "input", 9);
        ɵɵelement(22, "mat-datepicker-toggle", 10);
        ɵɵelement(23, "mat-datepicker", 11, 13);
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵɵreference(19);
        const _r2 = ɵɵreference(24);
        ɵɵadvance(1);
        ɵɵproperty("ngModel", ctx.dateRangeValue);
        ɵɵadvance(15);
        ɵɵproperty("matDatepicker", _r1)("value", ctx.startDate);
        ɵɵadvance(1);
        ɵɵproperty("for", _r1);
        ɵɵadvance(4);
        ɵɵproperty("matDatepicker", _r2)("value", ctx.endDate);
        ɵɵadvance(1);
        ɵɵproperty("for", _r2);
    } }, directives: [MatSelect, NgControlStatus, NgModel, MatOption, MatDatepickerInput, MatDatepickerToggle, MatDatepicker], styles: [".custom-date-filter[_ngcontent-%COMP%] {\n            padding:10px;\n        }"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DateFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-date-cell',
                // template: `<input #filterText [value]="filterText" [ngModel]="filterText" (ngModelChange)="onChange($event)"/>`,
                template: `<div class="ag-input-wrapper custom-date-filter">
        <mat-select #dateRange [ngModel]="dateRangeValue"
            (ngModelChange)="onDateRangeChange($event)"
            panelClass="ag-custom-component-popup">
            <mat-option value="0">Tarih Aralığı</mat-option>
            <mat-option value="1">Bugün</mat-option>
            <mat-option value="-1">Dün</mat-option>
            <mat-option value="7">Bir Haftalık</mat-option>
            <mat-option value="30">Bu Ay</mat-option>
            <mat-option value="365">Bu Yıl</mat-option>
        </mat-select><br/>
        <input [matDatepicker]="dateStart" [value]="startDate">
        <mat-datepicker-toggle [for]="dateStart"></mat-datepicker-toggle>
        <mat-datepicker #dateStart
        panelClass="ag-custom-component-popup"></mat-datepicker><br/>
        <input [matDatepicker]="dateEnd" [value]="endDate">
        <mat-datepicker-toggle [for]="dateEnd"></mat-datepicker-toggle>
        <mat-datepicker #dateEnd
        panelClass="ag-custom-component-popup"></mat-datepicker>
    </div>`,
                styles: [
                    `.custom-date-filter {
            padding:10px;
        }`
                ],
                providers: [{ provide: MAT_DATE_LOCALE, useValue: 'tr-TR' }]
            }]
    }], null, { dateRange: [{
            type: ViewChild,
            args: ['dateRange', { static: false }]
        }], dateStart: [{
            type: ViewChild,
            args: ['dateStart', { static: false }]
        }], dateEnd: [{
            type: ViewChild,
            args: ['dateEnd', { static: false }]
        }] }); })();

const _c0$a = ["filterSelect"];
class DropDownFilterComponent {
    constructor() {
        this.text = '';
        this.value = -1;
    }
    agInit(params) {
        this.params = params;
        this.valueGetter = params.valueGetter;
        this.isLocalRefresh = params['isLocalRefresh'];
        if (params.colDef.filterParams !== null) {
            this.options = params.colDef.filterParams.filterDataSource;
        }
    }
    isFilterActive() {
        return this.value !== null && this.value !== undefined && this.value !== -1;
        // return this.text !== null && this.text !== undefined && this.text !== '';
    }
    doesFilterPass(params) {
        if (this.isLocalRefresh) {
            const val = params.data[this.params.colDef.field];
            // tslint:disable-next-line: radix
            return this.value === parseInt(val);
        }
        else {
            return true;
        }
    }
    getModel() {
        return { value: this.value };
    }
    setModel(model) {
        this.value = model ? model.value : -1;
    }
    // ngAfterViewInit(params: IAfterGuiAttachedParams): void {
    ngAfterViewInit() {
        const sel = this.theSelect.element.nativeElement;
        this.options.forEach(o => {
            const opt = document.createElement('option');
            opt.value = o.value.toString();
            opt.text = o.label;
            sel.add(opt, null);
        });
        window.setTimeout(() => {
            this.theSelect.element.nativeElement.focus();
        });
    }
    onChange(newValue) {
        if (this.value !== newValue) {
            this.value = newValue;
            this.params.filterChangedCallback();
        }
    }
}
DropDownFilterComponent.ɵfac = function DropDownFilterComponent_Factory(t) { return new (t || DropDownFilterComponent)(); };
DropDownFilterComponent.ɵcmp = ɵɵdefineComponent({ type: DropDownFilterComponent, selectors: [["vias-filter-cell"]], viewQuery: function DropDownFilterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$a, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.theSelect = _t.first);
    } }, decls: 2, vars: 1, consts: [[3, "ngModel", "ngModelChange"], ["filterSelect", ""]], template: function DropDownFilterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "select", 0, 1);
        ɵɵlistener("ngModelChange", function DropDownFilterComponent_Template_select_ngModelChange_0_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵɵreference(1);
        ɵɵproperty("ngModel", _r0);
    } }, directives: [SelectControlValueAccessor, NgControlStatus, NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DropDownFilterComponent, [{
        type: Component,
        args: [{
                selector: 'vias-filter-cell',
                template: `<select #filterSelect [ngModel]="filterSelect" (ngModelChange)="onChange($event)"></select>`,
            }]
    }], null, { theSelect: [{
            type: ViewChild,
            args: ['filterSelect', { read: ViewContainerRef, static: false }]
        }] }); })();

const _c0$b = ["filterSelect"];
class EditorAutoCompleteComponent {
    constructor() {
        this.text = '';
        this.value = -1;
        this.options2 = ['One', 'Two', 'Three'];
    }
    agInit(params) {
        this.form = new FormGroup({ filterSelect: new FormControl() });
        this.item = {
            type: FieldTypes.AutoComplete,
            name: 'filterSelect',
            value: this.value,
        };
        this.params = params;
        if (params.colDef.filterParams !== null) {
            this.options = params.colDef.filterParams.filterDataSource;
        }
        this.value = params.value;
    }
    ngAfterViewInit() {
        this.item.options = [];
        this.options.forEach(o => {
            this.item.options.push({
                label: o.label,
                data: o.value.toString()
            });
        });
        // window.setTimeout(() => {
        //     console.log("asads2",this.theSelect);
        //     // this.theSelect.element.nativeElement.focus();
        // },500);
    }
    afterGuiAttached() {
        this.filterSelect.element.nativeElement.focus();
        console.log(this.filterSelect);
    }
    onChange(newValue) {
        console.log('+___+');
        // this.theSelect.element.nativeElement.value;
        if (newValue !== undefined) {
            if (this.value !== newValue) {
                this.value = newValue;
            }
        }
    }
    getValue() {
        return this.value;
    }
    isPopup() {
        return false;
    }
}
EditorAutoCompleteComponent.ɵfac = function EditorAutoCompleteComponent_Factory(t) { return new (t || EditorAutoCompleteComponent)(); };
EditorAutoCompleteComponent.ɵcmp = ɵɵdefineComponent({ type: EditorAutoCompleteComponent, selectors: [["vias-editor-cell"]], viewQuery: function EditorAutoCompleteComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$b, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.filterSelect = _t.first);
    } }, decls: 2, vars: 2, consts: [[3, "form", "item", "onchange"], ["filterSelect", ""]], template: function EditorAutoCompleteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "vias-autocomplete", 0, 1);
        ɵɵlistener("onchange", function EditorAutoCompleteComponent_Template_vias_autocomplete_onchange_0_listener($event) { return ctx.onChange($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("form", ctx.form)("item", ctx.item);
    } }, directives: [AutocompleteComponent], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EditorAutoCompleteComponent, [{
        type: Component,
        args: [{
                selector: 'vias-editor-cell',
                template: `<vias-autocomplete #filterSelect [form]="form" [item]="item" (onchange)="onChange($event)"></vias-autocomplete>`,
            }]
    }], null, { filterSelect: [{
            type: ViewChild,
            args: ['filterSelect', { read: ViewContainerRef, static: true }]
        }] }); })();

const _c0$c = ["input"];
class EditorDecimalNumericComponent {
    constructor() {
        this.cancelBeforeStart = false;
    }
    agInit(params) {
        this.params = params;
        this.value = this.params.value;
        // only start edit if key pressed is a number, not a letter
        this.cancelBeforeStart =
            params.charPress && '1234567890'.indexOf(params.charPress) < 0;
    }
    getValue() {
        return this.value;
    }
    isCancelBeforeStart() {
        return this.cancelBeforeStart;
    }
    // will reject the number if it greater than 1,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd() {
        return this.value > 1000000;
    }
    onKeyDown(event) {
        if (!this.isKeyPressedNumeric(event)) {
            if (event.defaultPrevented)
                event.preventDefault();
        }
    }
    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        window.setTimeout(() => {
            this.input.element.nativeElement.focus();
        });
    }
    getCharCodeFromEvent(event) {
        event = event || window.event;
        return typeof event.which == 'undefined' ? event.keyCode : event.which;
    }
    isCharNumeric(charStr) {
        var regex = new RegExp(/^[0-9]+(.[0-9]*){0,1}$/g);
        return regex.test(charStr);
    }
    isKeyPressedNumeric(event) {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        return charStr;
    }
}
EditorDecimalNumericComponent.ɵfac = function EditorDecimalNumericComponent_Factory(t) { return new (t || EditorDecimalNumericComponent)(); };
EditorDecimalNumericComponent.ɵcmp = ɵɵdefineComponent({ type: EditorDecimalNumericComponent, selectors: [["numeric-cell"]], viewQuery: function EditorDecimalNumericComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$c, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.input = _t.first);
    } }, decls: 2, vars: 1, consts: [["viasOnlyNumeric", "", 2, "width", "100%", 3, "ngModel", "keydown", "ngModelChange"], ["input", ""]], template: function EditorDecimalNumericComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "input", 0, 1);
        ɵɵlistener("keydown", function EditorDecimalNumericComponent_Template_input_keydown_0_listener($event) { return ctx.onKeyDown($event); })("ngModelChange", function EditorDecimalNumericComponent_Template_input_ngModelChange_0_listener($event) { return ctx.value = $event; });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngModel", ctx.value);
    } }, directives: [DefaultValueAccessor, OnlyNumericDirective, NgControlStatus, NgModel], encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EditorDecimalNumericComponent, [{
        type: Component,
        args: [{
                selector: 'numeric-cell',
                template: `
      <input
        #input
        viasOnlyNumeric
        (keydown)="onKeyDown($event)"
        [(ngModel)]="value"
        style="width: 100%"
      />
    `,
            }]
    }], null, { input: [{
            type: ViewChild,
            args: ['input', { read: ViewContainerRef, static: true }]
        }] }); })();

class DefaultDialogPageComponent {
    constructor() { }
    ngOnInit() {
    }
}
DefaultDialogPageComponent.ɵfac = function DefaultDialogPageComponent_Factory(t) { return new (t || DefaultDialogPageComponent)(); };
DefaultDialogPageComponent.ɵcmp = ɵɵdefineComponent({ type: DefaultDialogPageComponent, selectors: [["vias-default-dialog-page"]], decls: 0, vars: 0, template: function DefaultDialogPageComponent_Template(rf, ctx) { }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DefaultDialogPageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-default-dialog-page',
                templateUrl: './default-dialog-page.component.html',
                styleUrls: ['./default-dialog-page.component.scss']
            }]
    }], function () { return []; }, null); })();

const _c0$d = ["formDialog"];
class EditDialogComponent {
    constructor(globals, viasService, translate, dialogRef, data) {
        this.globals = globals;
        this.viasService = viasService;
        this.translate = translate;
        this.dialogRef = dialogRef;
        this.data = data;
        this.pageName = '';
        this.hasSubmitButton = true;
        this.submitBtnText = 'save';
        this.formItems = [];
        this.numLocale = this.globals.numLocale;
        if (data.pageName !== undefined) {
            this.pageName = data.pageName;
        }
        if (data.hasSubmitButton !== undefined) {
            this.hasSubmitButton = data.hasSubmitButton;
        }
        if (data.submitBtnText !== undefined) {
            this.submitBtnText = data.submitBtnText;
        }
        if (data.formItems !== undefined) {
            this.formItems = data.formItems;
        }
        if (data.parentRef !== undefined) {
            if (data.parentRef.pageGeneralData !== undefined) {
                this.pageGeneralData = data.parentRef.pageGeneralData;
            }
        }
        if (data.pageGeneralData !== undefined) {
            this.pageGeneralData = data.parentRef.pageGeneralData;
        }
        if (data.row !== undefined) {
            this.formData = data.row;
        }
        this.submitBtnText = globals.getTranslate(this.submitBtnText);
        this.formItems.forEach(e => {
            if (this.pageGeneralData !== undefined) {
                if (e.optionsFieldName !== undefined) {
                    if (this.pageGeneralData[e.optionsFieldName] !== undefined) {
                        e.options = [];
                        this.pageGeneralData[e.optionsFieldName].forEach(data => {
                            const lbl = data[e.optionsDataLabelField !== undefined ? e.optionsDataLabelField : 'name'];
                            e.options.push({
                                label: this.globals.getTranslate(lbl),
                                data: data[e.optionsDataIdField !== undefined ? e.optionsDataIdField : 'id'].toString()
                            });
                        });
                    }
                }
            }
            if (this.formData !== undefined) {
                if (this.formData[e.name] !== undefined) {
                    if (e.type === FieldTypes.DatePicker) {
                        e.value = this.formData[e.name] * 1 === 0 ? null : new Date(this.formData[e.name] * 1000);
                    }
                    else if (e.type === FieldTypes.CheckBox) {
                        e.value = Number(this.formData[e.name]);
                    }
                    else {
                        e.value = this.formData[e.name];
                    }
                }
            }
            if (e.options !== undefined) {
                e.options.forEach(eo => {
                    eo.label = this.globals.getTranslate(eo.label);
                });
            }
            this.translate.get(e.label).subscribe((translated) => {
                e.label = translated;
            });
        });
    }
    set formRef(formDialog) {
        if (!formDialog) {
            return;
        }
        this.afterFormInit(formDialog);
    }
    onNoClick() {
        this.dialogRef.close();
    }
    onSubmit(formData) {
        this.dialogRef.close({ formData });
    }
    formItemClickHandler($event) {
        if ($event.iconClick !== undefined) {
            $event.iconClick(this, this.globals, this.viasService, this.translate);
        }
    }
    afterFormInit(form) {
        // formRef init olunca set ediliyor, yokdsa null
        this.formRefx = form;
        form.formChange.subscribe(changed => {
            // item bul
            const item = this.formItems.find(e => e.name === changed.itemName);
            if (item.onChangedServiceCall !== undefined) {
                const csca = item.onChangedServiceCall;
                csca.forEach(csc => {
                    let data = {};
                    data[csc.data] = changed.val;
                    if (csc.initData !== undefined) {
                        data = Object.assign(Object.assign({}, data), csc.initData);
                    }
                    if (csc.isContractor === undefined) {
                        csc.isContractor = false;
                    }
                    let serviceUrl = csc.isContractor === true ? this.globals.contractorServerURL : this.globals.serverURL;
                    this.viasService.send(csc.pid, csc.aid, data, serviceUrl)
                        .then(r => {
                        console.log(r);
                        if (r.error) {
                            this.globals.handleErrors(r.error);
                        }
                        if (r.data !== undefined) {
                            if (r.data[csc.returnField] !== undefined) {
                                // baska alana deger olarak gir
                                // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                                // tslint:disable-next-line: triple-equals
                                if (csc.otherFieldVal !== undefined) {
                                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                                    // baska alana data source
                                }
                                else if (csc.otherFieldDataSource !== undefined) {
                                    const fItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                                    const res = r.data[csc.returnField];
                                    const opt = [];
                                    for (const s in res) {
                                        if (s !== undefined) {
                                            opt.push({
                                                label: res[s][fItem.optionsDataLabelField],
                                                data: res[s][fItem.optionsDataIdField]
                                            });
                                        }
                                    }
                                    fItem.options = opt;
                                }
                            }
                        }
                    })
                        .catch(err => {
                        console.log(err);
                    });
                });
            }
            // onchange fonk varsa calistir
            if (item.onChangedFunc !== undefined) {
                console.log(item.onChangedFunc);
                item.onChangedFunc(changed.val, this);
            }
        });
        //set value
        this.formItems.forEach(item => {
            if (this.formRefx.form.controls[item.name] !== undefined) {
                if (item.type === 'checkbox') {
                    this.formRefx.form.controls[item.name].setValue(item.value * 1);
                }
                else if (item.type === 'datepicker') {
                    const d = new Date(item.value * 1000);
                    this.formRefx.form.controls[item.name].setValue(d);
                }
                else {
                    this.formRefx.form.controls[item.name].setValue(item.value);
                }
            }
        });
    }
}
EditDialogComponent.ɵfac = function EditDialogComponent_Factory(t) { return new (t || EditDialogComponent)(ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
EditDialogComponent.ɵcmp = ɵɵdefineComponent({ type: EditDialogComponent, selectors: [["vias-edit-dialog"]], viewQuery: function EditDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$d, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.formRef = _t.first);
    } }, decls: 6, vars: 7, consts: [["mat-dialog-content", ""], [3, "formItems", "hasSubmitBtn", "submitBtnText", "numLocale", "formSubmit", "formItemClick"], ["formDialog", ""]], template: function EditDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "h3");
        ɵɵtext(2);
        ɵɵpipe(3, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(4, "vias-form", 1, 2);
        ɵɵlistener("formSubmit", function EditDialogComponent_Template_vias_form_formSubmit_4_listener($event) { return ctx.onSubmit($event); })("formItemClick", function EditDialogComponent_Template_vias_form_formItemClick_4_listener($event) { return ctx.formItemClickHandler($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(2);
        ɵɵtextInterpolate(ɵɵpipeBind1(3, 5, ctx.pageName));
        ɵɵadvance(2);
        ɵɵproperty("formItems", ctx.formItems)("hasSubmitBtn", ctx.hasSubmitButton)("submitBtnText", ctx.submitBtnText)("numLocale", ctx.numLocale);
    } }, directives: [FormComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(EditDialogComponent, [{
        type: Component,
        args: [{
                selector: 'vias-edit-dialog',
                templateUrl: './edit-dialog.component.html',
                styleUrls: ['./edit-dialog.component.scss']
            }]
    }], function () { return [{ type: GlobalsService }, { type: ViasConnectionService }, { type: TranslateService }, { type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { formRef: [{
            type: ViewChild,
            args: ['formDialog', { static: false }]
        }] }); })();

const _c0$e = ["formApproval"];
function ApprovalProcessesDialogComponent_h2_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h2", 3);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, ctx_r0.pageName));
} }
class ApprovalProcessesDialogComponent {
    constructor(globals, translate, dialogRef, data) {
        this.globals = globals;
        this.translate = translate;
        this.dialogRef = dialogRef;
        this.data = data;
        this.approvalPersons = [];
        this.approvalCount = 0;
        this.formItems = [];
        this.numLocale = this.globals.numLocale;
        if (data.pid !== undefined) {
            this.pid = Number(data.pid);
        }
        if (data.pageName !== undefined) {
            this.pageName = data.pageName;
        }
        if (data.data !== undefined) {
            this.headData = data.data;
        }
        if (data.approvalPersons !== undefined) {
            this.approvalPersons = data.approvalPersons;
        }
        for (let ix = 1; ix <= this.approvalPersons.length; ix++) {
            let confirmUser = false;
            const status = Number(this.headData.status);
            if (this.pid === 2800) { //Purchase Orders
                if (Number(this.approvalPersons[ix - 1]['id']) === Number(sessionStorage.getItem('userId')) &&
                    ((ix === 1 && status === 0) ||
                        (ix === 2 && status === 6) ||
                        (ix === 3 && status === 8) ||
                        (ix === 4 && status === 9))) {
                    confirmUser = true;
                    this.approvalCount = ix;
                }
                else {
                    confirmUser = false;
                }
            }
            else if (this.pid === 8600 || this.pid === 8900) { //Discovery Account Forms - Shipyard Account Forms
                let first = true;
                const subStatus = Number(this.approvalPersons[ix - 1]['approval_status']);
                if (subStatus === 9) {
                    if (Number(this.approvalPersons[ix - 1]['updated_by']) === Number(sessionStorage.getItem('userId')) &&
                        ((ix === 1 && Number(this.approvalPersons[ix - 1]['approved_by1']) === 0) ||
                            (ix === 2 && Number(this.approvalPersons[ix - 1]['approved_by2']) === 0) ||
                            (ix === 3 && Number(this.approvalPersons[ix - 1]['approved_by3']) === 0) ||
                            (ix === 4 && Number(this.approvalPersons[ix - 1]['approved_by4']) === 0) ||
                            (ix === 5 && Number(this.approvalPersons[ix - 1]['approved_by5']) === 0)) && first) {
                        first = false;
                        confirmUser = true;
                        this.approvalCount = ix;
                    }
                    else {
                        confirmUser = false;
                    }
                }
                else if (Number(this.approvalPersons[ix - 1]['id']) === Number(sessionStorage.getItem('userId')) &&
                    ((ix === 1 && subStatus === 0) ||
                        (ix === 2 && subStatus === 6) ||
                        (ix === 3 && subStatus === 7) ||
                        (ix === 4 && subStatus === 8) ||
                        (ix === 5 && subStatus === 10))) {
                    confirmUser = true;
                    this.approvalCount = ix;
                }
                else {
                    confirmUser = false;
                }
            }
            this.formItems.push({
                type: FieldTypes.Text,
                label: 'approver_' + ix.toString(),
                name: 'approvedBy' + ix.toString(),
                disabled: true,
                value: this.approvalPersons[ix - 1]['name'],
                componentFixedWidth: 2
            });
            this.formItems.push({
                type: FieldTypes.Text,
                label: 'notes',
                name: 'approvedNote' + ix.toString(),
                disabled: !confirmUser,
                multiline: true,
                componentFixedWidth: 2
            });
            if (confirmUser) {
                this.formItems.push({
                    type: FieldTypes.Button,
                    label: 'confirm',
                    name: 'confirm',
                    icon: true,
                    icon_type: 'check',
                    iconClick($event) { }
                });
                this.formItems.push({
                    type: FieldTypes.Button,
                    label: 'deny',
                    name: 'deny',
                    icon: true,
                    icon_type: 'close',
                    color: 'warn',
                    iconClick($event) { }
                });
                if (this.pid === 8600 || this.pid === 8900) {
                    this.formItems.push({
                        type: FieldTypes.Button,
                        label: 'waited',
                        name: 'wait',
                        icon: true,
                        icon_type: 'hourglass_empty',
                        color: 'accent',
                        iconClick($event) { }
                    });
                }
            }
            let val = '';
            if (this.pid === 8600 || this.pid === 8900) {
                val = this.approvalPersons[ix - 1]['approved_note' + ix.toString()];
            }
            else {
                val = ix === 1 ? this.headData['remarks'] : this.headData['remarks' + ix.toString()];
            }
            this.formItems.find(fi => fi.name === 'approvedNote' + ix.toString()).value = val;
        }
        this.formItems.forEach(e => {
            this.translate.get(e.label).subscribe((translated) => {
                e.label = translated;
            });
        });
    }
    set formRef(formApproval) {
        if (!formApproval) {
            return;
        }
        this.formRefx = formApproval;
    }
    formItemIconClickHandler($event) {
        if ($event.name === 'confirm') {
            this.dialogRef.close({ confirm: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
        }
        if ($event.name === 'deny') {
            this.dialogRef.close({ deny: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
        }
        if ($event.name === 'wait') {
            this.dialogRef.close({ wait: true, notes: this.formRefx.value['approvedNote' + this.approvalCount.toString()] });
        }
    }
}
ApprovalProcessesDialogComponent.ɵfac = function ApprovalProcessesDialogComponent_Factory(t) { return new (t || ApprovalProcessesDialogComponent)(ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialogRef), ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
ApprovalProcessesDialogComponent.ɵcmp = ɵɵdefineComponent({ type: ApprovalProcessesDialogComponent, selectors: [["vias-approval-processes-dialog"]], viewQuery: function ApprovalProcessesDialogComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$e, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.formRef = _t.first);
    } }, decls: 3, vars: 3, consts: [["mat-dialog-title", "", 4, "ngIf"], [3, "formItems", "numLocale", "formItemClick"], ["formApproval", ""], ["mat-dialog-title", ""]], template: function ApprovalProcessesDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ApprovalProcessesDialogComponent_h2_0_Template, 3, 3, "h2", 0);
        ɵɵelementStart(1, "vias-form", 1, 2);
        ɵɵlistener("formItemClick", function ApprovalProcessesDialogComponent_Template_vias_form_formItemClick_1_listener($event) { return ctx.formItemIconClickHandler($event); });
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.data.pageName !== undefined);
        ɵɵadvance(1);
        ɵɵproperty("formItems", ctx.formItems)("numLocale", ctx.numLocale);
    } }, directives: [NgIf, FormComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ApprovalProcessesDialogComponent, [{
        type: Component,
        args: [{
                selector: 'vias-approval-processes-dialog',
                templateUrl: './approval-processes-dialog.component.html',
                styleUrls: ['./approval-processes-dialog.component.scss']
            }]
    }], function () { return [{ type: GlobalsService }, { type: TranslateService }, { type: MatDialogRef }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, { formRef: [{
            type: ViewChild,
            args: ['formApproval', { static: false }]
        }] }); })();

const _c0$f = ["form"];
function DefaultReportPageComponent_vias_buttonbar_8_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵɵgetCurrentView();
    ɵɵelementStart(0, "vias-buttonbar", 5);
    ɵɵlistener("itemClick", function DefaultReportPageComponent_vias_buttonbar_8_Template_vias_buttonbar_itemClick_0_listener($event) { ɵɵrestoreView(_r3); const ctx_r2 = ɵɵnextContext(); return ctx_r2.butonclickHandler($event); });
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵɵnextContext();
    ɵɵproperty("numLocale", ctx_r1.numLocale)("buttons", ctx_r1.buttonBarItems);
} }
class DefaultReportPageComponent extends PageComponent {
    constructor(storage, globals, viasService, next, route, translate, tableDialog, dialogData = {}, dialogRef) {
        super(storage, globals, viasService, next, route, translate, dialogData);
        this.storage = storage;
        this.globals = globals;
        this.viasService = viasService;
        this.next = next;
        this.route = route;
        this.translate = translate;
        this.tableDialog = tableDialog;
        this.dialogData = dialogData;
        this.dialogRef = dialogRef;
        this.formSubmitFields = {};
        this.hasDatagrid = true;
        this.hasEditForm = true;
    }
    set formRef(form) {
        if (!form) {
            return;
        }
        this.afterFormInit(form);
    }
    afterFormInit(form) {
        // formRef init olunca set ediliyor, yokdsa null
        this.formRefx = form;
        form.formChange.subscribe(changed => {
            // item bul
            const item = this.formItems.find(e => e.name === changed.itemName);
            if (item.onChangedServiceCall !== undefined) {
                const csca = item.onChangedServiceCall;
                csca.forEach(csc => {
                    const data = {};
                    data[csc.data] = changed.val;
                    this.viasService.send(csc.pid, csc.aid, data)
                        .then(r => {
                        console.log(r);
                        if (r.error) {
                            this.globals.handleErrors(r.error);
                        }
                        if (r.data !== undefined) {
                            if (r.data[csc.returnField] !== undefined) {
                                // baska alana deger olarak gir
                                // serviceWorkStatusEditMode bu alan true ise edit modunda da çalışacak
                                // tslint:disable-next-line: triple-equals
                                if (csc.otherFieldVal !== undefined && (csc.serviceWorkStatusEditMode == true || this.loadAid != 3)) {
                                    form.form.get(csc.otherFieldVal).setValue(r.data[csc.returnField]);
                                    // baska alana data source
                                }
                                else if (csc.otherFieldDataSource !== undefined) {
                                    const fItem = form.formItems.find(e => e.name === csc.otherFieldDataSource);
                                    const res = r.data[csc.returnField];
                                    const opt = [];
                                    for (const s in res) {
                                        if (s !== undefined) {
                                            opt.push({
                                                label: res[s][fItem.optionsDataLabelField],
                                                data: res[s][fItem.optionsDataIdField]
                                            });
                                        }
                                    }
                                    fItem.options = opt;
                                }
                            }
                        }
                    })
                        .catch(err => {
                        console.log(err);
                    });
                });
            }
            // onchange fonk varsa calistir
            if (item.onChangedFunc !== undefined) {
                console.log(item.onChangedFunc);
                item.onChangedFunc(changed.val, this);
            }
        });
    }
    formItemClickHandler($event) {
        if ($event.iconClick !== undefined) {
            $event.iconClick(this, this.storage, this.globals, this.viasService, this.next, this.route, this.translate, this.tableDialog);
        }
    }
    formChangeHandler($event) {
        if (this.pageMeta.formChangeFunction !== undefined) {
            if (this.pageMeta.formChangeFunctionItems !== undefined) {
                this.pageMeta.formChangeFunctionItems.forEach(fi => {
                    if ($event['itemName'] === fi) {
                        this.pageMeta.formChangeFunction($event, this);
                    }
                });
            }
        }
        console.log($event);
    }
    formTableEditHandler($event) {
        this.tableAddDialogRun($event);
    }
    formSubmitHandler($event) {
        console.log($event);
        console.log(this.formRefx);
        if (this.pageMeta.formBeforeSubmitFunction !== undefined) {
            this.pageMeta.formBeforeSubmitFunction(this, this.formRefx.form, this.storage, this.globals, this.viasService, this.next, this.route, this.translate);
        }
        else {
            const sendData = {};
            this.formItems.forEach(fi => {
                let val = $event[fi.name];
                if (fi.type === FieldTypes.DateCombo) {
                    const d = new Date(val);
                    val = d.getTime() / 1000;
                }
                sendData[fi.name] = val;
            });
            for (const key in this.formSubmitFields) {
                if (this.formSubmitFields[key]) {
                    sendData[key] = this.formSubmitFields[key];
                }
            }
            this.viasService.send(this.pid, this.submitAid, sendData).then(response => {
                // super.viasServiceHandler(response);
                this.globals.viasAlert.show('successful', AlertType.Success);
                this.viasSubmitServiceHandler(response);
            }, err => {
                this.globals.handleErrors([err]);
                // alert(err);
                // console.log(err);
            });
        }
    }
    viasSubmitServiceHandler(response) {
        if (response.error !== null && response.error !== undefined && response.error.length > 0) {
            this.globals.handleErrors(response.error);
        }
        else {
            if (this.pageMeta.formAfterSubmitFunction !== undefined) {
                this.pageMeta.formAfterSubmitFunction(response, this.storage, this.globals, this.viasService, this.next, this.route, this.translate);
            }
            else {
                switch (response.return_action) {
                    // kendini guncelle
                    case 'refresh':
                    case 'refresh_self':
                        this.viasListOneService();
                        break;
                    // formu kapat arkadaki sayfayi guncelle
                    default:
                    case '':
                    case 'success':
                        this.route.navigate(['/' + this.moduleName + '/' + this.pageMeta.listPageName]);
                        break;
                }
            }
        }
    }
    viasListOneService() {
        let sendData = this.data$;
        if (this.pageMeta.editInitDataFields !== undefined) {
            sendData = Object.assign(Object.assign({}, sendData), this.pageMeta.editInitDataFields);
        }
        const pidx = this.editPid !== undefined && this.editPid > 0 ? this.editPid : this.pid;
        // this.pageMeta.inspectAid
        // this.viasService.send(pidx, this.aid, sendData).then(
        this.viasService.send(pidx, this.pageMeta.inspectAid, sendData).then(response => {
            if (response.error !== null && response.error !== undefined && response.error.length > 0) {
                this.globals.handleErrors(response.error);
            }
            this.viasServiceHandler(response);
        }, err => {
            this.globals.handleErrors([err]);
        });
    }
}
DefaultReportPageComponent.ɵfac = function DefaultReportPageComponent_Factory(t) { return new (t || DefaultReportPageComponent)(ɵɵdirectiveInject(StorageService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(MatDialog), ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵɵdirectiveInject(MatDialogRef)); };
DefaultReportPageComponent.ɵcmp = ɵɵdefineComponent({ type: DefaultReportPageComponent, selectors: [["vias-default-report-page"]], viewQuery: function DefaultReportPageComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$f, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.formRef = _t.first);
    } }, features: [ɵɵInheritDefinitionFeature], decls: 9, vars: 25, consts: [[3, "ngClass"], [3, "tabs", "hasSubmitBtn", "submitBtnText", "numLocale", "formItems", "formChange", "formSubmit", "formItemClick"], ["form", ""], [3, "dataSource", "numLocale", "columns", "currentPage", "totalPages", "options", "rowClassRules", "tableId", "sideMenuItems", "contextMenuItems", "columnState", "dgButtons", "refresh", "rowClick", "dblClick", "selectClick", "addClick", "editClick", "deleteClick", "columnStateChange"], [3, "numLocale", "buttons", "itemClick", 4, "ngIf"], [3, "numLocale", "buttons", "itemClick"]], template: function DefaultReportPageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "h2");
        ɵɵtext(2);
        ɵɵpipe(3, "translate");
        ɵɵpipe(4, "translate");
        ɵɵelementEnd();
        ɵɵelementStart(5, "vias-form", 1, 2);
        ɵɵlistener("formChange", function DefaultReportPageComponent_Template_vias_form_formChange_5_listener($event) { return ctx.formChangeHandler($event); })("formSubmit", function DefaultReportPageComponent_Template_vias_form_formSubmit_5_listener($event) { return ctx.formSubmitHandler($event); })("formItemClick", function DefaultReportPageComponent_Template_vias_form_formItemClick_5_listener($event) { return ctx.formItemClickHandler($event); });
        ɵɵelementEnd();
        ɵɵelementStart(7, "vias-datagrid", 3);
        ɵɵlistener("refresh", function DefaultReportPageComponent_Template_vias_datagrid_refresh_7_listener($event) { return ctx.datagridRefreshHandler($event); })("rowClick", function DefaultReportPageComponent_Template_vias_datagrid_rowClick_7_listener($event) { return ctx.datagridClickHandler($event); })("dblClick", function DefaultReportPageComponent_Template_vias_datagrid_dblClick_7_listener($event) { return ctx.datagridDoubleClickHandler($event); })("selectClick", function DefaultReportPageComponent_Template_vias_datagrid_selectClick_7_listener($event) { return ctx.datagridSelectBtnClickHandler($event); })("addClick", function DefaultReportPageComponent_Template_vias_datagrid_addClick_7_listener($event) { return ctx.datagridAddBtnClickHandler($event); })("editClick", function DefaultReportPageComponent_Template_vias_datagrid_editClick_7_listener($event) { return ctx.datagridEditBtnClickHandler($event); })("deleteClick", function DefaultReportPageComponent_Template_vias_datagrid_deleteClick_7_listener($event) { return ctx.datagridDeleteBtnClickHandler($event); })("columnStateChange", function DefaultReportPageComponent_Template_vias_datagrid_columnStateChange_7_listener($event) { return ctx.datagridColumnStateChangeHandler($event); });
        ɵɵelementEnd();
        ɵɵtemplate(8, DefaultReportPageComponent_vias_buttonbar_8_Template, 1, 2, "vias-buttonbar", 4);
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngClass", ctx.fromDialog ? "" : "fullScreen");
        ɵɵadvance(2);
        ɵɵtextInterpolate2("", ɵɵpipeBind1(3, 21, ctx.moduleName), " - ", ɵɵpipeBind1(4, 23, ctx.pageName), "");
        ɵɵadvance(3);
        ɵɵproperty("tabs", ctx.tabs)("hasSubmitBtn", ctx.hasSubmitBtn)("submitBtnText", ctx.submitBtnText)("numLocale", ctx.numLocale)("formItems", ctx.formItems);
        ɵɵadvance(2);
        ɵɵproperty("dataSource", ctx.dataSource)("numLocale", ctx.numLocale)("columns", ctx.columns)("currentPage", ctx.pageno)("totalPages", ctx.totalPages)("options", ctx.datagridOptions)("rowClassRules", ctx.rowClassRules)("tableId", ctx.datagridId)("sideMenuItems", ctx.sideMenuItems)("contextMenuItems", ctx.contextMenuItems)("columnState", ctx.datagridColumnState)("dgButtons", ctx.dgButtons);
        ɵɵadvance(1);
        ɵɵproperty("ngIf", ctx.hasButtonbar);
    } }, directives: [NgClass, FormComponent, DatagridComponent, NgIf, ButtonbarComponent], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(DefaultReportPageComponent, [{
        type: Component,
        args: [{
                selector: 'vias-default-report-page',
                templateUrl: './default-report-page.component.html',
                styleUrls: ['./default-report-page.component.scss']
            }]
    }], function () { return [{ type: StorageService }, { type: GlobalsService }, { type: ViasConnectionService }, { type: ActivatedRoute }, { type: Router }, { type: TranslateService }, { type: MatDialog }, { type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: MatDialogRef }]; }, { formRef: [{
            type: ViewChild,
            args: ['form', { static: false }]
        }] }); })();

function ProgressSpinnerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div", 1);
    ɵɵelementStart(1, "div", 2);
    ɵɵelement(2, "mat-progress-spinner", 3);
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(2);
    ɵɵproperty("diameter", ctx_r0.diameter)("mode", ctx_r0.mode)("color", ctx_r0.color)("strokeWidth", ctx_r0.strokeWidth)("value", ctx_r0.value);
} }
class ProgressSpinnerComponent {
    constructor() {
        this.run = true;
        this.value = 100;
        this.diameter = 70;
        this.mode = 'indeterminate';
        this.strokeWidth = 8;
        this.overlay = true;
        this.color = 'primary';
    }
    ngOnInit() {
    }
}
ProgressSpinnerComponent.ɵfac = function ProgressSpinnerComponent_Factory(t) { return new (t || ProgressSpinnerComponent)(); };
ProgressSpinnerComponent.ɵcmp = ɵɵdefineComponent({ type: ProgressSpinnerComponent, selectors: [["vias-progress-spinner"]], inputs: { run: "run", value: "value", diameter: "diameter", mode: "mode", strokeWidth: "strokeWidth", overlay: "overlay", color: "color" }, decls: 1, vars: 1, consts: [["class", "overlay", 4, "ngIf"], [1, "overlay"], [1, "center"], [3, "diameter", "mode", "color", "strokeWidth", "value"]], template: function ProgressSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, ProgressSpinnerComponent_div_0_Template, 3, 5, "div", 0);
    } if (rf & 2) {
        ɵɵproperty("ngIf", ctx.run);
    } }, directives: [NgIf, MatProgressSpinner], styles: [".center[_ngcontent-%COMP%]{left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%)}.overlay[_ngcontent-%COMP%]{background-color:hsla(0,0%,60.8%,.199);height:100vh;left:0;position:fixed;top:0;width:100%;z-index:10}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ProgressSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'vias-progress-spinner',
                templateUrl: './progress-spinner.component.html',
                styleUrls: ['./progress-spinner.component.scss']
            }]
    }], function () { return []; }, { run: [{
            type: Input
        }], value: [{
            type: Input
        }], diameter: [{
            type: Input
        }], mode: [{
            type: Input
        }], strokeWidth: [{
            type: Input
        }], overlay: [{
            type: Input
        }], color: [{
            type: Input
        }] }); })();

class ComponentsModule {
}
ComponentsModule.ɵmod = ɵɵdefineNgModule({ type: ComponentsModule });
ComponentsModule.ɵinj = ɵɵdefineInjector({ factory: function ComponentsModule_Factory(t) { return new (t || ComponentsModule)(); }, imports: [[
            CommonModule,
            TranslateModule,
            AgGridModule.withComponents([
                AutoCompleteFilterComponent,
                DropDownFilterComponent,
                DgFilterComponent,
                TextFilterComponent,
                NumericFilterComponent,
                DateFilterComponent,
                EditorAutoCompleteComponent,
                ActionsSideToolBarComponent,
                EditorDecimalNumericComponent
            ]),
            ReactiveFormsModule,
            FormsModule,
            MatTableModule,
            MatFormFieldModule,
            MatInputModule,
            MatPaginatorModule,
            MatSelectModule,
            MatCheckboxModule,
            MatRadioModule,
            MatTabsModule,
            MatDatepickerModule,
            MatMomentDateModule,
            MatProgressSpinnerModule,
            MatNativeDateModule,
            MatAutocompleteModule,
            MatIconModule,
            MatSnackBarModule,
            MatGridListModule,
            MatButtonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ComponentsModule, { declarations: [DatagridComponent,
        AutoCompleteFilterComponent,
        DropDownFilterComponent,
        EditorAutoCompleteComponent,
        ActionsSideToolBarComponent,
        EditorDecimalNumericComponent,
        DgFilterComponent,
        TextFilterComponent,
        DateFilterComponent,
        NumericFilterComponent,
        CheckboxComponent,
        DropdownComponent,
        RadioComponent,
        FileComponent,
        ImgComponent,
        AutocompleteComponent,
        DatepickerComponent,
        DatecomboComponent,
        ButtonComponent,
        InputComponent,
        PageViewerComponent,
        PageViewerSafeUrlPipe,
        FormComponent,
        FormItemDirective,
        ButtonbarComponent,
        PageComponent,
        DefaultMasterDetailPageComponent,
        DefaultListPageComponent,
        DefaultEditPageComponent,
        OnlyNumericDirective,
        TableComponent,
        DefaultDialogPageComponent,
        ConfirmationDialogComponent,
        EditDialogComponent,
        ApprovalProcessesDialogComponent,
        DefaultReportPageComponent,
        ProgressSpinnerComponent,
        BreadcrumbComponent,
        InfoCardComponent], imports: [CommonModule,
        TranslateModule, AgGridModule, ReactiveFormsModule,
        FormsModule,
        MatTableModule,
        MatFormFieldModule,
        MatInputModule,
        MatPaginatorModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        MatTabsModule,
        MatDatepickerModule,
        MatMomentDateModule,
        MatProgressSpinnerModule,
        MatNativeDateModule,
        MatAutocompleteModule,
        MatIconModule,
        MatSnackBarModule,
        MatGridListModule,
        MatButtonModule], exports: [DatagridComponent,
        CheckboxComponent,
        DropdownComponent,
        RadioComponent,
        FileComponent,
        ImgComponent,
        AutocompleteComponent,
        DatepickerComponent,
        DatecomboComponent,
        ButtonComponent,
        InputComponent,
        PageViewerComponent,
        PageViewerSafeUrlPipe,
        FormComponent,
        ButtonbarComponent,
        PageComponent,
        DefaultMasterDetailPageComponent,
        DefaultListPageComponent,
        DefaultEditPageComponent,
        DefaultReportPageComponent,
        ProgressSpinnerComponent,
        TableComponent,
        ConfirmationDialogComponent,
        EditDialogComponent,
        ApprovalProcessesDialogComponent,
        BreadcrumbComponent,
        InfoCardComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ComponentsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DatagridComponent,
                    AutoCompleteFilterComponent,
                    DropDownFilterComponent,
                    EditorAutoCompleteComponent,
                    ActionsSideToolBarComponent,
                    EditorDecimalNumericComponent,
                    DgFilterComponent,
                    TextFilterComponent,
                    DateFilterComponent,
                    NumericFilterComponent,
                    CheckboxComponent,
                    DropdownComponent,
                    RadioComponent,
                    FileComponent,
                    ImgComponent,
                    AutocompleteComponent,
                    DatepickerComponent,
                    DatecomboComponent,
                    ButtonComponent,
                    InputComponent,
                    PageViewerComponent,
                    PageViewerSafeUrlPipe,
                    FormComponent,
                    FormItemDirective,
                    ButtonbarComponent,
                    PageComponent,
                    DefaultMasterDetailPageComponent,
                    DefaultListPageComponent,
                    DefaultEditPageComponent,
                    OnlyNumericDirective,
                    TableComponent,
                    DefaultDialogPageComponent,
                    ConfirmationDialogComponent,
                    EditDialogComponent,
                    ApprovalProcessesDialogComponent,
                    DefaultReportPageComponent,
                    ProgressSpinnerComponent,
                    BreadcrumbComponent,
                    InfoCardComponent,
                ],
                imports: [
                    CommonModule,
                    TranslateModule,
                    AgGridModule.withComponents([
                        AutoCompleteFilterComponent,
                        DropDownFilterComponent,
                        DgFilterComponent,
                        TextFilterComponent,
                        NumericFilterComponent,
                        DateFilterComponent,
                        EditorAutoCompleteComponent,
                        ActionsSideToolBarComponent,
                        EditorDecimalNumericComponent
                    ]),
                    ReactiveFormsModule,
                    FormsModule,
                    MatTableModule,
                    MatFormFieldModule,
                    MatInputModule,
                    MatPaginatorModule,
                    MatSelectModule,
                    MatCheckboxModule,
                    MatRadioModule,
                    MatTabsModule,
                    MatDatepickerModule,
                    MatMomentDateModule,
                    MatProgressSpinnerModule,
                    MatNativeDateModule,
                    MatAutocompleteModule,
                    MatIconModule,
                    MatSnackBarModule,
                    MatGridListModule,
                    MatButtonModule
                ],
                entryComponents: [
                    CheckboxComponent,
                    DropdownComponent,
                    RadioComponent,
                    FileComponent,
                    ImgComponent,
                    AutocompleteComponent,
                    DatepickerComponent,
                    DatecomboComponent,
                    ButtonComponent,
                    InputComponent,
                    PageViewerComponent,
                    ButtonbarComponent,
                    TableComponent
                ],
                exports: [
                    DatagridComponent,
                    CheckboxComponent,
                    DropdownComponent,
                    RadioComponent,
                    FileComponent,
                    ImgComponent,
                    AutocompleteComponent,
                    DatepickerComponent,
                    DatecomboComponent,
                    ButtonComponent,
                    InputComponent,
                    PageViewerComponent,
                    PageViewerSafeUrlPipe,
                    FormComponent,
                    ButtonbarComponent,
                    PageComponent,
                    DefaultMasterDetailPageComponent,
                    DefaultListPageComponent,
                    DefaultEditPageComponent,
                    DefaultReportPageComponent,
                    ProgressSpinnerComponent,
                    TableComponent,
                    ConfirmationDialogComponent,
                    EditDialogComponent,
                    ApprovalProcessesDialogComponent,
                    BreadcrumbComponent,
                    InfoCardComponent
                ],
            }]
    }], null, null); })();

class DashboardModule {
}
DashboardModule.ɵmod = ɵɵdefineNgModule({ type: DashboardModule });
DashboardModule.ɵinj = ɵɵdefineInjector({ factory: function DashboardModule_Factory(t) { return new (t || DashboardModule)(); }, imports: [[
            CommonModule,
            RouterModule.forChild([
                { path: '', component: DashboardComponent, pathMatch: 'full' }
            ]),
            MatIconModule,
            MatCardModule,
            MatButtonModule,
            MatListModule,
            MatProgressBarModule,
            MatMenuModule,
            MatTableModule,
            MatSnackBarModule,
            FlexLayoutModule,
            AgmCoreModule,
            NgxChartsModule,
            ComponentsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(DashboardModule, { declarations: [DashboardComponent], imports: [CommonModule, RouterModule, MatIconModule,
        MatCardModule,
        MatButtonModule,
        MatListModule,
        MatProgressBarModule,
        MatMenuModule,
        MatTableModule,
        MatSnackBarModule,
        FlexLayoutModule,
        AgmCoreModule,
        NgxChartsModule,
        ComponentsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(DashboardModule, [{
        type: NgModule,
        args: [{
                declarations: [DashboardComponent],
                imports: [
                    CommonModule,
                    RouterModule.forChild([
                        { path: '', component: DashboardComponent, pathMatch: 'full' }
                    ]),
                    MatIconModule,
                    MatCardModule,
                    MatButtonModule,
                    MatListModule,
                    MatProgressBarModule,
                    MatMenuModule,
                    MatTableModule,
                    MatSnackBarModule,
                    FlexLayoutModule,
                    AgmCoreModule,
                    NgxChartsModule,
                    ComponentsModule
                ]
            }]
    }], null, null); })();

class ViasAuthLogoutService {
    constructor(globals, router) {
        this.globals = globals;
        this.router = router;
    }
    canActivate(next, state) {
        this.globals.logout();
        return true;
    }
}
ViasAuthLogoutService.ɵfac = function ViasAuthLogoutService_Factory(t) { return new (t || ViasAuthLogoutService)(ɵɵinject(GlobalsService), ɵɵinject(Router)); };
ViasAuthLogoutService.ɵprov = ɵɵdefineInjectable({ token: ViasAuthLogoutService, factory: ViasAuthLogoutService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasAuthLogoutService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GlobalsService }, { type: Router }]; }, null); })();

const _c0$g = ["errorTxt"];
function ForgotComponent_small_25_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "small", 11);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "errorTexts.e_general_051"), "");
} }
const _c1$3 = function () { return ["/account/login"]; };
class ForgotComponent {
    constructor(fb, router, globals, viasService, translate) {
        this.fb = fb;
        this.router = router;
        this.globals = globals;
        this.viasService = viasService;
        this.translate = translate;
        this.email = '';
        translate.use(globals.langLocale.substr(0, 2));
    }
    ngOnInit() {
        this.globals.logout();
        this.form = this.fb.group({
            email: [null, Validators.compose([Validators.required, Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$')])]
        });
    }
    sendMail() {
        if (this.form.valid) {
            console.log(this.form.value);
            this.viasService.send(0, 6, {
                email: this.form.value.email,
                firmId: this.globals.selectedFirmId
            }).then(r => {
                if (r.error !== null &&
                    r.error !== undefined && r.error.length > 0) {
                    this.globals.handleErrors(r.error);
                }
                else if (r.return_action !== null &&
                    r.return_action !== undefined && r.return_action.length > 0) {
                    if ((r.return_action === ViasReturnActions$1.Success)) {
                        this.globals.viasAlert.show('successful', AlertType$1.Success);
                    }
                }
            }, err => {
                alert(err);
                console.log(err);
            });
        }
    }
    openLoginPage() {
        this.router.navigate(['/account/login']);
    }
}
ForgotComponent.ɵfac = function ForgotComponent_Factory(t) { return new (t || ForgotComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(TranslateService)); };
ForgotComponent.ɵcmp = ɵɵdefineComponent({ type: ForgotComponent, selectors: [["vias-forgot"]], viewQuery: function ForgotComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$g, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.errorTxt = _t.first);
    } }, decls: 33, vars: 21, consts: [[1, "session"], [1, "overflow-hidden"], ["fxLayout", "row wrap"], ["fxFlex.gt-xs", "50", "fxFlex", "100", 1, "bg-image", "bg-image-signin"], ["fxLayout", "row", "fxLayoutAlign", "space-evenly center", 1, "h-100", "py-3"], [1, "text-xs-center", "pb-1", "mat-text-white"], ["src", "assets/images/vias_logo_en.png", "width", "280"], ["fxFlex.gt-xs", "50", "fxFlex", "100"], [1, "pa-3"], [1, "mb-0"], [1, "mat-text-muted", "text-md", "mt-0", "mb-2"], [1, "mat-text-warn"], ["errorTxt", ""], [3, "formGroup", "ngSubmit"], ["fxLayout", "column", "fxLayoutAlign", "space-around"], [1, "pb-1"], [2, "width", "100%"], ["matInput", "", 3, "placeholder", "formControl"], ["matSuffix", ""], ["class", "mat-text-warn", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled"], [1, "pt-1", "pb-1", "text-xs-right", 2, "color", "blue"], [3, "routerLink"]], template: function ForgotComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-card", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelement(6, "img", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 7);
        ɵɵelementStart(8, "mat-card-content", 8);
        ɵɵelementStart(9, "h1", 9);
        ɵɵtext(10);
        ɵɵpipe(11, "translate");
        ɵɵelementEnd();
        ɵɵelementStart(12, "p", 10);
        ɵɵtext(13);
        ɵɵpipe(14, "translate");
        ɵɵelementEnd();
        ɵɵelement(15, "p", 11, 12);
        ɵɵelementStart(17, "form", 13);
        ɵɵlistener("ngSubmit", function ForgotComponent_Template_form_ngSubmit_17_listener() { return ctx.sendMail(); });
        ɵɵelementStart(18, "div", 14);
        ɵɵelementStart(19, "div", 15);
        ɵɵelementStart(20, "mat-form-field", 16);
        ɵɵelement(21, "input", 17);
        ɵɵpipe(22, "translate");
        ɵɵelementStart(23, "mat-icon", 18);
        ɵɵtext(24, "mail");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(25, ForgotComponent_small_25_Template, 3, 3, "small", 19);
        ɵɵelementEnd();
        ɵɵelementStart(26, "button", 20);
        ɵɵtext(27);
        ɵɵpipe(28, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(29, "div", 21);
        ɵɵelementStart(30, "a", 22);
        ɵɵtext(31);
        ɵɵpipe(32, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(10);
        ɵɵtextInterpolate(ɵɵpipeBind1(11, 10, "forgotPass"));
        ɵɵadvance(3);
        ɵɵtextInterpolate(ɵɵpipeBind1(14, 12, "errorTexts.e_general_104"));
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵpropertyInterpolate("placeholder", ɵɵpipeBind1(22, 14, "email"));
        ɵɵproperty("formControl", ctx.form.controls["email"]);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", (ctx.form.controls["email"].hasError("required") || !ctx.form.valid) && ctx.form.controls["email"].touched);
        ɵɵadvance(1);
        ɵɵproperty("disabled", !ctx.form.valid);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ɵɵpipeBind1(28, 16, "sendMail"));
        ɵɵadvance(3);
        ɵɵproperty("routerLink", ɵɵpureFunction0(20, _c1$3));
        ɵɵadvance(1);
        ɵɵtextInterpolate(ɵɵpipeBind1(32, 18, "login"));
    } }, directives: [MatCard, DefaultLayoutDirective, DefaultFlexDirective, DefaultLayoutAlignDirective, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, MatFormField, MatInput, DefaultValueAccessor, NgControlStatus, FormControlDirective, MatIcon, MatSuffix, NgIf, MatButton, RouterLinkWithHref], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ForgotComponent, [{
        type: Component,
        args: [{
                selector: 'vias-forgot',
                templateUrl: './forgot.component.html',
                styleUrls: ['./forgot.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }, { type: Router }, { type: GlobalsService }, { type: ViasConnectionService }, { type: TranslateService }]; }, { errorTxt: [{
            type: ViewChild,
            args: ['errorTxt', { static: true }]
        }] }); })();

function LockscreenComponent_small_15_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "small", 13);
    ɵɵtext(1, "Username is required.");
    ɵɵelementEnd();
} }
class LockscreenComponent {
    constructor(fb, router) {
        this.fb = fb;
        this.router = router;
    }
    ngOnInit() {
        this.form = this.fb.group({
            uname: [null, Validators.compose([Validators.required])]
        });
    }
    onSubmit() {
        this.router.navigate(['/dashboard']);
    }
}
LockscreenComponent.ɵfac = function LockscreenComponent_Factory(t) { return new (t || LockscreenComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(Router)); };
LockscreenComponent.ɵcmp = ɵɵdefineComponent({ type: LockscreenComponent, selectors: [["vias-lockscreen"]], decls: 19, vars: 4, consts: [[1, "session"], [1, "lockscreen-wrapper", "text-xs-center"], [3, "formGroup", "ngSubmit"], [1, "lockscreen-avatar"], ["src", "assets/images/avatar.jpg", "alt", "user", "title", "user", 1, "radius-round"], [1, "center-block", "mt-1"], ["fxLayout", "column", "fxLayoutAlign", "space-around"], [1, "pb-1"], [2, "width", "100%"], ["matInput", "", "placeholder", "Username", 3, "formControl"], ["matSuffix", ""], ["class", "mat-text-warn", 4, "ngIf"], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled"], [1, "mat-text-warn"]], template: function LockscreenComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "mat-card");
        ɵɵelementStart(3, "mat-card-content");
        ɵɵelementStart(4, "form", 2);
        ɵɵlistener("ngSubmit", function LockscreenComponent_Template_form_ngSubmit_4_listener() { return ctx.onSubmit(); });
        ɵɵelementStart(5, "div", 3);
        ɵɵelement(6, "img", 4);
        ɵɵelementEnd();
        ɵɵelementStart(7, "p", 5);
        ɵɵtext(8, "David Miller");
        ɵɵelementEnd();
        ɵɵelementStart(9, "div", 6);
        ɵɵelementStart(10, "div", 7);
        ɵɵelementStart(11, "mat-form-field", 8);
        ɵɵelement(12, "input", 9);
        ɵɵelementStart(13, "mat-icon", 10);
        ɵɵtext(14, "lock");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(15, LockscreenComponent_small_15_Template, 2, 0, "small", 11);
        ɵɵelementEnd();
        ɵɵelementStart(16, "div");
        ɵɵelementStart(17, "button", 12);
        ɵɵtext(18, "Unlock");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(8);
        ɵɵproperty("formControl", ctx.form.controls["uname"]);
        ɵɵadvance(3);
        ɵɵproperty("ngIf", ctx.form.controls["uname"].hasError("required") && ctx.form.controls["uname"].touched);
        ɵɵadvance(2);
        ɵɵproperty("disabled", !ctx.form.valid);
    } }, directives: [MatCard, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, DefaultLayoutDirective, DefaultLayoutAlignDirective, MatFormField, MatInput, DefaultValueAccessor, NgControlStatus, FormControlDirective, MatIcon, MatSuffix, NgIf, MatButton], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LockscreenComponent, [{
        type: Component,
        args: [{
                selector: 'vias-lockscreen',
                templateUrl: './lockscreen.component.html',
                styleUrls: ['./lockscreen.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }, { type: Router }]; }, null); })();

const _c0$h = ["errorTxt"];
function LoginComponent_small_22_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "small", 10);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate1(" ", ɵɵpipeBind1(2, 1, "errorTexts.e_0000_001"), "");
} }
function LoginComponent_small_29_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "small", 10);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, "errorTexts.e_0000_002"));
} }
class LoginComponent {
    constructor(fb, router, next, globals, viasService, translate) {
        this.fb = fb;
        this.router = router;
        this.next = next;
        this.globals = globals;
        this.viasService = viasService;
        this.translate = translate;
        this.username = '';
        this.rememberMe = false;
        translate.use(globals.langLocale.substr(0, 2));
    }
    ngOnInit() {
        this.form = this.fb.group({
            username: [null, Validators.compose([Validators.required])],
            password: [null, Validators.compose([Validators.required])],
            remember: []
        });
        if (this.globals.rememberLoginName !== undefined
            && this.globals.rememberLoginName !== null
            && this.globals.rememberLoginName.length > 0) {
            this.form.setValue({
                username: this.globals.rememberLoginName,
                password: '',
                remember: true
            });
        }
    }
    onSubmit() {
        this.router.navigate(['/']);
    }
    // sifreyi sifrele
    encryptPassword(str) {
        for (let i = 0; i < 5; i++) {
            str = btoa(str).split('').reverse().join('');
        }
        return str;
    }
    validateLoginData() {
        let allOk = true;
        if (!(this.form.value.username.length > 2)) {
            this.errorTxt.nativeElement.innerHTML = 'Kullanınıcı Adınızı Hatalıdır';
            allOk = false;
        }
        if (!(this.form.value.password.length > 2)) {
            this.errorTxt.nativeElement.innerHTML = 'Şifreniz Hatalıdır';
            allOk = false;
        }
        return allOk;
    }
    // ?data={%22username%22:%22hob%22,%22password%22:%22iZkWyZleGNlUsRmeX1GdXJ1aKVVVB1TP%22,%22firmId%22:2}
    login() {
        // console.log(this.form.value);
        if (this.validateLoginData()) {
            if (this.form.value.remember === true) {
                this.globals.rememberLoginName = this.form.value.username;
            }
            else {
                this.globals.rememberLoginName = '';
            }
            this.viasService.send(0, 0, {
                username: this.form.value.username,
                password: this.encryptPassword(this.form.value.password),
                firmId: this.globals.selectedFirmId,
            }).then(response => this.serviceHandler(response));
        }
    }
    // login servis handler
    serviceHandler(r) {
        return __awaiter(this, void 0, void 0, function* () {
            // hatalar
            if (r.error) {
                this.globals.handleErrors(r.error);
                this.errorTxt.nativeElement.innerHTML = 'Kullanıcı Adınız veya Şifreniz Hatalıdır';
            }
            // sayfa yetkileri
            if (r.perm) {
            }
            // return action
            if (r.return_action) {
            }
            // gelen veriler
            if (r.data) {
                if (r.data.hasOwnProperty('permissions')) {
                    const perm = [];
                    for (const s in r.data['permissions']) {
                        if (s) {
                            perm.push({
                                pageId: Number.parseInt(s, 10),
                                permission: r.data['permissions'][s]
                            });
                        }
                    }
                    this.globals.pagePermissions = perm;
                }
                /// login bilgileri
                if (r.data.hasOwnProperty('login_bilgileri')) {
                    const login = r.data['login_bilgileri'];
                    // global degiskenleri set et
                    this.globals.userNameSurname = login.name + ' ' + login.surname;
                    this.globals.userId = login.id;
                    this.globals.userSectionId = login.section_id;
                    this.globals.langLocale = login.user_locale;
                    this.globals.numLocale = login.user_locale.replace('_', '-');
                    this.globals.userProjectType = login.project_type;
                    this.globals.userDepartmentId = login.department_id;
                    this.globals.userDefaultModuleId = login.default_module_id;
                    this.globals.userDefaultPageId = login.default_page_id;
                    this.globals.userDefaultActionId = login.default_action_id;
                    yield this.globals.userPrefService.getPref(login.id)
                        .then((result) => {
                        this.globals.userPref = result;
                    })
                        .catch((err) => { console.log(err); const x = { userId: login.id }; return x; });
                    // dashboard sayfaasina gonder
                    this.router.navigate(['/']);
                }
            }
        });
    }
    onForgotPass() {
        this.router.navigate(['/account/forgot']);
    }
}
LoginComponent.ɵfac = function LoginComponent_Factory(t) { return new (t || LoginComponent)(ɵɵdirectiveInject(FormBuilder), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(ViasConnectionService), ɵɵdirectiveInject(TranslateService)); };
LoginComponent.ɵcmp = ɵɵdefineComponent({ type: LoginComponent, selectors: [["vias-login"]], viewQuery: function LoginComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵstaticViewQuery(_c0$h, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.errorTxt = _t.first);
    } }, decls: 41, vars: 25, consts: [[1, "session"], [1, "overflow-hidden"], ["fxLayout", "row wrap"], ["fxFlex.gt-xs", "50", "fxFlex", "100", 1, "bg-image", "bg-image-signin"], ["fxLayout", "row", "fxLayoutAlign", "space-evenly center", 1, "h-100", "py-3"], [1, "text-xs-center", "pb-1", "mat-text-white"], ["src", "assets/images/vias_logo_en.png", "width", "280"], ["fxFlex.gt-xs", "50", "fxFlex", "100"], [1, "pa-3"], [1, "mb-0"], [1, "mat-text-warn"], ["errorTxt", ""], [3, "formGroup", "ngSubmit"], ["fxLayout", "column", "fxLayoutAlign", "space-around"], [1, "pb-1"], [2, "width", "100%"], ["matInput", "", 3, "placeholder", "formControl"], ["matSuffix", ""], ["class", "mat-text-warn", 4, "ngIf"], ["matInput", "", "type", "password", 3, "placeholder", "formControl"], [1, "text-xs-right", 2, "color", "blue"], [3, "click"], [3, "formControl"], ["mat-raised-button", "", "color", "primary", "type", "submit", 3, "disabled"]], template: function LoginComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "mat-card", 1);
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "div", 3);
        ɵɵelementStart(4, "div", 4);
        ɵɵelementStart(5, "div", 5);
        ɵɵelement(6, "img", 6);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(7, "div", 7);
        ɵɵelementStart(8, "mat-card-content", 8);
        ɵɵelementStart(9, "h1", 9);
        ɵɵtext(10);
        ɵɵpipe(11, "translate");
        ɵɵelementEnd();
        ɵɵelement(12, "p", 10, 11);
        ɵɵelementStart(14, "form", 12);
        ɵɵlistener("ngSubmit", function LoginComponent_Template_form_ngSubmit_14_listener() { return ctx.login(); });
        ɵɵelementStart(15, "div", 13);
        ɵɵelementStart(16, "div", 14);
        ɵɵelementStart(17, "mat-form-field", 15);
        ɵɵelement(18, "input", 16);
        ɵɵpipe(19, "translate");
        ɵɵelementStart(20, "mat-icon", 17);
        ɵɵtext(21, "person");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(22, LoginComponent_small_22_Template, 3, 3, "small", 18);
        ɵɵelementEnd();
        ɵɵelementStart(23, "div", 14);
        ɵɵelementStart(24, "mat-form-field", 15);
        ɵɵelement(25, "input", 19);
        ɵɵpipe(26, "translate");
        ɵɵelementStart(27, "mat-icon", 17);
        ɵɵtext(28, "lock");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵtemplate(29, LoginComponent_small_29_Template, 3, 3, "small", 18);
        ɵɵelementEnd();
        ɵɵelementStart(30, "div", 20);
        ɵɵelementStart(31, "a", 21);
        ɵɵlistener("click", function LoginComponent_Template_a_click_31_listener() { return ctx.onForgotPass(); });
        ɵɵtext(32);
        ɵɵpipe(33, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(34, "div", 14);
        ɵɵelementStart(35, "mat-checkbox", 22);
        ɵɵtext(36);
        ɵɵpipe(37, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(38, "button", 23);
        ɵɵtext(39);
        ɵɵpipe(40, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(10);
        ɵɵtextInterpolate(ɵɵpipeBind1(11, 13, "pageNames.page_1"));
        ɵɵadvance(4);
        ɵɵproperty("formGroup", ctx.form);
        ɵɵadvance(4);
        ɵɵpropertyInterpolate("placeholder", ɵɵpipeBind1(19, 15, "userName"));
        ɵɵproperty("formControl", ctx.form.controls["username"]);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.form.controls["username"].hasError("required") && ctx.form.controls["username"].touched);
        ɵɵadvance(3);
        ɵɵpropertyInterpolate("placeholder", ɵɵpipeBind1(26, 17, "password"));
        ɵɵproperty("formControl", ctx.form.controls["password"]);
        ɵɵadvance(4);
        ɵɵproperty("ngIf", ctx.form.controls["password"].hasError("required") && ctx.form.controls["password"].touched);
        ɵɵadvance(3);
        ɵɵtextInterpolate(ɵɵpipeBind1(33, 19, "forgotPass"));
        ɵɵadvance(3);
        ɵɵproperty("formControl", ctx.form.controls["remember"]);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ɵɵpipeBind1(37, 21, "rememberMe"));
        ɵɵadvance(2);
        ɵɵproperty("disabled", !ctx.form.valid);
        ɵɵadvance(1);
        ɵɵtextInterpolate(ɵɵpipeBind1(40, 23, "login"));
    } }, directives: [MatCard, DefaultLayoutDirective, DefaultFlexDirective, DefaultLayoutAlignDirective, MatCardContent, ɵangular_packages_forms_forms_y, NgControlStatusGroup, FormGroupDirective, MatFormField, MatInput, DefaultValueAccessor, NgControlStatus, FormControlDirective, MatIcon, MatSuffix, NgIf, MatCheckbox, MatButton], pipes: [TranslatePipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LoginComponent, [{
        type: Component,
        args: [{
                selector: 'vias-login',
                templateUrl: './login.component.html',
                styleUrls: ['./login.component.scss']
            }]
    }], function () { return [{ type: FormBuilder }, { type: Router }, { type: ActivatedRoute }, { type: GlobalsService }, { type: ViasConnectionService }, { type: TranslateService }]; }, { errorTxt: [{
            type: ViewChild,
            args: ['errorTxt', { static: true }]
        }] }); })();

const AccountRoutes = [
    {
        path: '',
        children: [
            {
                path: 'forgot',
                component: ForgotComponent
            },
            {
                path: 'lockscreen',
                component: LockscreenComponent
            },
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'logout',
                canActivate: [ViasAuthLogoutService],
                component: LoginComponent
            }
        ]
    }
];

class AccountModule {
}
AccountModule.ɵmod = ɵɵdefineNgModule({ type: AccountModule });
AccountModule.ɵinj = ɵɵdefineInjector({ factory: function AccountModule_Factory(t) { return new (t || AccountModule)(); }, imports: [[
            CommonModule,
            TranslateModule,
            RouterModule.forChild(AccountRoutes),
            MatIconModule,
            MatCardModule,
            MatInputModule,
            MatCheckboxModule,
            MatButtonModule,
            FlexLayoutModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AccountModule, { declarations: [ForgotComponent,
        LockscreenComponent,
        LoginComponent], imports: [CommonModule,
        TranslateModule, RouterModule, MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AccountModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule,
                    RouterModule.forChild(AccountRoutes),
                    MatIconModule,
                    MatCardModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatButtonModule,
                    FlexLayoutModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                declarations: [
                    ForgotComponent,
                    LockscreenComponent,
                    LoginComponent,
                ]
            }]
    }], null, null); })();

class ContractorLayoutComponent {
}
ContractorLayoutComponent.ɵfac = function ContractorLayoutComponent_Factory(t) { return new (t || ContractorLayoutComponent)(); };
ContractorLayoutComponent.ɵcmp = ɵɵdefineComponent({ type: ContractorLayoutComponent, selectors: [["vias-contractor-layout"]], decls: 2, vars: 0, template: function ContractorLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-sidenav-container");
        ɵɵelement(1, "router-outlet");
        ɵɵelementEnd();
    } }, directives: [MatSidenavContainer, RouterOutlet], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ContractorLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'vias-contractor-layout',
                templateUrl: './contractor-layout.component.html',
                styleUrls: ['./contractor-layout.component.scss']
            }]
    }], null, null); })();

class NotFoundComponent {
    constructor() { }
    ngOnInit() { }
}
NotFoundComponent.ɵfac = function NotFoundComponent_Factory(t) { return new (t || NotFoundComponent)(); };
NotFoundComponent.ɵcmp = ɵɵdefineComponent({ type: NotFoundComponent, selectors: [["vias-not-found"]], decls: 11, vars: 0, consts: [[1, "session"], [1, "session-content", "text-xs-center"], [1, "error-title"], [1, "error-subtitle"], [1, "mat-text-muted"], ["href", "javascript:;"]], template: function NotFoundComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div");
        ɵɵelementStart(3, "div", 2);
        ɵɵtext(4, "404");
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 3);
        ɵɵtext(6, "Sayfa bulunamadi!");
        ɵɵelementEnd();
        ɵɵelementStart(7, "p", 4);
        ɵɵtext(8, "Bu saayfa bulunamadi. ");
        ɵɵelementStart(9, "a", 5);
        ɵɵtext(10, "Bu hatayi raporla?");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotFoundComponent, [{
        type: Component,
        args: [{
                selector: 'vias-not-found',
                templateUrl: './not-found.component.html',
                styleUrls: ['./not-found.component.scss']
            }]
    }], function () { return []; }, null); })();

class ErrorComponent {
    constructor() { }
    ngOnInit() { }
}
ErrorComponent.ɵfac = function ErrorComponent_Factory(t) { return new (t || ErrorComponent)(); };
ErrorComponent.ɵcmp = ɵɵdefineComponent({ type: ErrorComponent, selectors: [["vias-error"]], decls: 11, vars: 0, consts: [[1, "session"], [1, "session-content", "text-xs-center"], [1, "error-title"], [1, "error-subtitle"], [1, "mat-text-muted"], ["href", "javascript:;"]], template: function ErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "div", 1);
        ɵɵelementStart(2, "div");
        ɵɵelementStart(3, "div", 2);
        ɵɵtext(4, "500");
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 3);
        ɵɵtext(6, "Bu sayfaya erisilemiyor!");
        ɵɵelementEnd();
        ɵɵelementStart(7, "p", 4);
        ɵɵtext(8, "bu sayfa icin erisim hakkiniz olmayabilir. ");
        ɵɵelementStart(9, "a", 5);
        ɵɵtext(10, "Bu hatayi raporla?");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } }, styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorComponent, [{
        type: Component,
        args: [{
                selector: 'vias-error',
                templateUrl: './error.component.html',
                styleUrls: ['./error.component.scss']
            }]
    }], function () { return []; }, null); })();

const ErrorRoutes = [
    {
        path: '',
        children: [
            {
                path: '404',
                component: NotFoundComponent
            },
            {
                path: 'error',
                component: ErrorComponent,
                data: {
                    heading: 'Error',
                    css: ''
                }
            }
        ]
    }
];

class ErrorModule {
}
ErrorModule.ɵmod = ɵɵdefineNgModule({ type: ErrorModule });
ErrorModule.ɵinj = ɵɵdefineInjector({ factory: function ErrorModule_Factory(t) { return new (t || ErrorModule)(); }, imports: [[
            CommonModule,
            RouterModule.forChild(ErrorRoutes),
            MatIconModule,
            MatCardModule,
            MatInputModule,
            MatCheckboxModule,
            MatButtonModule,
            FlexLayoutModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ErrorModule, { declarations: [NotFoundComponent, ErrorComponent], imports: [CommonModule, RouterModule, MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ErrorModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    RouterModule.forChild(ErrorRoutes),
                    MatIconModule,
                    MatCardModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatButtonModule,
                    FlexLayoutModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                declarations: [NotFoundComponent, ErrorComponent]
            }]
    }], null, null); })();

function HeaderComponent_mat_list_item_75_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "p", 30);
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const notice_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(notice_r6.subtext);
} }
function HeaderComponent_mat_list_item_75_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span", 33);
    ɵɵtext(1);
    ɵɵpipe(2, "date");
    ɵɵelementEnd();
} if (rf & 2) {
    const notice_r6 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind2(2, 1, notice_r6.date, "fullDate"));
} }
function HeaderComponent_mat_list_item_75_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-item");
    ɵɵelementStart(1, "mat-icon", 29);
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "h4", 30);
    ɵɵtext(4);
    ɵɵelementEnd();
    ɵɵtemplate(5, HeaderComponent_mat_list_item_75_p_5_Template, 2, 1, "p", 31);
    ɵɵtemplate(6, HeaderComponent_mat_list_item_75_span_6_Template, 3, 4, "span", 32);
    ɵɵelementEnd();
} if (rf & 2) {
    const notice_r6 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵclassMapInterpolate1("mat-text-", notice_r6 == null ? null : notice_r6.color, " mat-icon mat-list-avatar material-icons");
    ɵɵadvance(1);
    ɵɵtextInterpolate(notice_r6.icon);
    ɵɵadvance(2);
    ɵɵtextInterpolate(notice_r6.text);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", notice_r6.subtext);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", notice_r6.date);
} }
const _c0$i = function () { return ["/messages"]; };
const _c1$4 = function () { return ["/calendar"]; };
const _c2$1 = function () { return ["/social"]; };
const _c3 = function () { return ["/maps/google"]; };
const _c4 = function () { return ["/messsages"]; };
const _c5 = function () { return ["/taskboard"]; };
const _c6 = function () { return ["/hr/user-profile"]; };
const _c7 = function () { return ["/account/logout"]; };
const NOTIFICATIONITEMS = [
    {
        text: 'Social',
        subtext: 'Ligula Purus Adipiscing',
        icon: 'people',
        color: 'primary'
    },
    {
        text: 'Promotions',
        subtext: 'Etiam Ligula Dapibus',
        icon: 'local_offer',
        color: 'warn'
    },
    {
        text: 'Updates',
        subtext: 'Sollicitudin Euismod Fringilla',
        icon: 'info',
        color: 'accent'
    },
    {
        text: 'Removed 6 items from task list',
        date: 1427207139000,
        icon: 'delete_sweep'
    },
    {
        text: 'Completed 2 projects',
        date: 1427412725000,
        icon: 'check_circle'
    },
    {
        text: 'Muted notifications',
        date: 1427546580000,
        icon: 'notifications_paused'
    },
    {
        text: 'Added Joel to contact list',
        date: 1428275520000,
        icon: 'person_add'
    },
    {
        text: 'Missed live call from Ellie',
        date: 1428830580000,
        icon: 'phone_missed'
    },
    {
        text: 'You ve been added to HR group',
        date: 1429363920000,
        icon: 'group_add'
    }
];
class NotificationService {
    getAll() {
        return NOTIFICATIONITEMS;
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); };
NotificationService.ɵprov = ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NotificationService, [{
        type: Injectable
    }], null, null); })();
class HeaderComponent {
    constructor(notificationService, iconRegistry, sanitizer, globals, translate) {
        this.notificationService = notificationService;
        this.globals = globals;
        this.translate = translate;
        this.toggleSidenav = new EventEmitter();
        this.userName = '';
        this.config = {};
        iconRegistry.addSvgIcon('search-icon', sanitizer.bypassSecurityTrustResourceUrl('assets/images/search.svg'));
        translate.use(globals.langLocale.substr(0, 2));
        this.userName = globals.userNameSurname;
    }
    ngOnInit() {
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵɵdirectiveInject(NotificationService), ɵɵdirectiveInject(MatIconRegistry), ɵɵdirectiveInject(DomSanitizer), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(TranslateService)); };
HeaderComponent.ɵcmp = ɵɵdefineComponent({ type: HeaderComponent, selectors: [["vias-header"]], outputs: { toggleSidenav: "toggleSidenav" }, features: [ɵɵProvidersFeature([NotificationService])], decls: 76, vars: 26, consts: [[1, "main-header"], ["mat-icon-button", "", "matTooltip", "Toggle navigation", "matTooltipPosition", "after", "matTooltipShowDelay", "300", 3, "click"], ["tooltip", "matTooltip"], [1, "branding"], ["href", "/#"], ["src", "assets/images/vias_logo_en.png", "height", "40", "alt", "viaMarine"], ["fxFlex", "", 1, "search-bar"], ["mat-icon-button", "", "matTooltip", "User links", "matTooltipPosition", "before", "matTooltipShowDelay", "300", 1, "ml-xs", "header-avatar", 3, "matMenuTriggerFor"], ["src", "assets/images/vias76x76.png", "alt", "", 1, "toolbar-avatar", "radius-circle"], ["x-position", "before"], ["apps", "matMenu"], ["fxLayout", "row", 1, "pa-xs"], ["fxFlex", "33.3333", 1, "text-xs-center", "pa-1"], [1, "block", 3, "routerLink"], [1, "block"], [1, "h1", "mat-text-default"], [1, "text-muted"], [1, "mt-2", "block", 3, "routerLink"], [1, "h1", "mat-text-muted"], [1, "h1", "mat-text-warn"], [1, "h1", "mat-text-accent"], [1, "h1", "mat-text-primary"], ["user", "matMenu"], ["mat-menu-item", "", 3, "routerLink"], ["x-position", "before", 1, "notifications"], ["notifications", "matMenu"], [1, "mr-1", "ml-1"], [1, "notifications-inner", 3, "perfectScrollbar"], [4, "ngFor", "ngForOf"], ["mat-list-avatar", ""], ["matLine", ""], ["matLine", "", 4, "ngIf"], ["class", "text-md mat-text-muted", "matLine", "", 4, "ngIf"], ["matLine", "", 1, "text-md", "mat-text-muted"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-toolbar", 0);
        ɵɵelementStart(1, "button", 1, 2);
        ɵɵlistener("click", function HeaderComponent_Template_button_click_1_listener() { return ctx.toggleSidenav.emit(); });
        ɵɵelementStart(3, "mat-icon");
        ɵɵtext(4, "menu");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(5, "div", 3);
        ɵɵelementStart(6, "a", 4);
        ɵɵelement(7, "img", 5);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelement(8, "div", 6);
        ɵɵelementStart(9, "span");
        ɵɵtext(10);
        ɵɵpipe(11, "translate");
        ɵɵelementEnd();
        ɵɵelementStart(12, "button", 7, 2);
        ɵɵelement(14, "img", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(15, "mat-menu", 9, 10);
        ɵɵelementStart(17, "div", 11);
        ɵɵelementStart(18, "div", 12);
        ɵɵelementStart(19, "a", 13);
        ɵɵelementStart(20, "span", 14);
        ɵɵelementStart(21, "mat-icon", 15);
        ɵɵtext(22, "email");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(23, "small", 16);
        ɵɵtext(24, "Emails");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(25, "a", 17);
        ɵɵelementStart(26, "span", 14);
        ɵɵelementStart(27, "mat-icon", 18);
        ɵɵtext(28, "date_range");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(29, "small", 16);
        ɵɵtext(30, "Calendar");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(31, "div", 12);
        ɵɵelementStart(32, "a", 13);
        ɵɵelementStart(33, "span", 14);
        ɵɵelementStart(34, "mat-icon", 19);
        ɵɵtext(35, "person");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(36, "small", 16);
        ɵɵtext(37, "Social");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(38, "a", 17);
        ɵɵelementStart(39, "span", 14);
        ɵɵelementStart(40, "mat-icon", 15);
        ɵɵtext(41, "place");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(42, "small", 16);
        ɵɵtext(43, "Map");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(44, "div", 12);
        ɵɵelementStart(45, "a", 13);
        ɵɵelementStart(46, "span", 14);
        ɵɵelementStart(47, "mat-icon", 20);
        ɵɵtext(48, "ondemand_video");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(49, "small", 16);
        ɵɵtext(50, "Media");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(51, "a", 17);
        ɵɵelementStart(52, "span", 14);
        ɵɵelementStart(53, "mat-icon", 21);
        ɵɵtext(54, "view_column");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(55, "small", 16);
        ɵɵtext(56, "Tasks");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(57, "mat-menu", 9, 22);
        ɵɵelementStart(59, "button", 23);
        ɵɵelementStart(60, "mat-icon");
        ɵɵtext(61, "account_box");
        ɵɵelementEnd();
        ɵɵtext(62, " Profile ");
        ɵɵelementEnd();
        ɵɵelementStart(63, "button", 23);
        ɵɵelementStart(64, "mat-icon");
        ɵɵtext(65, "exit_to_app");
        ɵɵelementEnd();
        ɵɵtext(66);
        ɵɵpipe(67, "translate");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(68, "mat-menu", 24, 25);
        ɵɵelementStart(70, "mat-toolbar");
        ɵɵelementStart(71, "span", 26);
        ɵɵtext(72, "Notifications");
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(73, "div", 27);
        ɵɵelementStart(74, "mat-nav-list");
        ɵɵtemplate(75, HeaderComponent_mat_list_item_75_Template, 7, 7, "mat-list-item", 28);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        const _r3 = ɵɵreference(58);
        ɵɵadvance(10);
        ɵɵtextInterpolate2("", ɵɵpipeBind1(11, 14, "welcome"), " ", ctx.userName, "");
        ɵɵadvance(2);
        ɵɵproperty("matMenuTriggerFor", _r3);
        ɵɵadvance(7);
        ɵɵproperty("routerLink", ɵɵpureFunction0(18, _c0$i));
        ɵɵadvance(6);
        ɵɵproperty("routerLink", ɵɵpureFunction0(19, _c1$4));
        ɵɵadvance(7);
        ɵɵproperty("routerLink", ɵɵpureFunction0(20, _c2$1));
        ɵɵadvance(6);
        ɵɵproperty("routerLink", ɵɵpureFunction0(21, _c3));
        ɵɵadvance(7);
        ɵɵproperty("routerLink", ɵɵpureFunction0(22, _c4));
        ɵɵadvance(6);
        ɵɵproperty("routerLink", ɵɵpureFunction0(23, _c5));
        ɵɵadvance(8);
        ɵɵproperty("routerLink", ɵɵpureFunction0(24, _c6));
        ɵɵadvance(4);
        ɵɵproperty("routerLink", ɵɵpureFunction0(25, _c7));
        ɵɵadvance(3);
        ɵɵtextInterpolate1(" ", ɵɵpipeBind1(67, 16, "logout"), " ");
        ɵɵadvance(7);
        ɵɵproperty("perfectScrollbar", ctx.config);
        ɵɵadvance(2);
        ɵɵproperty("ngForOf", ctx.notificationService.getAll());
    } }, directives: [MatToolbar, MatButton, MatTooltip, MatIcon, DefaultFlexDirective, MatMenuTrigger, _MatMenu, DefaultLayoutDirective, RouterLinkWithHref, MatMenuItem, RouterLink, PerfectScrollbarDirective, MatNavList, NgForOf, MatListItem, MatListAvatarCssMatStyler, MatLine, NgIf], pipes: [TranslatePipe, DatePipe], styles: [".example-card[_ngcontent-%COMP%]{max-width:400px}.example-header-image[_ngcontent-%COMP%]{background-image:url(https://material.angular.io/assets/img/examples/shiba1.jpg);background-size:cover}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'vias-header',
                templateUrl: './header.component.html',
                styleUrls: ['./header.component.scss'],
                providers: [NotificationService]
            }]
    }], function () { return [{ type: NotificationService }, { type: MatIconRegistry }, { type: DomSanitizer }, { type: GlobalsService }, { type: TranslateService }]; }, { toggleSidenav: [{
            type: Output
        }] }); })();

var MenuType;
(function (MenuType) {
    MenuType[MenuType["title"] = 0] = "title";
    MenuType[MenuType["link"] = 1] = "link";
    MenuType[MenuType["sub"] = 2] = "sub";
    MenuType[MenuType["divider"] = 3] = "divider";
})(MenuType || (MenuType = {}));

const MENUITEM_PROVIDER = new InjectionToken('MenuItem Provider', {
    providedIn: 'root',
    factory: () => []
});
class MenuService {
    constructor(MenuItems) {
        this.MenuItems = MenuItems;
    }
    getMenu() { return this.MenuItems; }
}
MenuService.ɵfac = function MenuService_Factory(t) { return new (t || MenuService)(ɵɵinject(MENUITEM_PROVIDER)); };
MenuService.ɵprov = ɵɵdefineInjectable({ token: MenuService, factory: MenuService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MenuService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MENUITEM_PROVIDER]
            }] }]; }, null); })();

class AccordionDirective {
    constructor(router) {
        this.router = router;
        this.navlinks = [];
        setTimeout(() => this.checkOpenLinks());
    }
    closeOtherLinks(openLink) {
        this.navlinks.forEach((link) => {
            if (link !== openLink) {
                link.open = false;
            }
        });
    }
    addLink(link) {
        this.navlinks.push(link);
    }
    removeGroup(link) {
        const index = this.navlinks.indexOf(link);
        if (index !== -1) {
            this.navlinks.splice(index, 1);
        }
    }
    checkOpenLinks() {
        this.navlinks.forEach((link) => {
            if (link.group) {
                const routeUrl = this.router.url;
                const currentUrl = routeUrl.split('/');
                if (currentUrl.indexOf(link.group) > 0) {
                    link.open = true;
                    this.closeOtherLinks(link);
                }
            }
        });
    }
    ngAfterContentChecked() {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(e => this.checkOpenLinks());
    }
}
AccordionDirective.ɵfac = function AccordionDirective_Factory(t) { return new (t || AccordionDirective)(ɵɵdirectiveInject(Router)); };
AccordionDirective.ɵdir = ɵɵdefineDirective({ type: AccordionDirective, selectors: [["", "viasAccordion", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AccordionDirective, [{
        type: Directive,
        args: [{
                selector: '[viasAccordion]'
            }]
    }], function () { return [{ type: Router }]; }, null); })();

class AccordionLinkDirective {
    constructor(nav) {
        this.nav = nav;
    }
    get open() {
        return this._open;
    }
    set open(value) {
        this._open = value;
        if (value) {
            this.nav.closeOtherLinks(this);
        }
    }
    ngOnInit() {
        this.nav.addLink(this);
    }
    ngOnDestroy() {
        this.nav.removeGroup(this);
    }
    toggle() {
        this.open = !this.open;
    }
}
AccordionLinkDirective.ɵfac = function AccordionLinkDirective_Factory(t) { return new (t || AccordionLinkDirective)(ɵɵdirectiveInject(AccordionDirective)); };
AccordionLinkDirective.ɵdir = ɵɵdefineDirective({ type: AccordionLinkDirective, selectors: [["", "viasAccordionlink", ""]], hostVars: 2, hostBindings: function AccordionLinkDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵɵclassProp("open", ctx.open);
    } }, inputs: { group: "group", open: "open" } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AccordionLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[viasAccordionlink]'
            }]
    }], function () { return [{ type: AccordionDirective, decorators: [{
                type: Inject,
                args: [AccordionDirective]
            }] }]; }, { group: [{
            type: Input
        }], open: [{
            type: HostBinding,
            args: ['class.open']
        }, {
            type: Input
        }] }); })();

class AccordionAnchorDirective {
    constructor(navlink) {
        this.navlink = navlink;
    }
    onClick(e) {
        this.navlink.toggle();
    }
}
AccordionAnchorDirective.ɵfac = function AccordionAnchorDirective_Factory(t) { return new (t || AccordionAnchorDirective)(ɵɵdirectiveInject(AccordionLinkDirective)); };
AccordionAnchorDirective.ɵdir = ɵɵdefineDirective({ type: AccordionAnchorDirective, selectors: [["", "viasAccordionToggle", ""]], hostBindings: function AccordionAnchorDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵɵlistener("click", function AccordionAnchorDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } } });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AccordionAnchorDirective, [{
        type: Directive,
        args: [{
                selector: '[viasAccordionToggle]'
            }]
    }], function () { return [{ type: AccordionLinkDirective, decorators: [{
                type: Inject,
                args: [AccordionLinkDirective]
            }] }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }] }); })();

function NavComponent_div_4_h5_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "h5", 9);
    ɵɵtext(1);
    ɵɵpipe(2, "translate");
    ɵɵelementEnd();
} if (rf & 2) {
    const menuitem_r1 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(2, 1, menuitem_r1.name));
} }
function NavComponent_div_4_mat_list_item_2_a_1_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const badge_r12 = ctx.$implicit;
    ɵɵclassMapInterpolate1("menu-badge mat-", badge_r12.type, "");
    ɵɵadvance(1);
    ɵɵtextInterpolate(badge_r12.value);
} }
function NavComponent_div_4_mat_list_item_2_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 13);
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "span");
    ɵɵtext(4);
    ɵɵpipe(5, "translate");
    ɵɵelementEnd();
    ɵɵelement(6, "span", 14);
    ɵɵtemplate(7, NavComponent_div_4_mat_list_item_2_a_1_span_7_Template, 2, 4, "span", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const childitem_r7 = ɵɵnextContext().$implicit;
    ɵɵproperty("routerLink", childitem_r7.url);
    ɵɵadvance(2);
    ɵɵtextInterpolate(childitem_r7.icon);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 4, "pageNames.page_" + childitem_r7.pageId));
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", childitem_r7.badge);
} }
function NavComponent_div_4_mat_list_item_2_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 16);
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "span");
    ɵɵtext(4);
    ɵɵpipe(5, "translate");
    ɵɵelementEnd();
    ɵɵelement(6, "span", 14);
    ɵɵelementStart(7, "mat-icon", 17);
    ɵɵtext(8, "arrow_drop_down");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const childitem_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(2);
    ɵɵtextInterpolate(childitem_r7.icon);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 2, childitem_r7.name));
} }
function NavComponent_div_4_mat_list_item_2_mat_nav_list_3_mat_list_item_1_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-item", 20);
    ɵɵelementStart(1, "a", 13);
    ɵɵtext(2);
    ɵɵpipe(3, "translate");
    ɵɵelementEnd();
    ɵɵelementEnd();
} if (rf & 2) {
    const childlinks_r16 = ctx.$implicit;
    ɵɵadvance(1);
    ɵɵproperty("routerLink", childlinks_r16.url);
    ɵɵadvance(1);
    ɵɵtextInterpolate(ɵɵpipeBind1(3, 2, "pageNames.page_" + childlinks_r16.pageId));
} }
function NavComponent_div_4_mat_list_item_2_mat_nav_list_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-nav-list", 18);
    ɵɵtemplate(1, NavComponent_div_4_mat_list_item_2_mat_nav_list_3_mat_list_item_1_Template, 4, 4, "mat-list-item", 19);
    ɵɵelementEnd();
} if (rf & 2) {
    const childitem_r7 = ɵɵnextContext().$implicit;
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", childitem_r7.children);
} }
function NavComponent_div_4_mat_list_item_2_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "mat-list-item", 10);
    ɵɵtemplate(1, NavComponent_div_4_mat_list_item_2_a_1_Template, 8, 6, "a", 7);
    ɵɵtemplate(2, NavComponent_div_4_mat_list_item_2_a_2_Template, 9, 4, "a", 11);
    ɵɵtemplate(3, NavComponent_div_4_mat_list_item_2_mat_nav_list_3_Template, 2, 1, "mat-nav-list", 12);
    ɵɵelementEnd();
} if (rf & 2) {
    const childitem_r7 = ctx.$implicit;
    const ctx_r3 = ɵɵnextContext(2);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", childitem_r7.type === ctx_r3.mt.link);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", childitem_r7.type === ctx_r3.mt.sub);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", childitem_r7.type === ctx_r3.mt.sub);
} }
function NavComponent_div_4_a_3_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "span");
    ɵɵtext(1);
    ɵɵelementEnd();
} if (rf & 2) {
    const badge_r19 = ctx.$implicit;
    ɵɵclassMapInterpolate1("menu-badge mat-", badge_r19.type, "");
    ɵɵadvance(1);
    ɵɵtextInterpolate(badge_r19.value);
} }
function NavComponent_div_4_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "a", 13);
    ɵɵelementStart(1, "mat-icon");
    ɵɵtext(2);
    ɵɵelementEnd();
    ɵɵelementStart(3, "span");
    ɵɵtext(4);
    ɵɵpipe(5, "translate");
    ɵɵelementEnd();
    ɵɵelement(6, "span", 14);
    ɵɵtemplate(7, NavComponent_div_4_a_3_span_7_Template, 2, 4, "span", 15);
    ɵɵelementEnd();
} if (rf & 2) {
    const menuitem_r1 = ɵɵnextContext().$implicit;
    ɵɵproperty("routerLink", menuitem_r1.url);
    ɵɵadvance(2);
    ɵɵtextInterpolate(menuitem_r1.icon);
    ɵɵadvance(2);
    ɵɵtextInterpolate(ɵɵpipeBind1(5, 4, "pageNames.page_" + menuitem_r1.pageId));
    ɵɵadvance(3);
    ɵɵproperty("ngForOf", menuitem_r1.badge);
} }
function NavComponent_div_4_mat_divider_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-divider", 21);
} }
function NavComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵɵelementStart(0, "div");
    ɵɵtemplate(1, NavComponent_div_4_h5_1_Template, 3, 3, "h5", 5);
    ɵɵtemplate(2, NavComponent_div_4_mat_list_item_2_Template, 4, 3, "mat-list-item", 6);
    ɵɵtemplate(3, NavComponent_div_4_a_3_Template, 8, 6, "a", 7);
    ɵɵtemplate(4, NavComponent_div_4_mat_divider_4_Template, 1, 0, "mat-divider", 8);
    ɵɵelement(5, "br");
    ɵɵelementEnd();
} if (rf & 2) {
    const menuitem_r1 = ctx.$implicit;
    const ctx_r0 = ɵɵnextContext();
    ɵɵadvance(1);
    ɵɵproperty("ngIf", menuitem_r1.type === ctx_r0.mt.title);
    ɵɵadvance(1);
    ɵɵproperty("ngForOf", menuitem_r1.children);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", menuitem_r1.type === ctx_r0.mt.link);
    ɵɵadvance(1);
    ɵɵproperty("ngIf", menuitem_r1.type === ctx_r0.mt.divider);
} }
class NavFilterPipe {
    constructor(translate2, globals) {
        this.translate2 = translate2;
        this.globals = globals;
        translate2.use(globals.langLocale.substr(0, 2));
    }
    transform(items, searchText) {
        if (!items)
            return [];
        if (!searchText || searchText.trim() === '')
            return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            let childFind = false;
            // Ana menü ismini çeviriyle güncelle
            it.name = this.translate2.instant(it.name) || it.name;
            if (it.name && it.name.toLowerCase().includes(searchText)) {
                return true;
            }
            // Alt menüleri kontrol et
            if (it.children && it.children.length > 0) {
                it.children.forEach(ic => {
                    ic.name = this.translate2.instant(ic.name) || ic.name;
                    if (ic.name && ic.name.toLowerCase().includes(searchText)) {
                        childFind = true;
                    }
                    if (ic.children && ic.children.length > 0) {
                        ic.children.forEach(icc => {
                            icc.name = this.translate2.instant('pageNames.page_' + icc.pageId) || icc.name;
                            if (icc.name && icc.name.toLowerCase().includes(searchText)) {
                                childFind = true;
                            }
                        });
                    }
                });
            }
            return childFind;
        });
    }
}
NavFilterPipe.ɵfac = function NavFilterPipe_Factory(t) { return new (t || NavFilterPipe)(ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(GlobalsService)); };
NavFilterPipe.ɵpipe = ɵɵdefinePipe({ name: "filter", type: NavFilterPipe, pure: true });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NavFilterPipe, [{
        type: Pipe,
        args: [{
                name: 'filter'
            }]
    }], function () { return [{ type: TranslateService }, { type: GlobalsService }]; }, null); })();
class NavComponent {
    constructor(translate, globals, menu) {
        this.translate = translate;
        this.globals = globals;
        this.menu = menu;
        this.mt = MenuType;
        this.menuSearchText = ''; // Başlangıç değeri boş string olmalı
        translate.use(globals.langLocale.substr(0, 2));
        // FormGroup ve FormControl başlatma işlemi
        this.form = new FormGroup({
            menuSearch: new FormControl('') // Başlangıç değeri boş string
        });
        this.item = {
            type: FieldTypes.Text,
            name: 'menuSearch',
        };
        this.translate.get('search').subscribe((translated) => {
            this.item.label = translated;
        });
    }
    ngOnInit() {
        this.menuItems = this.getAll();
        // Form kontrolündeki değeri dinleyerek arama metnini güncelle
        this.form.controls['menuSearch'].valueChanges.subscribe(value => {
            this.menuSearchText = value || ''; // Eğer `null` veya `undefined` gelirse boş string ata
        });
    }
    getAll() {
        const MenuItems = this.menu.getMenu();
        const pages = [];
        this.globals.pagePermissions.forEach(e => {
            const perm = this.handlePermissions(e.permission);
            for (let i = 0; i < perm.length; i++) {
                if (perm.charAt(i) === '1') {
                    pages.push(e.pageId + i);
                }
            }
        });
        const menu = MenuItems.filter(function f(o) {
            if (pages.includes(o.pageId)) {
                return true;
            }
            if (o.children) {
                return (o.children = o.children.filter(f)).length;
            }
        });
        return menu;
    }
    handlePermissions(perm) {
        let x = '';
        if (perm.length > 0) {
            x = Number.parseInt(perm, 16).toString(2);
            while (x.length < 50) {
                x = '0' + x;
            }
        }
        return x;
    }
    onChangeInput(event) {
        this.menuSearchText = event; // Gelen değeri doğrudan menuSearchText'e ata
    }
}
NavComponent.ɵfac = function NavComponent_Factory(t) { return new (t || NavComponent)(ɵɵdirectiveInject(TranslateService), ɵɵdirectiveInject(GlobalsService), ɵɵdirectiveInject(MenuService)); };
NavComponent.ɵcmp = ɵɵdefineComponent({ type: NavComponent, selectors: [["vias-nav"]], decls: 6, vars: 7, consts: [[1, "menuSearchDiv"], ["tabindex", "100", 3, "form", "item", "ngModel", "ngModelChange", "onchange"], [1, "navigation"], ["viasAccordion", "", 1, "navigation"], [4, "ngFor", "ngForOf"], ["mat-subheader", "", 4, "ngIf"], ["viasAccordionlink", "", 4, "ngFor", "ngForOf"], ["class", "relative", 3, "routerLink", 4, "ngIf"], ["class", "my-1", 4, "ngIf"], ["mat-subheader", ""], ["viasAccordionlink", ""], ["viasAccordionToggle", "", "class", "relative", "href", "javascript:;", 4, "ngIf"], ["class", "sub-menu", 4, "ngIf"], [1, "relative", 3, "routerLink"], ["fxFlex", ""], [3, "class", 4, "ngFor", "ngForOf"], ["viasAccordionToggle", "", "href", "javascript:;", 1, "relative"], [1, "menu-caret"], [1, "sub-menu"], ["routerLinkActive", "open", 4, "ngFor", "ngForOf"], ["routerLinkActive", "open"], [1, "my-1"]], template: function NavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "div", 0);
        ɵɵelementStart(1, "vias-input", 1);
        ɵɵlistener("ngModelChange", function NavComponent_Template_vias_input_ngModelChange_1_listener($event) { return ctx.menuSearchText = $event; })("onchange", function NavComponent_Template_vias_input_onchange_1_listener($event) { return ctx.onChangeInput($event); });
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementStart(2, "div", 2);
        ɵɵelementStart(3, "mat-nav-list", 3);
        ɵɵtemplate(4, NavComponent_div_4_Template, 6, 4, "div", 4);
        ɵɵpipe(5, "filter");
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵadvance(1);
        ɵɵproperty("form", ctx.form)("item", ctx.item)("ngModel", ctx.menuSearchText);
        ɵɵadvance(3);
        ɵɵproperty("ngForOf", ɵɵpipeBind2(5, 4, ctx.menuItems, ctx.menuSearchText));
    } }, directives: [InputComponent, NgControlStatus, NgModel, MatNavList, AccordionDirective, NgForOf, NgIf, MatListSubheaderCssMatStyler, MatListItem, AccordionLinkDirective, RouterLinkWithHref, MatIcon, DefaultFlexDirective, AccordionAnchorDirective, RouterLinkActive, MatDivider], pipes: [NavFilterPipe, TranslatePipe], styles: [".menuSearchDiv[_ngcontent-%COMP%]{margin-left:10px;margin-right:10px}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(NavComponent, [{
        type: Component,
        args: [{
                selector: 'vias-nav',
                templateUrl: './nav.component.html',
                styleUrls: ['./nav.component.scss']
            }]
    }], function () { return [{ type: TranslateService }, { type: GlobalsService }, { type: MenuService }]; }, null); })();

const _c0$j = ["sidemenu"];
const _c1$5 = function () { return { height: "2px" }; };
function MainLayoutComponent_mat_progress_bar_0_Template(rf, ctx) { if (rf & 1) {
    ɵɵelement(0, "mat-progress-bar", 9);
    ɵɵpipe(1, "async");
} if (rf & 2) {
    const ctx_r0 = ɵɵnextContext();
    ɵɵproperty("value", ɵɵpipeBind1(1, 2, ctx_r0.loader.progress$))("ngStyle", ɵɵpureFunction0(4, _c1$5));
} }
const _c2$2 = function (a0, a1, a2, a3, a4) { return { "app-dark": a0, "boxed": a1, "collapsed-sidebar": a2, "side-panel-opened": a3, "side-panel-closed": a4 }; };
const SMALL_WIDTH_BREAKPOINT = 960;
class MainLayoutComponent {
    constructor(_element, router, route, zone, loader, titleService, viasService) {
        this._element = _element;
        this.router = router;
        this.route = route;
        this.zone = zone;
        this.loader = loader;
        this.titleService = titleService;
        this.viasService = viasService;
        this.mediaMatcher = matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`);
        this.options = {
            dark: false,
            boxed: false,
            collapsed: false,
            dir: 'ltr'
        };
        this.config = {};
        // this.mediaMatcher.addListener(mql =>
        //   zone.run(() => {
        //     this.mediaMatcher = mql;
        //   })
        // );
    }
    ngOnInit() {
        this.url = this.router.url;
        this._router = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe((event) => {
            document.querySelector('.app-inner > .mat-drawer-content > div').scrollTop = 0;
            this.url = event.url;
            this.runOnRouteChange();
        });
        this.runOnRouteChange();
    }
    ngOnDestroy() {
        this._router.unsubscribe();
    }
    runOnRouteChange() {
        if (this.isOver()) {
            this.sidePanelOpened = false;
        }
        else {
            this.updatePS();
        }
        this.route.children.forEach((route) => {
            let activeRoute = route;
            while (activeRoute.firstChild) {
                activeRoute = activeRoute.firstChild;
            }
            this.routeData = activeRoute.snapshot.data;
        });
        if (this.routeData.hasOwnProperty('heading')) {
            this.setTitle(this.routeData.heading);
        }
    }
    setTitle(newTitle) {
        this.titleService.setTitle(newTitle + ' | Node - Angular Material 2 Admin Template');
    }
    receiveMessage($event) {
        this.options = $event;
        this.triggerWindowResize();
    }
    toggleSidenav() {
        this.sidemenu.toggle();
        this.triggerWindowResize();
    }
    isOver() {
        if (this.url === '/messages' ||
            this.url === '/calendar' ||
            this.url === '/media' ||
            this.url === '/maps/leaflet' ||
            this.url === '/taskboard') {
            return true;
        }
        else {
            return this.mediaMatcher.matches;
        }
    }
    updatePS() {
        if (!this.mediaMatcher.matches) {
            setTimeout(() => {
                this.directiveScroll.update();
            }, 350);
        }
    }
    triggerWindowResize() {
        if (typeof Event === 'function') {
            window.dispatchEvent(new Event('resize'));
        }
        else {
            const evt = window.document.createEvent('UIEvents');
            evt.initEvent('resize', true, false);
            window.dispatchEvent(evt);
        }
    }
    toggleFullscreen() {
        const elem = this._element.nativeElement.querySelector('.app-inner');
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        }
        else if (elem.webkitRequestFullScreen) {
            elem.webkitRequestFullScreen();
        }
        else if (elem.mozRequestFullScreen) {
            elem.mozRequestFullScreen();
        }
        else if (elem.msRequestFullScreen) {
            elem.msRequestFullScreen();
        }
    }
}
MainLayoutComponent.ɵfac = function MainLayoutComponent_Factory(t) { return new (t || MainLayoutComponent)(ɵɵdirectiveInject(ElementRef), ɵɵdirectiveInject(Router), ɵɵdirectiveInject(ActivatedRoute), ɵɵdirectiveInject(NgZone), ɵɵdirectiveInject(LoadingBarService), ɵɵdirectiveInject(Title), ɵɵdirectiveInject(ViasConnectionService)); };
MainLayoutComponent.ɵcmp = ɵɵdefineComponent({ type: MainLayoutComponent, selectors: [["vias-main-layout"]], viewQuery: function MainLayoutComponent_Query(rf, ctx) { if (rf & 1) {
        ɵɵviewQuery(_c0$j, true);
        ɵɵviewQuery(PerfectScrollbarDirective, true);
    } if (rf & 2) {
        var _t;
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.sidemenu = _t.first);
        ɵɵqueryRefresh(_t = ɵɵloadQuery()) && (ctx.directiveScroll = _t.first);
    } }, decls: 14, vars: 19, consts: [["class", "page-loader", 3, "value", "ngStyle", 4, "ngIf"], [1, "app", 3, "dir", "ngClass"], [3, "toggleSidenav"], [1, "app-inner", 3, "click"], [1, "sidebar-panel", 3, "mode", "opened", "perfectScrollbar", "disabled", "openedStart", "closedStart"], ["sidemenu", ""], [3, "perfectScrollbar", "disabled"], [3, "run"], [3, "className"], [1, "page-loader", 3, "value", "ngStyle"]], template: function MainLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵtemplate(0, MainLayoutComponent_mat_progress_bar_0_Template, 2, 5, "mat-progress-bar", 0);
        ɵɵpipe(1, "async");
        ɵɵelementStart(2, "div", 1);
        ɵɵelementStart(3, "vias-header", 2);
        ɵɵlistener("toggleSidenav", function MainLayoutComponent_Template_vias_header_toggleSidenav_3_listener() { return ctx.toggleSidenav(); });
        ɵɵelementEnd();
        ɵɵelementStart(4, "mat-sidenav-container", 3);
        ɵɵlistener("click", function MainLayoutComponent_Template_mat_sidenav_container_click_4_listener() { return ctx.updatePS(); });
        ɵɵelementStart(5, "mat-sidenav", 4, 5);
        ɵɵlistener("openedStart", function MainLayoutComponent_Template_mat_sidenav_openedStart_5_listener() { return ctx.sidePanelOpened = true; })("closedStart", function MainLayoutComponent_Template_mat_sidenav_closedStart_5_listener() { return ctx.sidePanelOpened = false; });
        ɵɵelement(7, "vias-nav");
        ɵɵelementEnd();
        ɵɵelementStart(8, "div", 6);
        ɵɵelementStart(9, "mat-card");
        ɵɵelementStart(10, "mat-card-content");
        ɵɵelementStart(11, "div");
        ɵɵelement(12, "vias-progress-spinner", 7);
        ɵɵelement(13, "router-outlet", 8);
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
        ɵɵelementEnd();
    } if (rf & 2) {
        ɵɵproperty("ngIf", ɵɵpipeBind1(1, 11, ctx.loader.progress$));
        ɵɵadvance(2);
        ɵɵproperty("dir", ctx.options.dir)("ngClass", ɵɵpureFunction5(13, _c2$2, ctx.options.dark, ctx.options.boxed, ctx.options.collapsed, ctx.sidePanelOpened, !ctx.sidePanelOpened));
        ɵɵadvance(3);
        ɵɵproperty("mode", ctx.isOver() ? "over" : "side")("opened", !ctx.isOver())("perfectScrollbar", ctx.config)("disabled", ctx.mediaMatcher.matches);
        ɵɵadvance(3);
        ɵɵproperty("perfectScrollbar", ctx.config)("disabled", ctx.mediaMatcher.matches);
        ɵɵadvance(4);
        ɵɵproperty("run", ctx.viasService.progressSpinnerRun);
        ɵɵadvance(1);
        ɵɵproperty("className", ctx.routeData.css);
    } }, directives: [NgIf, Dir, NgClass, DefaultClassDirective, HeaderComponent, MatSidenavContainer, MatSidenav, PerfectScrollbarDirective, NavComponent, MatCard, MatCardContent, ProgressSpinnerComponent, RouterOutlet, MatProgressBar, NgStyle, DefaultStyleDirective], pipes: [AsyncPipe], styles: [""] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(MainLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'vias-main-layout',
                templateUrl: './main-layout.component.html',
                styleUrls: ['./main-layout.component.scss']
            }]
    }], function () { return [{ type: ElementRef }, { type: Router }, { type: ActivatedRoute }, { type: NgZone }, { type: LoadingBarService }, { type: Title }, { type: ViasConnectionService }]; }, { sidemenu: [{
            type: ViewChild,
            args: ['sidemenu', { static: false }]
        }], directiveScroll: [{
            type: ViewChild,
            args: [PerfectScrollbarDirective, { static: false }]
        }] }); })();

class AuthLayoutComponent {
}
AuthLayoutComponent.ɵfac = function AuthLayoutComponent_Factory(t) { return new (t || AuthLayoutComponent)(); };
AuthLayoutComponent.ɵcmp = ɵɵdefineComponent({ type: AuthLayoutComponent, selectors: [["vias-auth-layout"]], decls: 2, vars: 0, template: function AuthLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "mat-sidenav-container");
        ɵɵelement(1, "router-outlet");
        ɵɵelementEnd();
    } }, directives: [MatSidenavContainer, RouterOutlet], styles: ["[_nghost-%COMP%]     .mat-drawer-content{display:block!important;padding:0}.mat-drawer-container[_ngcontent-%COMP%]{z-index:1000}"] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AuthLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'vias-auth-layout',
                styleUrls: ['./auth-layout.component.scss'],
                templateUrl: './auth-layout.component.html'
            }]
    }], null, null); })();

const routes = [];
class ViasngCoreModule {
}
ViasngCoreModule.ɵmod = ɵɵdefineNgModule({ type: ViasngCoreModule });
ViasngCoreModule.ɵinj = ɵɵdefineInjector({ factory: function ViasngCoreModule_Factory(t) { return new (t || ViasngCoreModule)(); }, imports: [[
            RouterModule,
            TranslateModule,
            CommonModule,
            FormsModule,
            MatExpansionModule,
            MatSidenavModule,
            MatMenuModule,
            MatCheckboxModule,
            MatDialogModule,
            MatIconModule,
            MatTableModule,
            MatSnackBarModule,
            MatButtonModule,
            MatToolbarModule,
            MatTooltipModule,
            MatListModule,
            MatSelectModule,
            MatInputModule,
            MatCardModule,
            MatProgressBarModule,
            MatProgressSpinnerModule,
            FlexLayoutModule,
            LoadingBarModule,
            PerfectScrollbarModule,
            ComponentsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(ViasngCoreModule, { declarations: [HeaderComponent,
        NavComponent,
        NavFilterPipe,
        MainLayoutComponent,
        AuthLayoutComponent,
        ContractorLayoutComponent,
        AccordionDirective,
        AccordionLinkDirective,
        AccordionAnchorDirective], imports: [RouterModule,
        TranslateModule,
        CommonModule,
        FormsModule,
        MatExpansionModule,
        MatSidenavModule,
        MatMenuModule,
        MatCheckboxModule,
        MatDialogModule,
        MatIconModule,
        MatTableModule,
        MatSnackBarModule,
        MatButtonModule,
        MatToolbarModule,
        MatTooltipModule,
        MatListModule,
        MatSelectModule,
        MatInputModule,
        MatCardModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        FlexLayoutModule,
        LoadingBarModule,
        PerfectScrollbarModule,
        ComponentsModule], exports: [HeaderComponent,
        NavComponent,
        NavFilterPipe,
        MainLayoutComponent,
        AuthLayoutComponent,
        ContractorLayoutComponent,
        AccordionDirective,
        AccordionLinkDirective,
        AccordionAnchorDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasngCoreModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    HeaderComponent,
                    NavComponent,
                    NavFilterPipe,
                    MainLayoutComponent,
                    AuthLayoutComponent,
                    ContractorLayoutComponent,
                    AccordionDirective,
                    AccordionLinkDirective,
                    AccordionAnchorDirective
                ],
                imports: [
                    RouterModule,
                    TranslateModule,
                    CommonModule,
                    FormsModule,
                    MatExpansionModule,
                    MatSidenavModule,
                    MatMenuModule,
                    MatCheckboxModule,
                    MatDialogModule,
                    MatIconModule,
                    MatTableModule,
                    MatSnackBarModule,
                    MatButtonModule,
                    MatToolbarModule,
                    MatTooltipModule,
                    MatListModule,
                    MatSelectModule,
                    MatInputModule,
                    MatCardModule,
                    MatProgressBarModule,
                    MatProgressSpinnerModule,
                    FlexLayoutModule,
                    LoadingBarModule,
                    PerfectScrollbarModule,
                    ComponentsModule
                ],
                exports: [
                    HeaderComponent,
                    NavComponent,
                    NavFilterPipe,
                    MainLayoutComponent,
                    AuthLayoutComponent,
                    ContractorLayoutComponent,
                    AccordionDirective,
                    AccordionLinkDirective,
                    AccordionAnchorDirective
                ]
            }]
    }], null, null); })();

// @dynamic
class StatusVars {
}
StatusVars.generalStatus = {
    0: 'statPassive',
    1: 'statActive',
    3: 'statCancelled',
    5: 'statDeleted'
};
StatusVars.repairQuotation2 = {
    0: 'statPassive',
    1: 'statQuotationCreated',
    2: 'statInRevision',
    3: 'statCancelled',
    4: 'statEntered',
    5: 'statDeleted',
    6: 'statFinalised'
};
StatusVars.purchaseOrder = {
    '-2': 'statSaved',
    1: 'statOrdered',
    2: 'statConfirmed',
    3: 'statCancelled',
    4: 'statArrived',
    7: 'statPartialArrivied'
};
StatusVars.purchaseTender = {
    1: 'statQuotationCreated',
    2: 'statPriceEntered',
    3: 'statPendingOrderConfirmation',
    4: 'statLoggedOffer',
    6: 'statOrdered',
    0: 'statWaitConfirm1',
    7: 'statWaitConfirm2',
    8: 'statWaitConfirmFinal',
    9: 'approvedOpenOrder'
};
StatusVars.purchaseRequest = {
    1: 'statConvertedProposal',
    2: 'statRejected',
    3: 'statPendingOrderConfirmation',
    4: 'statNewRequest',
    6: 'statOrdered',
    7: 'statPartialTendered',
    0: 'statPassive'
};
StatusVars.repairQuotation = {
    1: 'statEntered',
    2: 'statConfirmed',
    3: 'statWaitRevision',
    4: 'statProjectCreated'
};
StatusVars.project = {
    0: 'onSupply',
    1: 'needDetails',
    2: 'Unquoted',
    3: 'cancelled',
    4: 'waitingOrder',
    6: 'ordered',
    7: 'delivered'
};
StatusVars.workOrder = {
    0: 'statWaitingConfirm',
    6: 'statToBeDone',
    1: 'statStarted',
    2: 'statFirstClose',
    3: 'statCancelled',
    4: 'statSecondClose',
    5: 'statDeleted',
    7: 'statWaitingContractorOffer',
    8: 'statThirdClose'
};
StatusVars.workOrderClassDesign = {
    0: 'statNotArrived',
    1: 'statArrived',
    2: 'statApproved'
};
StatusVars.workOrderProdDesign = {
    0: 'statNotArrived',
    2: 'statPublished'
};
StatusVars.warehouseIntake = {
    0: 'statPassive',
    1: 'statInStock',
    2: 'statQuantityControlDeny',
    3: 'statQualityControlDeny',
    5: 'statDeleted',
    6: 'statQuantityControl',
    7: 'statQualityControl'
};
StatusVars.warehouseWithdraws = {
    1: 'statEntered2',
    2: 'statWaitingConfirm',
    3: 'statNotApproved',
    4: 'statConfirmed',
    5: 'statDeleted'
};
StatusVars.materialLoans = {
    1: 'statLent',
    2: 'statRequested',
    3: 'statCancelled',
    4: 'statReplaced'
};
StatusVars.classImageFile = {
    0: 'statNotApproved',
    1: 'statApproved'
};
StatusVars.reservationStat = {
    0: 'vacant',
    1: 'full',
    2: 'reserved'
};
StatusVars.qcRemarkStat = {
    0: 'statEntered',
    1: 'statClosed',
    2: 'statInRevision'
};
StatusVars.userStartUpStat = {
    1: 'userRecord',
    2: 'userPassed',
    3: 'userFailed',
    4: 'approvedDoctor',
    5: 'deniedDoctor',
    6: 'waitedDoctor',
    7: 'approvedChancellery',
    8: 'deniedChancellery',
    9: 'givenKKD'
};
StatusVars.equipmentDamageFormStat = {
    1: 'statWaitEstimation',
    2: 'statWaitEstimationApproval'
};
StatusVars.orderInvoiceStatus = {
    0: 'statNotInvoiced',
    1: 'statInvoiced',
    2: 'statPartialInvoiced'
};
StatusVars.accPaymentPlanStatus = {
    0: 'statNotPaid',
    1: 'statPaid',
    2: 'statDrafted'
};
StatusVars.accPaymentDrafts = {
    0: 'statPassive',
    1: 'statActive',
    2: 'statConfirmed',
    3: 'statCancelled',
    4: 'statPaid',
    6: 'statWaitConfirm1',
    7: 'statWaitConfirm2',
    8: 'statWaitConfirm3',
    9: 'statWaitConfirmFinal'
};
StatusVars.vesselStatus = {
    0: 'statVesselEntered',
    1: 'statVesselConvertedToProject',
    2: 'statVesselTenderProcess',
    3: 'repaired'
};
StatusVars.vesselTrackStatus = {
    1: 'onSupply',
    2: 'waitingOrder',
    3: 'cancelled',
    4: 'ordered',
    6: 'delivered',
    7: 'needDetails',
    8: 'Unquoted',
};
StatusVars.projectContractorTimingApprovalsStatus = {
    0: 'statWaitConfirm1',
    2: 'statConfirmed',
    6: 'statWaitConfirm2',
    7: 'statWaitConfirm3',
    8: 'statWaitConfirm4',
    9: 'statWaitConfirmFinal'
};
StatusVars.ditStatus = {
    0: 'statWaitConfirm1',
    1: 'statSaved',
    2: 'onaylandiIsEmriAc',
    3: 'statCancelled',
    4: 'convertToWorkOrder',
    6: 'statWaitConfirm2',
    7: 'statWaitConfirm3',
    8: 'statWaitConfirm4',
    9: 'takenOnHold'
};
StatusVars.contractorTimingStatus = {
    0: 'Onaya Bekliyor',
    1: 'Kaydedilmiş',
    2: 'Tamamlanmiş',
    3: 'Reddedilmiş'
};
StatusVars.projectContractorTimingDetailApprovalStatus = {
    0: 'statSaved',
    1: 'statWaitConfirm',
    2: 'statConfirmed',
    3: 'statCancelled'
};
StatusVars.projectMaterialsPreparationStatus = {
    1: 'preparing',
    2: 'prepared',
    3: 'statCancelled',
    0: 'statWaitConfirm',
    4: 'takenOnHold'
};
StatusVars.repairProjectRequestsStatus = {
    1: 'onaylandiIsEmriAc',
    2: 'workOrderConnected',
    3: 'repeatingEntry',
    0: 'statWaitConfirm',
    4: 'convertToWorkOrder'
};
StatusVars.equipmentSerialsStatus = {
    0: 'kullanilamaz',
    1: 'kullanilabilir',
    2: 'zimmette',
    3: 'inRepair',
    4: 'satilmis'
};
StatusVars.vesselTenderServiceStatus = {
    0: 'statActive',
    2: 'statOrdered',
    3: 'statCancelled',
    9: 'statCancelledOrder',
    4: 'statMakeInvoice',
    6: 'statInvoiced'
};

class ViasAuthService {
    constructor(globals, router) {
        this.globals = globals;
        this.router = router;
    }
    canActivate(next, state) {
        if (this.globals.isLoggedIn()) {
            return true;
        }
        this.router.navigate(['/account/login']);
        return false;
    }
}
ViasAuthService.ɵfac = function ViasAuthService_Factory(t) { return new (t || ViasAuthService)(ɵɵinject(GlobalsService), ɵɵinject(Router)); };
ViasAuthService.ɵprov = ɵɵdefineInjectable({ token: ViasAuthService, factory: ViasAuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasAuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GlobalsService }, { type: Router }]; }, null); })();

class ViasContractorAuthService {
    constructor(globals, router) {
        this.globals = globals;
        this.router = router;
    }
    canActivate(next, state) {
        if (this.globals.isContractorLoggedIn()) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}
ViasContractorAuthService.ɵfac = function ViasContractorAuthService_Factory(t) { return new (t || ViasContractorAuthService)(ɵɵinject(GlobalsService), ɵɵinject(Router)); };
ViasContractorAuthService.ɵprov = ɵɵdefineInjectable({ token: ViasContractorAuthService, factory: ViasContractorAuthService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(ViasContractorAuthService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: GlobalsService }, { type: Router }]; }, null); })();

class TextboxFormItem {
    constructor(init) {
        this.type = FieldTypes.Input;
        Object.assign(this, init);
    }
}
class ButtonFormItem {
    constructor(init) {
        this.type = FieldTypes.Input;
        Object.assign(this, init);
    }
}
class DropdownFormItem {
    constructor(init) {
        this.type = FieldTypes.DropDown;
        Object.assign(this, init);
    }
}
class AutoCompleteFormItem {
    constructor(init) {
        this.type = FieldTypes.AutoComplete;
        this.options = [];
        Object.assign(this, init);
    }
}

/*
 * Public API Surface of viasng-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionAnchorDirective, AccordionDirective, AccordionLinkDirective, AccountModule, AgrFuncs, AlertType, ApprovalProcessesDialogComponent, AuthLayoutComponent, AutoCompleteFormItem, AutocompleteComponent, BreadcrumbComponent, ButtonColors, ButtonComponent, ButtonFormItem, ButtonTypes, ButtonbarComponent, CONTRACTOR_SERVER_URL, CheckboxComponent, ComponentsModule, ConfirmationDialogComponent, ContractorLayoutComponent, DashboardComponent, DashboardModule, DashboardService, DatagridComponent, DatecomboComponent, DatepickerComponent, DefaultEditPageComponent, DefaultListPageComponent, DefaultMasterDetailPageComponent, DefaultReportPageComponent, DropdownComponent, DropdownFormItem, EditDialogComponent, ErrorComponent, ErrorModule, FieldTypes, FileComponent, ForgotComponent, FormComponent, FormItemDirective, GlobalsService, HeaderComponent, ImgComponent, InfoCardComponent, InputComponent, LockscreenComponent, LoginComponent, MAIN_SERVER_URL, MENUITEM_PROVIDER, MainLayoutComponent, MenuService, MenuType, NavComponent, NavFilterPipe, NotFoundComponent, NotificationService, OnlyNumericDirective, PAGEMETA_PROVIDER, PRINT_URL, PageComponent, PageDirection, PageMetaService, PageViewerComponent, PageViewerSafeUrlPipe, ProgressSpinnerComponent, RadioComponent, ResponseFieldDataSourceType, SERVER_URL, SortType, StatusVars, StorageService, TableComponent, TextboxFormItem, ViasAlertComponent, ViasAlertService, ViasAuthService, ViasConnectionService, ViasContractorAuthService, ViasDialogService, ViasReturnActions, ViasUserPrefService, ViasngCoreModule };
//# sourceMappingURL=viasng-core.js.map
